/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/docker-stacker/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(19);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(30)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(14);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(20);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultOverscanIndicesGetter;
var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 *
 * @param direction One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
 * @param cellCount Number of rows or columns in the current axis
 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
 * @param overscanCellsCount Maximum number of cells to over-render in either direction
 * @param startIndex Begin of range of visible cells
 * @param stopIndex End of range of visible cells
 */
function defaultOverscanIndicesGetter(_ref) {
  var direction = _ref.direction,
      cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  var overscanStartIndex = void 0;
  var overscanStopIndex = void 0;

  switch (scrollDirection) {
    case SCROLL_DIRECTION_FORWARD:
      overscanStartIndex = startIndex;
      overscanStopIndex = stopIndex + overscanCellsCount;
      break;
    case SCROLL_DIRECTION_BACKWARD:
      overscanStartIndex = startIndex - overscanCellsCount;
      overscanStopIndex = stopIndex;
      break;
  }

  return {
    overscanStartIndex: Math.max(0, overscanStartIndex),
    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
  };
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultCellRangeRenderer;

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      scrollLeft = _ref.scrollLeft,
      scrollTop = _ref.scrollTop,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var deferredMode = typeof deferredMeasurementCache !== 'undefined';

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMode && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(12);
module.exports = __webpack_require__(18);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(13).enable();
  window.Promise = __webpack_require__(16);
}

// fetch() polyfill for making API calls.
__webpack_require__(17);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(2);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(6);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(6);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(64);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(2),n=__webpack_require__(3),p=__webpack_require__(7),q=__webpack_require__(4),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(3),ca=__webpack_require__(0),m=__webpack_require__(21),p=__webpack_require__(2),v=__webpack_require__(4),da=__webpack_require__(22),ea=__webpack_require__(23),fa=__webpack_require__(24),ha=__webpack_require__(7);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ca?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,I="function"===typeof Symbol&&Symbol.for,fc=I?Symbol.for("react.element"):60103,gc=I?Symbol.for("react.portal"):60106,hc=I?Symbol.for("react.fragment"):60107,ic=I?Symbol.for("react.strict_mode"):60108,jc=I?Symbol.for("react.profiler"):60114,mc=I?Symbol.for("react.provider"):60109,nc=I?Symbol.for("react.context"):60110,oc=I?Symbol.for("react.async_mode"):60111,pc=I?Symbol.for("react.forward_ref"):60112,qc=I?Symbol.for("react.timeout"):
60113,rc="function"===typeof Symbol&&Symbol.iterator;function sc(a){if(null===a||"undefined"===typeof a)return null;a=rc&&a[rc]||a["@@iterator"];return"function"===typeof a?a:null}
function tc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case oc:return"AsyncMode";case nc:return"Context.Consumer";case hc:return"ReactFragment";case gc:return"ReactPortal";case jc:return"Profiler("+a.pendingProps.id+")";case mc:return"Context.Provider";case ic:return"StrictMode";case qc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case pc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=tc(a);var f=null;c&&(f=tc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},yc={};function zc(a){if(yc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return yc[a]=!0;xc[a]=!0;return!1}
function Ac(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Bc(a,b,c,d){if(null===b||"undefined"===typeof b||Ac(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function J(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var K={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null)});var Cc=/[\-:]([a-z])/g;function Dc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Cc,
Dc);K[b]=new J(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});K.tabIndex=new J("tabIndex",1,!1,"tabindex",null);
function Ec(a,b,c,d){var e=K.hasOwnProperty(b)?K[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Bc(b,c,e,d)&&(c=null),d||null===e?zc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Fc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Gc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Hc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Ic(a,b){b=b.checked;null!=b&&Ec(a,"checked",b,!1)}
function Jc(a,b){Ic(a,b);var c=Hc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Kc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Kc(a,b.type,Hc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Lc(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Hc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Mc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Nc(a,b,c){a=H.getPooled(Mc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Oc=null,Pc=null;function Qc(a){Ia(a,!1)}function Rc(a){var b=Oa(a);if(dc(b))return a}
function Sc(a,b){if("change"===a)return b}var Tc=!1;m.canUseDOM&&(Tc=$b("input")&&(!document.documentMode||9<document.documentMode));function Uc(){Oc&&(Oc.detachEvent("onpropertychange",Vc),Pc=Oc=null)}function Vc(a){"value"===a.propertyName&&Rc(Pc)&&(a=Nc(Pc,a,Zb(a)),Wb(Qc,a))}function Wc(a,b,c){"focus"===a?(Uc(),Oc=b,Pc=c,Oc.attachEvent("onpropertychange",Vc)):"blur"===a&&Uc()}function Xc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Rc(Pc)}
function Yc(a,b){if("click"===a)return Rc(b)}function Zc(a,b){if("input"===a||"change"===a)return Rc(b)}
var $c={eventTypes:Mc,_isInputEventSupported:Tc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Sc:Yb(e)?Tc?f=Zc:(f=Xc,g=Wc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Yc);if(f&&(f=f(a,b)))return Nc(f,c,d);g&&g(a,e,b);"blur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Kc(e,"number",e.value)}},ad=H.extend({view:null,
detail:null}),bd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function cd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=bd[a])?!!b[a]:!1}function dd(){return cd}
var ed=ad.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:dd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),fd=ed.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=ed,h=gd.mouseLeave,k=gd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=fd,h=gd.pointerLeave,k=gd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function id(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function jd(a){2!==id(a)?A("188"):void 0}
function kd(a){var b=a.alternate;if(!b)return b=id(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return jd(e),a;if(g===d)return jd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function ld(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function md(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var nd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=ad.extend({relatedTarget:null});
function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=ad.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:dd,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=ed.extend({dataTransfer:null}),vd=ad.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:dd}),wd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=ed.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case fb:case gb:case hb:a=nd;break;case ib:a=wd;break;case "scroll":a=ad;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=fd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Gd=!0;function Id(a){Gd=!!a}function L(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!1)}
function Ld(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!0)}function Jd(a,b){Tb(Kd,a,b)}function Kd(a,b){if(Gd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===id(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}
var Md={get _enabled(){return Gd},setEnabled:Id,isEnabled:function(){return Gd},trapBubbledEvent:L,trapCapturedEvent:Ld,dispatchEvent:Kd},Nd={},Od=0,Pd="_reactListenersID"+(""+Math.random()).slice(2);function Qd(a){Object.prototype.hasOwnProperty.call(a,Pd)||(a[Pd]=Od++,Nd[a[Pd]]={});return Nd[a[Pd]]}function Rd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Sd(a,b){var c=Rd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Rd(c)}}function Td(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ud=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Vd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wd=null,Xd=null,Yd=null,Zd=!1;
function $d(a,b){if(Zd||null==Wd||Wd!==da())return null;var c=Wd;"selectionStart"in c&&Td(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Yd&&ea(Yd,c)?null:(Yd=c,a=H.getPooled(Vd.select,Xd,a,b),a.type="select",a.target=Wd,Ya(a),a)}
var ae={eventTypes:Vd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Qd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Wd=e,Xd=b,Yd=null;break;case "blur":Yd=Xd=Wd=null;break;case "mousedown":Zd=!0;break;case "contextmenu":case "mouseup":return Zd=!1,$d(c,d);case "selectionchange":if(Ud)break;
case "keydown":case "keyup":return $d(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:hd,ChangeEventPlugin:$c,SelectEventPlugin:ae,BeforeInputEventPlugin:Ib});var be=void 0;
be="object"===typeof performance&&"function"===typeof performance.now?function(){return performance.now()}:function(){return Date.now()};var ce=void 0,de=void 0;
if(m.canUseDOM){var ee=[],fe=0,ge={},he=-1,ie=!1,je=!1,ke=0,le=33,me=33,ne={didTimeout:!1,timeRemaining:function(){var a=ke-be();return 0<a?a:0}},oe=function(a,b){if(ge[b])try{a(ne)}finally{delete ge[b]}},pe="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===pe&&(ie=!1,0!==ee.length)){if(0!==ee.length&&(a=be(),!(-1===he||he>a))){he=-1;ne.didTimeout=!0;for(var b=0,c=ee.length;b<c;b++){var d=ee[b],e=d.timeoutTime;-1!==
e&&e<=a?oe(d.scheduledCallback,d.callbackId):-1!==e&&(-1===he||e<he)&&(he=e)}}for(a=be();0<ke-a&&0<ee.length;)a=ee.shift(),ne.didTimeout=!1,oe(a.scheduledCallback,a.callbackId),a=be();0<ee.length&&!je&&(je=!0,requestAnimationFrame(qe))}},!1);var qe=function(a){je=!1;var b=a-ke+me;b<me&&le<me?(8>b&&(b=8),me=b<le?le:b):le=b;ke=a+me;ie||(ie=!0,window.postMessage(pe,"*"))};ce=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=be()+b.timeout);if(-1===he||-1!==c&&c<he)he=c;fe++;b=fe;ee.push({scheduledCallback:a,
callbackId:b,timeoutTime:c});ge[b]=!0;je||(je=!0,requestAnimationFrame(qe));return b};de=function(a){delete ge[a]}}else{var re=0,se={};ce=function(a){var b=re++,c=setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});se[b]=c;return b};de=function(a){var b=se[a];delete se[a];clearTimeout(b)}}function te(a){var b="";ca.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function ue(a,b){a=p({children:void 0},b);if(b=te(b.children))a.children=b;return a}function ve(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function we(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function xe(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ye(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function ze(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ae(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Be={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ce(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function De(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ce(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ee=void 0,Fe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Be.svg||"innerHTML"in a)a.innerHTML=b;else{Ee=Ee||document.createElement("div");Ee.innerHTML="<svg>"+b+"</svg>";for(b=Ee.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ge(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var He={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ie=["Webkit","ms","Moz","O"];Object.keys(He).forEach(function(a){Ie.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);He[b]=He[a]})});
function Je(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||He.hasOwnProperty(e)&&He[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ke=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Le(a,b,c){b&&(Ke[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Me(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Ne=v.thatReturns("");
function Oe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Qd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ld("scroll",a);break;case "focus":case "blur":Ld("focus",a);Ld("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Ld(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&L(e,a)}c[e]=!0}}}
function Pe(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Be.html&&(d=Ce(a));d===Be.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Qe(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Re(a,b,c,d){var e=Me(b,c);switch(b){case "iframe":case "object":L("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)L(jb[f],a);f=c;break;case "source":L("error",a);f=c;break;case "img":case "image":case "link":L("error",a);L("load",a);f=c;break;case "form":L("reset",a);L("submit",a);f=c;break;case "details":L("toggle",a);f=c;break;case "input":Gc(a,c);f=Fc(a,c);L("invalid",a);Oe(d,"onChange");break;case "option":f=ue(a,c);break;case "select":we(a,c);f=p({},c,{value:void 0});
L("invalid",a);Oe(d,"onChange");break;case "textarea":ye(a,c);f=xe(a,c);L("invalid",a);Oe(d,"onChange");break;default:f=c}Le(b,f,Ne);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Je(a,k,Ne):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fe(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ge(a,k):"number"===typeof k&&Ge(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Oe(d,
h):null!=k&&Ec(a,h,k,e))}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ve(a,!!c.multiple,b,!1):null!=c.defaultValue&&ve(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Se(a,b,c,d,e){var f=null;switch(b){case "input":c=Fc(a,c);d=Fc(a,d);f=[];break;case "option":c=ue(a,c);d=ue(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=xe(a,c);d=xe(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Le(b,d,Ne);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Oe(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Te(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Ic(a,e);Me(c,d);d=Me(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Je(a,h,Ne):"dangerouslySetInnerHTML"===g?Fe(a,h):"children"===g?Ge(a,h):Ec(a,g,h,d)}switch(c){case "input":Jc(a,e);break;case "textarea":ze(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ve(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ve(a,!!e.multiple,e.defaultValue,!0):ve(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ue(a,b,c,d,e){switch(b){case "iframe":case "object":L("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)L(jb[d],a);break;case "source":L("error",a);break;case "img":case "image":case "link":L("error",a);L("load",a);break;case "form":L("reset",a);L("submit",a);break;case "details":L("toggle",a);break;case "input":Gc(a,c);L("invalid",a);Oe(e,"onChange");break;case "select":we(a,c);L("invalid",a);Oe(e,"onChange");break;case "textarea":ye(a,c),L("invalid",a),Oe(e,"onChange")}Le(b,
c,Ne);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Oe(e,f)}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ve(a,b){return a.nodeValue!==b}
var We={createElement:Pe,createTextNode:Qe,setInitialProperties:Re,diffProperties:Se,updateProperties:Te,diffHydratedProperties:Ue,diffHydratedText:Ve,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Jc(d,e)}}}break;case "textarea":ze(a,c);break;case "select":b=c.value,null!=b&&ve(a,!!c.multiple,b,!1)}}},Xe=null,Ye=null;function Ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function $e(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var af=be,bf=ce,cf=de;function df(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function ef(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var ff=[],gf=-1;function hf(a){return{current:a}}
function M(a){0>gf||(a.current=ff[gf],ff[gf]=null,gf--)}function N(a,b){gf++;ff[gf]=a.current;a.current=b}var jf=hf(ha),O=hf(!1),kf=ha;function lf(a){return mf(a)?kf:jf.current}
function nf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mf(a){return 2===a.tag&&null!=a.type.childContextTypes}function of(a){mf(a)&&(M(O,a),M(jf,a))}function pf(a){M(O,a);M(jf,a)}
function qf(a,b,c){jf.current!==ha?A("168"):void 0;N(jf,b,a);N(O,c,a)}function rf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",tc(a)||"Unknown",e);return p({},b,c)}function sf(a){if(!mf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;kf=jf.current;N(jf,b,a);N(O,O.current,a);return!0}
function tf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=rf(a,kf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(jf,a);N(jf,d,a)}else M(O,a);N(O,b,a)}
function uf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function vf(a,b,c){var d=a.alternate;null===d?(d=new uf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function wf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case hc:return xf(a.children,b,c,e);case oc:f=11;b|=3;break;case ic:f=11;b|=2;break;case jc:return d=new uf(15,a,e,b|4),d.type=jc,d.expirationTime=c,d;case qc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case mc:f=13;break a;case nc:f=12;break a;case pc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new uf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function xf(a,b,c,d){a=new uf(10,a,d,b);a.expirationTime=c;return a}function yf(a,b,c){a=new uf(6,a,null,b);a.expirationTime=c;return a}function zf(a,b,c){b=new uf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Af(a,b,c){b=new uf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Bf=null,Cf=null;function Df(a){return function(b){try{return a(b)}catch(c){}}}
function Ef(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Bf=Df(function(a){return b.onCommitFiberRoot(c,a)});Cf=Df(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ff(a){"function"===typeof Bf&&Bf(a)}function Gf(a){"function"===typeof Cf&&Cf(a)}var Hf=!1;
function If(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Jf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Kf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Lf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Mf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=If(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=If(a.memoizedState),f=d.updateQueue=If(d.memoizedState)):e=a.updateQueue=Jf(f):null===f&&(f=d.updateQueue=Jf(e));null===f||e===f?Lf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Lf(e,b,c),Lf(f,b,c)):(Lf(e,b,c),f.lastUpdate=b)}
function Nf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=If(a.memoizedState):Of(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Of(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Jf(b));return b}
function Pf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Hf=!0}return d}
function Qf(a,b,c,d,e){Hf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Of(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Rf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Sf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Rf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Rf(b,c)),a=a.nextEffect}
function Tf(a,b){return{value:a,source:b,stack:vc(b)}}var Uf=hf(null),Vf=hf(null),Wf=hf(0);function Xf(a){var b=a.type._context;N(Wf,b._changedBits,a);N(Vf,b._currentValue,a);N(Uf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function Yf(a){var b=Wf.current,c=Vf.current;M(Uf,a);M(Vf,a);M(Wf,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var Zf={},$f=hf(Zf),ag=hf(Zf),bg=hf(Zf);function cg(a){a===Zf?A("174"):void 0;return a}
function dg(a,b){N(bg,b,a);N(ag,a,a);N($f,Zf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:De(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=De(b,c)}M($f,a);N($f,b,a)}function eg(a){M($f,a);M(ag,a);M(bg,a)}function fg(a){ag.current===a&&(M($f,a),M(ag,a))}function hg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var lg={isMounted:function(a){return(a=a._reactInternalFiber)?2===id(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ig();c=jg(c,a);var d=Kf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Mf(a,d,c);kg(a,c)}};function mg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&lg.enqueueReplaceState(b,b.state,null)}
function og(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=nf(a,f);f=a.updateQueue;null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(hg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&lg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var pg=Array.isArray;
function qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function rg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=vf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=yf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=qg(a,b,c),d.return=a,d;d=wf(c,a.mode,d);d.ref=qg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
zf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=xf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=yf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case fc:return c=wf(b,a.mode,c),c.ref=qg(a,null,b),c.return=a,c;case gc:return b=zf(b,a.mode,c),b.return=a,b}if(pg(b)||sc(b))return b=xf(b,a.mode,c,null),b.return=
a,b;rg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fc:return c.key===e?c.type===hc?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case gc:return c.key===e?n(a,b,c,d):null}if(pg(c)||sc(c))return null!==e?null:r(a,b,c,d,null);rg(a,c)}return null}function kc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case fc:return a=a.get(null===d.key?c:d.key)||null,d.type===hc?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case gc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(pg(d)||sc(d))return a=a.get(c)||null,r(b,a,d,e,null);rg(b,d)}return null}function Hd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=kc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var t=sc(h);"function"!==typeof t?A("150"):void 0;h=t.call(h);null==h?A("151"):void 0;for(var u=t=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===u?t=r:u.sibling=r;u=r;n=y}if(l.done)return c(e,n),t;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===u?t=l:u.sibling=l,u=l);return t}for(n=d(e,n);!l.done;x++,l=h.next())l=kc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
u?t=l:u.sibling=l,u=l);a&&n.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===hc&&null===f.key&&(f=f.props.children);var k="object"===typeof f&&null!==f;if(k)switch(f.$$typeof){case fc:a:{var n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===hc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===hc?f.props.children:f.props,h);d.ref=qg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===hc?(d=xf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=wf(f,a.mode,h),h.ref=qg(a,d,f),h.return=a,a=h)}return g(a);case gc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=yf(f,a.mode,h),d.return=a,a=d),g(a);if(pg(f))return Hd(a,d,f,h);if(sc(f))return E(a,d,f,h);k&&rg(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var tg=sg(!0),ug=sg(!1),vg=null,wg=null,xg=!1;function yg(a,b){var c=new uf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function zg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Ag(a){if(xg){var b=wg;if(b){var c=b;if(!zg(a,b)){b=df(c);if(!b||!zg(a,b)){a.effectTag|=2;xg=!1;vg=a;return}yg(vg,c)}vg=a;wg=ef(b)}else a.effectTag|=2,xg=!1,vg=a}}
function Bg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;vg=a}function Cg(a){if(a!==vg)return!1;if(!xg)return Bg(a),xg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!$e(b,a.memoizedProps))for(b=wg;b;)yg(a,b),b=df(b);Bg(a);wg=vg?df(a.stateNode):null;return!0}function Dg(){wg=vg=null;xg=!1}function Q(a,b,c){Eg(a,b,c,b.expirationTime)}function Eg(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Gg(a,b,c,d,e){Fg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Eg(a,b,null,e),b.child=null);Eg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tf(b,!0);return b.child}
function Hg(a){var b=a.stateNode;b.pendingContext?qf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qf(a,b.context,!1);dg(a,b.containerInfo)}
function Ig(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Jg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,Xf(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b)}else Ig(b,d,h,c)}b.stateNode=h;Xf(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=vf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=vf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Kg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Hg(b);break;case 2:sf(b);break;case 4:dg(b,b.stateNode.containerInfo);break;case 13:Xf(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=lf(b);f=nf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&hg(b,f,e),e=sf(b),d.updater=lg,b.stateNode=d,d._reactInternalFiber=b,og(b,c),a=Gg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=lf(b),d=nf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=sf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=lf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?nf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=lg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);og(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=lf(b);g=nf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&ng(b,d,f,g);Hf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Qf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Hf?("function"===typeof r&&(hg(b,r,f),n=b.memoizedState),(k=Hf||mg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=lf(b),g=nf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&ng(b,d,k,g),Hf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Qf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Hf?("function"===typeof r&&(hg(b,r,k),w=b.memoizedState),(r=Hf||mg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Gg(a,b,d,e,c);case 3:Hg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Qf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Dg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)wg=ef(b.stateNode.containerInfo),vg=b,d=xg=!0;d?(b.effectTag|=2,b.child=ug(b,null,e,c)):(Dg(),Q(a,b,e));a=b.child}else Dg(),a=R(a,b);return a;case 5:a:{cg(bg.current);e=cg($f.current);d=De(e,
b.type);e!==d&&(N(ag,b,b),N($f,d,b));null===a&&Ag(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;$e(e,d)?k=null:f&&$e(e,f)&&(b.effectTag|=16);Fg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Ag(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return dg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=tg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Jg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ig(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Lg(a){a.effectTag|=4}var Pg=void 0,Qg=void 0,Rg=void 0;Pg=function(){};Qg=function(a,b,c){(b.updateQueue=c)&&Lg(b)};Rg=function(a,b,c,d){c!==d&&Lg(b)};
function Sg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return of(b),null;case 3:eg(b);pf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Cg(b),b.effectTag&=-3;Pg(b);return null;case 5:fg(b);d=cg(bg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=cg($f.current);g=Se(g,e,f,c,d);Qg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=cg($f.current);if(Cg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ue(c,e,f,a,d),b.updateQueue=d,null!==d&&Lg(b);else{a=Pe(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Re(a,e,c,d);Ze(e,c)&&Lg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Rg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=cg(bg.current);cg($f.current);Cg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ve(d,c)&&Lg(b)):(d=Qe(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return eg(b),Pg(b),null;case 13:return Yf(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Tg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&tc(c);b=b.value;null!==a&&2===a.tag&&tc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Ug(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Vg(a,c)}else b.current=null}
function Wg(a){"function"===typeof Gf&&Gf(a);switch(a.tag){case 2:Ug(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Vg(a,c)}break;case 5:Ug(a);break;case 4:Xg(a)}}function Yg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Zg(a){a:{for(var b=a.return;null!==b;){if(Yg(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ge(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Yg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Wg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:Wg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function $g(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Te(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function ah(a,b,c){c=Kf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){bh(d);Tg(a,b)};return c}
function ch(a,b,c){c=Kf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===dh?dh=new Set([this]):dh.add(this);var c=b.value,d=b.stack;Tg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function eh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Tf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=ah(a,d,f);Nf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===dh||!dh.has(c))){a.effectTag|=1024;d=ch(a,b,f);Nf(a,d,f);return}}a=a.return}while(null!==a)}
function fh(a){switch(a.tag){case 2:of(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return eg(a),pf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return fg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return eg(a),null;case 13:return Yf(a),null;default:return null}}var gh=af(),hh=2,ih=gh,jh=0,kh=0,lh=!1,S=null,mh=null,T=0,nh=-1,oh=!1,U=null,ph=!1,qh=!1,dh=null;
function rh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:of(b);break;case 3:eg(b);pf(b);break;case 5:fg(b);break;case 4:eg(b);break;case 13:Yf(b)}a=a.return}mh=null;T=0;nh=-1;oh=!1;S=null;qh=!1}
function sh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Sg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{qh=!0;break}}else{a=fh(a,oh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function th(a){var b=Kg(a.alternate,a,T);null===b&&(b=sh(a));ec.current=null;return b}
function uh(a,b,c){lh?A("243"):void 0;lh=!0;if(b!==T||a!==mh||null===S)rh(),mh=a,T=b,nh=-1,S=vf(mh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;oh=!c||T<=hh;do{try{if(c)for(;null!==S&&!vh();)S=th(S);else for(;null!==S;)S=th(S)}catch(f){if(null===S)d=!0,bh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;bh(f);break}eh(a,e,c,f,oh,T,ih);S=sh(c)}}break}while(1);lh=!1;if(d)return null;if(null===S){if(qh)return a.pendingCommitExpirationTime=b,a.current.alternate;oh?A("262"):
void 0;0<=nh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&wh(a,b)},nh);xh(a.current.expirationTime)}return null}
function Vg(a,b){var c;a:{lh&&!ph?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===dh||!dh.has(d))){a=Tf(b,a);a=ch(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}break;case 3:a=Tf(b,a);a=ah(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Tf(b,a),c=ah(a,c,1),Mf(a,c,1),kg(a,1));c=void 0}return c}
function yh(){var a=2+25*(((ig()-2+500)/25|0)+1);a<=jh&&(a=jh+1);return jh=a}function jg(a,b){a=0!==kh?kh:lh?ph?1:T:b.mode&1?zh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;zh&&(0===Ah||a>Ah)&&(Ah=a);return a}
function kg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!lh&&0!==T&&b<T&&rh();var d=c.current.expirationTime;lh&&!ph&&mh===c||wh(c,d);Bh>Ch&&A("185")}else break;a=a.return}}function ig(){ih=af()-gh;return hh=(ih/10|0)+2}
function Dh(a){var b=kh;kh=2+25*(((ig()-2+500)/25|0)+1);try{return a()}finally{kh=b}}function Eh(a,b,c,d,e){var f=kh;kh=1;try{return a(b,c,d,e)}finally{kh=f}}var Fh=null,V=null,Gh=0,Hh=-1,W=!1,X=null,Y=0,Ah=0,Ih=!1,Jh=!1,Kh=null,Lh=null,Z=!1,Mh=!1,zh=!1,Nh=null,Ch=1E3,Bh=0,Oh=1;function Ph(a){if(0!==Gh){if(a>Gh)return;cf(Hh)}var b=af()-gh;Gh=a;Hh=bf(Qh,{timeout:10*(a-2)-b})}
function wh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Fh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Fh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Mh&&(X=a,Y=1,Rh(a,1,!1)):1===b?Sh():Ph(b))}
function Th(){var a=0,b=null;if(null!==V)for(var c=V,d=Fh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Fh=V=d.nextScheduledRoot=null;break}else if(d===Fh)Fh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Fh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Bh++:Bh=0;X=b;Y=a}function Qh(a){Uh(0,!0,a)}function Sh(){Uh(1,!1,null)}function Uh(a,b,c){Lh=c;Th();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Ih||ig()>=Y);)ig(),Rh(X,Y,!Ih),Th();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Rh(X,Y,!1),Th();null!==Lh&&(Gh=0,Hh=-1);0!==Y&&Ph(Y);Lh=null;Ih=!1;Vh()}function Wh(a,b){W?A("253"):void 0;X=a;Y=b;Rh(a,b,!1);Sh();Vh()}
function Vh(){Bh=0;if(null!==Nh){var a=Nh;Nh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Jh||(Jh=!0,Kh=d)}}}if(Jh)throw a=Kh,Kh=null,Jh=!1,a;}function Rh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!0),null!==c&&(vh()?a.finishedWork=c:Xh(a,c,b)))):(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!1),null!==c&&Xh(a,c,b)));W=!1}
function Xh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Nh?Nh=[d]:Nh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;ph=lh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ig();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;Xe=Gd;var f=da();if(Td(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,kc=0,Hd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++kc===k&&(w=r);t===n&&++Hd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;Ye={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var hi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=hi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Vg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ge(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:Zg(U);U.effectTag&=-3;break;case 6:Zg(U);U.effectTag&=-3;$g(U.alternate,
U);break;case 4:$g(U.alternate,U);break;case 8:D=U,Xg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Vg(U,y),null!==U&&(U=U.nextEffect))}l=Ye;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){Td(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Sd(q,l),D=Sd(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}Ye=null;Id(Xe);Xe=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var gg=U.effectTag;if(gg&36){var lc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ba=l.stateNode;if(l.effectTag&4)if(null===lc)ba.props=l.memoizedProps,ba.state=l.memoizedState,ba.componentDidMount();else{var ri=lc.memoizedProps,si=lc.memoizedState;ba.props=l.memoizedProps;ba.state=l.memoizedState;
ba.componentDidUpdate(ri,si,ba.__reactInternalSnapshotBeforeUpdate)}var Mg=l.updateQueue;null!==Mg&&(ba.props=l.memoizedProps,ba.state=l.memoizedState,Sf(l,Mg,ba,u));break;case 3:var Ng=l.updateQueue;if(null!==Ng){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Sf(l,Ng,y,u)}break;case 5:var ti=l.stateNode;null===lc&&l.effectTag&4&&Ze(l.type,l.memoizedProps)&&ti.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;default:A("163")}}if(gg&
128){l=void 0;var uc=U.ref;if(null!==uc){var Og=U.stateNode;switch(U.tag){case 5:l=Og;break;default:l=Og}"function"===typeof uc?uc(l):uc.current=l}}var ui=U.nextEffect;U.nextEffect=null;U=ui}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Vg(U,q),null!==U&&(U=U.nextEffect))}lh=ph=!1;"function"===typeof Ff&&Ff(b.stateNode);b=c.current.expirationTime;0===b&&(dh=null);a.remainingExpirationTime=b}function vh(){return null===Lh||Lh.timeRemaining()>Oh?!1:Ih=!0}
function bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Jh||(Jh=!0,Kh=a)}function xh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function Yh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Sh()}}function Zh(a,b){if(Z&&!Mh){Mh=!0;try{return a(b)}finally{Mh=!1}}return a(b)}function $h(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Eh(a,b)}finally{Z=c,Sh()}}function ai(a){var b=Z;Z=!0;try{Eh(a)}finally{(Z=b)||W||Uh(1,!1,null)}}
function bi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===id(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(mf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=mf(c)?rf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Kf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Mf(f,e,d);kg(f,d);return d}
function ci(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=ld(b);return null===a?null:a.stateNode}function di(a,b,c,d){var e=b.current,f=ig();e=jg(f,e);return bi(a,b,c,e,d)}function ei(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function fi(a){var b=a.findFiberByHostInstance;return Ef(p({},a,{findHostInstanceByFiber:function(a){a=ld(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var gi={updateContainerAtExpirationTime:bi,createContainer:function(a,b,c){return Af(a,b,c)},updateContainer:di,flushRoot:Wh,requestWork:wh,computeUniqueAsyncExpiration:yh,batchedUpdates:Yh,unbatchedUpdates:Zh,deferredUpdates:Dh,syncUpdates:Eh,interactiveUpdates:function(a,b,c){if(zh)return a(b,c);Z||W||0===Ah||(Uh(Ah,!1,null),Ah=0);var d=zh,e=Z;Z=zh=!0;try{return a(b,c)}finally{zh=d,(Z=e)||W||Sh()}},flushInteractiveUpdates:function(){W||0===Ah||(Uh(Ah,!1,null),Ah=0)},flushControlled:ai,flushSync:$h,
getPublicRootInstance:ei,findHostInstance:ci,findHostInstanceWithNoPortals:function(a){a=md(a);return null===a?null:a.stateNode},injectIntoDevTools:fi};function ii(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:gc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(We);
function ji(a){this._expirationTime=yh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ji.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new ki;bi(a,b,null,c,d._onCommit);return d};ji.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ji.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Wh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ji.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function ki(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}ki.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ki.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function li(a,b,c){this._internalRoot=Af(a,b,c)}li.prototype.render=function(a,b){var c=this._internalRoot,d=new ki;b=void 0===b?null:b;null!==b&&d.then(b);di(a,c,null,d._onCommit);return d};
li.prototype.unmount=function(a){var b=this._internalRoot,c=new ki;a=void 0===a?null:a;null!==a&&c.then(a);di(null,b,null,c._onCommit);return c};li.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new ki;c=void 0===c?null:c;null!==c&&e.then(c);di(b,d,a,e._onCommit);return e};
li.prototype.createBatch=function(){var a=new ji(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function mi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=gi.batchedUpdates;Tb=gi.interactiveUpdates;Ub=gi.flushInteractiveUpdates;
function ni(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new li(a,!1,b)}
function oi(a,b,c,d,e){mi(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ei(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ni(c,d);if("function"===typeof e){var h=e;e=function(){var a=ei(f._internalRoot);h.call(a)}}Zh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ei(f._internalRoot)}
function pi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;mi(b)?void 0:A("200");return ii(a,b,null,c)}
var qi={createPortal:pi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ci(a)},hydrate:function(a,b,c){return oi(null,a,b,!0,c)},render:function(a,b,c){return oi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return oi(a,b,c,!1,d)},unmountComponentAtNode:function(a){mi(a)?void 0:A("40");return a._reactRootContainer?(Zh(function(){oi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return pi.apply(void 0,
arguments)},unstable_batchedUpdates:Yh,unstable_deferredUpdates:Dh,flushSync:$h,unstable_flushControlled:ai,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Md},unstable_createRoot:function(a,b){return new li(a,!0,null!=b&&!0===b.hydrate)}};fi({findFiberByHostInstance:Na,bundleType:0,version:"16.4.0",rendererPackageName:"react-dom"});
var vi={default:qi},wi=vi&&qi||vi;module.exports=wi.default?wi.default:wi;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(25);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(26);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Card__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PackageSupport__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PDFSupport__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SparkSupport__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TextEditors__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datasets_julia__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datasets_julia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__datasets_julia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datasets_python__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datasets_python___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__datasets_python__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__datasets_r__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__datasets_r___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__datasets_r__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__datasets_scala__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__datasets_scala___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__datasets_scala__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_css__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={};_this.handleGenerate=_this.handleGenerate.bind(_this);_this.handleInputChange=_this.handleInputChange.bind(_this);return _this;}_createClass(App,[{key:'handleGenerate',value:function handleGenerate(event){console.log('TODO');}},{key:'handleInputChange',value:function handleInputChange(event){var target=event.target;var name=target.name;var value=target.type==='checkbox'?target.checked:target.value;console.log('setting state:',name,value);this.setState(_defineProperty({},name,value));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'app',className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-header sticky-top container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar navbar-expand-lg navbar-light justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'navbar-brand',href:'#app'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'App-logo',src:'https://cdn.jupyter.org/notebook/5.2.0/base/images/logo.png',alt:'Jupyter logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm btn-outline-jupyter',onClick:this.handleGenerate},'Generate'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-intro container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'jumbotron'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-10 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Jupyter Docker Stacker'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Build your own Jupyter Dockerfile (EXPERIMENTAL)')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-controls container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-deck'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Card__["a" /* default */],{header:'Libraries',title:'Python Environment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Install Python packages from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://conda-forge.org/feedstocks',rel:'noopener noreferrer',target:'_blank'},'https://conda-forge.org/feedstocks'),'. The IPython kernel is always installed for you.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_PackageSupport__["a" /* default */],{name:'pythonPackages',selected:this.state.pythonPackages,options:__WEBPACK_IMPORTED_MODULE_7__datasets_python___default.a.packages,onChange:this.handleInputChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Card__["a" /* default */],{header:'Libraries',title:'R Environment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Install R packages from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://conda-forge.org/feedstocks',rel:'noopener noreferrer',target:'_blank'},'https://conda-forge.org/feedstocks'),'. The IRKernel package will be installed for you if you choose at least one other package.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_PackageSupport__["a" /* default */],{name:'rPackages',selected:this.state.rPackages,options:__WEBPACK_IMPORTED_MODULE_8__datasets_r___default.a.packages,onChange:this.handleInputChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-deck'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Card__["a" /* default */],{header:'Libraries',title:'Julia Environment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Install Julia packages from ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://pkg.julialang.org/',rel:'noopener noreferrer',target:'_blank'},'https://pkg.julialang.org/'),'. The IJulia package will be installed for you if you choose at least one other package.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_PackageSupport__["a" /* default */],{name:'juliaPackages',selected:this.state.juliaPackages,options:__WEBPACK_IMPORTED_MODULE_6__datasets_julia___default.a.packages,onChange:this.handleInputChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Card__["a" /* default */],{header:'Libraries',title:'Scala Environment'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Install Scala kernels. Apache Spark will be installed for you if you choose at least one kernel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_PackageSupport__["a" /* default */],{name:'scalaPackages',selected:this.state.scalaPackages,options:__WEBPACK_IMPORTED_MODULE_9__datasets_scala___default.a.packages,onChange:this.handleInputChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-deck'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Card__["a" /* default */],{header:'Libraries',title:'Apache Spark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SparkSupport__["a" /* default */],{enableSpark:this.state.enableSpark,onChange:this.handleInputChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Card__["a" /* default */],{header:'Jupyter Notebook',title:'LaTeX & PDF Support'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_PDFSupport__["a" /* default */],{enablePdf:this.state.enablePdf,onChange:this.handleInputChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Card__["a" /* default */],{header:'Terminal',title:'Text Editors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TextEditors__["a" /* default */],{enableEmacs:this.state.enableEmacs,enableJed:this.state.enableJed,enableVim:this.state.enableVim,onChange:this.handleInputChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-block btn-outline-jupyter',onClick:this.handleGenerate},'Generate'))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Card=function Card(_ref){var header=_ref.header,title=_ref.title,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header'},header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'card-title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-text'},children)));};Card.propTypes={header:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(4);
var invariant = __webpack_require__(3);
var ReactPropTypesSecret = __webpack_require__(31);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_virtualized_select__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_virtualized_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_virtualized_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_virtualized_styles_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_virtualized_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_virtualized_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_virtualized_select_styles_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_virtualized_select_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_virtualized_select_styles_css__);
var PackageSupport=function PackageSupport(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_virtualized_select___default.a,{name:props.name,placeholder:'Select packages',multi:true,searchable:true,clearable:true,options:props.options,onChange:function onChange(item){props.onChange({target:{name:props.name,value:item}});},value:props.selected}));};PackageSupport.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (PackageSupport);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(34);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(35);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(36);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _AutoSizer = __webpack_require__(38);

var _AutoSizer2 = _interopRequireDefault(_AutoSizer);

var _List = __webpack_require__(41);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Import directly to avoid Webpack bundling the parts of react-virtualized that we are not using


var VirtualizedSelect = function (_Component) {
  _inherits(VirtualizedSelect, _Component);

  function VirtualizedSelect(props, context) {
    _classCallCheck(this, VirtualizedSelect);

    var _this = _possibleConstructorReturn(this, (VirtualizedSelect.__proto__ || Object.getPrototypeOf(VirtualizedSelect)).call(this, props, context));

    _this._renderMenu = _this._renderMenu.bind(_this);
    _this._optionRenderer = _this._optionRenderer.bind(_this);
    _this._setListRef = _this._setListRef.bind(_this);
    _this._setSelectRef = _this._setSelectRef.bind(_this);
    return _this;
  }

  /** See List#recomputeRowHeights */


  _createClass(VirtualizedSelect, [{
    key: 'recomputeOptionHeights',
    value: function recomputeOptionHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this._listRef) {
        this._listRef.recomputeRowHeights(index);
      }
    }

    /** See Select#focus (in react-select) */

  }, {
    key: 'focus',
    value: function focus() {
      if (this._selectRef) {
        return this._selectRef.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SelectComponent = this._getSelectComponent();

      return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
        ref: this._setSelectRef,
        menuRenderer: this._renderMenu,
        menuStyle: { overflow: 'hidden' }
      }));
    }

    // See https://github.com/JedWatson/react-select/#effeciently-rendering-large-lists-with-windowing

  }, {
    key: '_renderMenu',
    value: function _renderMenu(_ref) {
      var _this2 = this;

      var focusedOption = _ref.focusedOption,
          focusOption = _ref.focusOption,
          labelKey = _ref.labelKey,
          onSelect = _ref.onSelect,
          options = _ref.options,
          selectValue = _ref.selectValue,
          valueArray = _ref.valueArray,
          valueKey = _ref.valueKey;
      var _props = this.props,
          listProps = _props.listProps,
          optionRenderer = _props.optionRenderer;

      var focusedOptionIndex = options.indexOf(focusedOption);
      var height = this._calculateListHeight({ options: options });
      var innerRowRenderer = optionRenderer || this._optionRenderer;

      // react-select 1.0.0-rc2 passes duplicate `onSelect` and `selectValue` props to `menuRenderer`
      // The `Creatable` HOC only overrides `onSelect` which breaks an edge-case
      // In order to support creating items via clicking on the placeholder option,
      // We need to ensure that the specified `onSelect` handle is the one we use.
      // See issue #33

      function wrappedRowRenderer(_ref2) {
        var index = _ref2.index,
            key = _ref2.key,
            style = _ref2.style;

        var option = options[index];

        return innerRowRenderer({
          focusedOption: focusedOption,
          focusedOptionIndex: focusedOptionIndex,
          focusOption: focusOption,
          key: key,
          labelKey: labelKey,
          onSelect: onSelect,
          option: option,
          optionIndex: index,
          options: options,
          selectValue: onSelect,
          style: style,
          valueArray: valueArray,
          valueKey: valueKey
        });
      }

      return _react2.default.createElement(
        _AutoSizer2.default,
        { disableHeight: true },
        function (_ref3) {
          var width = _ref3.width;
          return _react2.default.createElement(_List2.default, _extends({
            className: 'VirtualSelectGrid',
            height: height,
            ref: _this2._setListRef,
            rowCount: options.length,
            rowHeight: function rowHeight(_ref4) {
              var index = _ref4.index;
              return _this2._getOptionHeight({
                option: options[index]
              });
            },
            rowRenderer: wrappedRowRenderer,
            scrollToIndex: focusedOptionIndex,
            width: width
          }, listProps));
        }
      );
    }
  }, {
    key: '_calculateListHeight',
    value: function _calculateListHeight(_ref5) {
      var options = _ref5.options;
      var maxHeight = this.props.maxHeight;


      var height = 0;

      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
        var option = options[optionIndex];

        height += this._getOptionHeight({ option: option });

        if (height > maxHeight) {
          return maxHeight;
        }
      }

      return height;
    }
  }, {
    key: '_getOptionHeight',
    value: function _getOptionHeight(_ref6) {
      var option = _ref6.option;
      var optionHeight = this.props.optionHeight;


      return optionHeight instanceof Function ? optionHeight({ option: option }) : optionHeight;
    }
  }, {
    key: '_getSelectComponent',
    value: function _getSelectComponent() {
      var _props2 = this.props,
          async = _props2.async,
          selectComponent = _props2.selectComponent;


      if (selectComponent) {
        return selectComponent;
      } else if (async) {
        return _reactSelect2.default.Async;
      } else {
        return _reactSelect2.default;
      }
    }
  }, {
    key: '_optionRenderer',
    value: function _optionRenderer(_ref7) {
      var focusedOption = _ref7.focusedOption,
          focusOption = _ref7.focusOption,
          key = _ref7.key,
          labelKey = _ref7.labelKey,
          option = _ref7.option,
          selectValue = _ref7.selectValue,
          style = _ref7.style,
          valueArray = _ref7.valueArray;

      var className = ['VirtualizedSelectOption'];

      if (option === focusedOption) {
        className.push('VirtualizedSelectFocusedOption');
      }

      if (option.disabled) {
        className.push('VirtualizedSelectDisabledOption');
      }

      if (valueArray && valueArray.indexOf(option) >= 0) {
        className.push('VirtualizedSelectSelectedOption');
      }

      if (option.className) {
        className.push(option.className);
      }

      var events = option.disabled ? {} : {
        onClick: function onClick() {
          return selectValue(option);
        },
        onMouseEnter: function onMouseEnter() {
          return focusOption(option);
        }
      };

      return _react2.default.createElement(
        'div',
        _extends({
          className: className.join(' '),
          key: key,
          style: style,
          title: option.title
        }, events),
        option[labelKey]
      );
    }
  }, {
    key: '_setListRef',
    value: function _setListRef(ref) {
      this._listRef = ref;
    }
  }, {
    key: '_setSelectRef',
    value: function _setSelectRef(ref) {
      this._selectRef = ref;
    }
  }]);

  return VirtualizedSelect;
}(_react.Component);

VirtualizedSelect.propTypes = {
  async: _propTypes2.default.bool,
  listProps: _propTypes2.default.object,
  maxHeight: _propTypes2.default.number,
  optionHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  optionRenderer: _propTypes2.default.func,
  selectComponent: _propTypes2.default.func
};
VirtualizedSelect.defaultProps = {
  async: false,
  maxHeight: 200,
  optionHeight: 35
};
exports.default = VirtualizedSelect;

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				className: className,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoSizer = exports.default = undefined;

var _AutoSizer2 = __webpack_require__(39);

var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AutoSizer3.default;
exports.AutoSizer = _AutoSizer3.default;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _detectElementResize = __webpack_require__(40);

var _detectElementResize2 = _interopRequireDefault(_detectElementResize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Decorator component that automatically adjusts the width and height of a single child.
 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
 * All other properties will be passed through to the child component.
 */
var AutoSizer = function (_PureComponent) {
  _inherits(AutoSizer, _PureComponent);

  function AutoSizer(props) {
    _classCallCheck(this, AutoSizer);

    var _this = _possibleConstructorReturn(this, (AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call(this, props));

    _this.state = {
      height: 0,
      width: 0
    };

    _this._onResize = _this._onResize.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  _createClass(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      // Delay access of parentNode until mount.
      // This handles edge-cases where the component has already been unmounted before its ref has been set,
      // As well as libraries like react-lite which have a slightly different lifecycle.

      this._parentNode = this._autoSizer.parentNode;

      // Defer requiring resize handler in order to support server-side rendering.
      // See issue #41
      this._detectElementResize = (0, _detectElementResize2.default)(nonce);
      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

      this._onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };

      if (!disableHeight) {
        outerStyle.height = 0;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return _react2.default.createElement(
        'div',
        {
          ref: this._setRef,
          style: outerStyle
        },
        children({ height: height, width: width })
      );
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      var _props2 = this.props,
          disableHeight = _props2.disableHeight,
          disableWidth = _props2.disableWidth,
          onResize = _props2.onResize;

      // Guard against AutoSizer component being removed from the DOM immediately after being added.
      // This can result in invalid style values which can result in NaN values if we don't handle them.
      // See issue #150 for more context.

      var height = this._parentNode.offsetHeight || 0;
      var width = this._parentNode.offsetWidth || 0;

      var style = window.getComputedStyle(this._parentNode) || {};
      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
      var paddingRight = parseInt(style.paddingRight, 10) || 0;
      var paddingTop = parseInt(style.paddingTop, 10) || 0;
      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;

      var newHeight = height - paddingTop - paddingBottom;
      var newWidth = width - paddingLeft - paddingRight;

      if (!disableHeight && this.state.height !== newHeight || !disableWidth && this.state.width !== newWidth) {
        this.setState({
          height: height - paddingTop - paddingBottom,
          width: width - paddingLeft - paddingRight
        });

        onResize({ height: height, width: width });
      }
    }
  }, {
    key: '_setRef',
    value: function _setRef(autoSizer) {
      this._autoSizer = autoSizer;
    }
  }]);

  return AutoSizer;
}(_react.PureComponent);

AutoSizer.defaultProps = {
  onResize: function onResize() {}
};
exports.default = AutoSizer;
 false ? AutoSizer.propTypes = {
  /**
  * Function responsible for rendering children.
  * This function should implement the following signature:
  * ({ height, width }) => PropTypes.element
  */
  children: _propTypes2.default.func.isRequired,

  /** Disable dynamic :height property */
  disableHeight: _propTypes2.default.bool,

  /** Disable dynamic :width property */
  disableWidth: _propTypes2.default.bool,

  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: _propTypes2.default.string,

  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: _propTypes2.default.func.isRequired
} : void 0;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = this;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        animationstring = 'animation',
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            animationstring = pfx + 'Animation';
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles() {
    if (!document.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) element.attachEvent('onresize', fn);else {
      if (!element.__resizeTriggers__) {
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles();
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) resetTriggers(element);
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) element.detachEvent('onresize', fn);else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.default = undefined;

var _List2 = __webpack_require__(42);

var _List3 = _interopRequireDefault(_List2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _List3.default;
exports.List = _List3.default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Grid = __webpack_require__(43);

var _Grid2 = _interopRequireDefault(_Grid);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */
var List = function (_PureComponent) {
  _inherits(List, _PureComponent);

  function List(props, context) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));

    _this._cellRenderer = _this._cellRenderer.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  _createClass(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      this.Grid.forceUpdate();
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
        alignment: alignment,
        rowIndex: index
      }),
          scrollTop = _Grid$getOffsetForCel.scrollTop;

      return scrollTop;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      this.Grid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.recomputeGridSize({
        rowIndex: index
      });
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToPosition({ scrollTop: scrollTop });
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);

      return _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }, {
    key: '_cellRenderer',
    value: function _cellRenderer(_ref2) {
      var rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          rest = _objectWithoutProperties(_ref2, ['rowIndex', 'style']);

      var rowRenderer = this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer(_extends({
        index: rowIndex,
        style: style
      }, rest));
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }]);

  return List;
}(_react.PureComponent);

List.defaultProps = {
  estimatedRowSize: 30,
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
exports.default = List;
 false ? List.propTypes = {
  'aria-label': _propTypes2.default.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: _propTypes2.default.bool,

  /** Optional CSS class name */
  className: _propTypes2.default.string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _propTypes2.default.number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  height: _propTypes2.default.number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: _propTypes2.default.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: _propTypes2.default.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: _propTypes2.default.number.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: _propTypes2.default.func.isRequired,

  /** Number of rows in list. */
  rowCount: _propTypes2.default.number.isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: _propTypes2.default.number.isRequired,

  /** Vertical offset. */
  scrollTop: _propTypes2.default.number,

  /** Optional inline style */
  style: _propTypes2.default.object,

  /** Tab index for focus */
  tabIndex: _propTypes2.default.number,

  /** Width of list */
  width: _propTypes2.default.number.isRequired
} : void 0;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOverscanIndicesGetter = exports.defaultCellRangeRenderer = exports.accessibilityOverscanIndicesGetter = exports.Grid = exports.default = undefined;

var _Grid2 = __webpack_require__(44);

var _Grid3 = _interopRequireDefault(_Grid2);

var _accessibilityOverscanIndicesGetter2 = __webpack_require__(52);

var _accessibilityOverscanIndicesGetter3 = _interopRequireDefault(_accessibilityOverscanIndicesGetter2);

var _defaultCellRangeRenderer2 = __webpack_require__(10);

var _defaultCellRangeRenderer3 = _interopRequireDefault(_defaultCellRangeRenderer2);

var _defaultOverscanIndicesGetter2 = __webpack_require__(9);

var _defaultOverscanIndicesGetter3 = _interopRequireDefault(_defaultOverscanIndicesGetter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Grid3.default;
exports.Grid = _Grid3.default;
exports.accessibilityOverscanIndicesGetter = _accessibilityOverscanIndicesGetter3.default;
exports.defaultCellRangeRenderer = _defaultCellRangeRenderer3.default;
exports.defaultOverscanIndicesGetter = _defaultOverscanIndicesGetter3.default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(45);

var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);

var _ScalingCellSizeAndPositionManager = __webpack_require__(46);

var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);

var _createCallbackMemoizer = __webpack_require__(48);

var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);

var _defaultOverscanIndicesGetter = __webpack_require__(9);

var _defaultOverscanIndicesGetter2 = _interopRequireDefault(_defaultOverscanIndicesGetter);

var _updateScrollIndexHelper = __webpack_require__(49);

var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);

var _defaultCellRangeRenderer = __webpack_require__(10);

var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);

var _scrollbarSize = __webpack_require__(50);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */

var Grid = function (_PureComponent) {
  _inherits(Grid, _PureComponent);

  function Grid(props, context) {
    _classCallCheck(this, Grid);

    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props, context));

    _this.state = {
      isScrolling: false,
      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0
    };

    // Invokes onSectionRendered callback only when start/stop row or column indices change
    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);

    // Bind functions to instance so they don't lose context when passed around
    _this._debounceScrollEndedCallback = _this._debounceScrollEndedCallback.bind(_this);
    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);

    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);

    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;

    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;

    var deferredMeasurementCache = props.deferredMeasurementCache;
    var deferredMode = typeof deferredMeasurementCache !== 'undefined';

    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
      batchAllCells: deferredMode && !deferredMeasurementCache.hasFixedHeight(),
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._columnWidthGetter(params);
      },
      estimatedCellSize: _this._getEstimatedColumnSize(props)
    });
    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
      batchAllCells: deferredMode && !deferredMeasurementCache.hasFixedWidth(),
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._rowHeightGetter(params);
      },
      estimatedCellSize: _this._getEstimatedRowSize(props)
    });

    // See defaultCellRangeRenderer() for more information on the usage of these caches
    _this._cellCache = {};
    _this._styleCache = {};
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  _createClass(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _extends({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = this._scrollbarSize;
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;


      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;


      this._columnSizeAndPositionManager.resetCell(columnIndex);
      this._rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && columnIndex <= scrollToColumn;
      this._recomputeScrollTopFlag = scrollToRow >= 0 && rowIndex <= scrollToRow;

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._cellCache = {};
      this._styleCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1) {
        this._updateScrollLeftForScrollToColumn(_extends({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      this._updateScrollTopForScrollToRow(_extends({}, props, {
        scrollToRow: rowIndex
      }));
    }

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop;

      this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = getScrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        (0, _updateScrollIndexHelper2.default)({
          cellSizeAndPositionManager: this._columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        (0, _updateScrollIndexHelper2.default)({
          cellSizeAndPositionManager: this._rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getScrollbarSize = this.props.getScrollbarSize;

      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()

      this._scrollbarSize = getScrollbarSize();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }

      this._calculateChildrenToRender();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var _state2 = this.state,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;


      if (nextProps.columnCount === 0 && scrollLeft !== 0 || nextProps.rowCount === 0 && scrollTop !== 0) {
        this._setScrollPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        var newState = {};

        if (nextProps.scrollLeft != null) {
          newState.scrollLeft = nextProps.scrollLeft;
        }
        if (nextProps.scrollTop != null) {
          newState.scrollTop = nextProps.scrollTop;
        }

        this._setScrollPosition(newState);
      }

      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
        this._styleCache = {};
      }

      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);

      this._columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
      });
      this._rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: this._getEstimatedRowSize(nextProps)
      });

      var _props6 = this.props,
          columnCount = _props6.columnCount,
          rowCount = _props6.rowCount;

      // Special case when either cols or rows were 0
      // This would prevent any cells from rendering
      // So we need to reset row scroll if cols changed from 0 (and vice versa)

      if (columnCount === 0 || rowCount === 0) {
        columnCount = 0;
        rowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && this.props.isScrolling === true) {
        this._resetStyleCache();
      }

      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
        cellCount: columnCount,
        cellSize: this.props.columnWidth,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: nextProps.columnWidth,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: this.props.scrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollLeftForScrollToColumn(nextProps, _this3.state);
        }
      });
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
        cellCount: rowCount,
        cellSize: this.props.rowHeight,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: nextProps.rowHeight,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: this.props.scrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollTopForScrollToRow(nextProps, _this3.state);
        }
      });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this._calculateChildrenToRender(nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          autoContainerWidth = _props7.autoContainerWidth,
          autoHeight = _props7.autoHeight,
          autoWidth = _props7.autoWidth,
          className = _props7.className,
          containerStyle = _props7.containerStyle,
          height = _props7.height,
          id = _props7.id,
          noContentRenderer = _props7.noContentRenderer,
          role = _props7.role,
          style = _props7.style,
          tabIndex = _props7.tabIndex,
          width = _props7.width;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return _react2.default.createElement(
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: _extends({}, gridStyle, style),
          tabIndex: tabIndex
        },
        childrenToDisplay.length > 0 && _react2.default.createElement(
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            style: _extends({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle)
          },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          scrollLeft = state.scrollLeft,
          scrollTop = state.scrollTop;


      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: this._renderedColumnStartIndex,
          stopIndex: this._renderedColumnStopIndex
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: this._renderedRowStartIndex,
          stopIndex: this._renderedRowStopIndex
        });

        // Store for _invokeOnGridRenderedHelper()
        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
        this._rowStopIndex = overscanRowIndices.overscanStopIndex;

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
          columnStartIndex: this._columnStartIndex,
          columnStopIndex: this._columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          parent: this,
          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
          rowStartIndex: this._rowStartIndex,
          rowStopIndex: this._rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_debounceScrollEndedCallback',
    value: function _debounceScrollEndedCallback() {
      this._disablePointerEventsTimeoutId = null;
      this._resetStyleCache();
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */

  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnGridRenderedHelper',
    value: function _invokeOnGridRenderedHelper() {
      var onSectionRendered = this.props.onSectionRendered;


      this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: this._columnStartIndex,
          columnOverscanStopIndex: this._columnStopIndex,
          columnStartIndex: this._renderedColumnStartIndex,
          columnStopIndex: this._renderedColumnStopIndex,
          rowOverscanStartIndex: this._rowStartIndex,
          rowOverscanStopIndex: this._rowStopIndex,
          rowStartIndex: this._renderedRowStartIndex,
          rowStopIndex: this._renderedRowStopIndex
        }
      });
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref7) {
      var _this4 = this;

      var scrollLeft = _ref7.scrollLeft,
          scrollTop = _ref7.scrollTop,
          totalColumnsWidth = _ref7.totalColumnsWidth,
          totalRowsHeight = _ref7.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref8) {
          var scrollLeft = _ref8.scrollLeft,
              scrollTop = _ref8.scrollTop;
          var _props8 = _this4.props,
              height = _props8.height,
              onScroll = _props8.onScroll,
              width = _props8.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? props.isScrolling : state.isScrolling;
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this._scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: '_setScrollingContainerRef',
    value: function _setScrollingContainerRef(ref) {
      this._scrollingContainer = ref;
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref9) {
      var scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_wrapPropertyGetter',
    value: function _wrapPropertyGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(size) {
      return this._wrapPropertyGetter(size);
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var columnCount = props.columnCount,
          height = props.height,
          scrollToAlignment = props.scrollToAlignment,
          scrollToColumn = props.scrollToColumn,
          width = props.width;
      var scrollLeft = state.scrollLeft;


      if (scrollToColumn >= 0 && columnCount > 0) {
        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;

        return this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollLeft = state.scrollLeft;

      var calculatedScrollLeft = this._getCalculatedScrollLeft(props, state);

      if (calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        this._setScrollPosition({
          scrollLeft: calculatedScrollLeft
        });
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var height = props.height,
          rowCount = props.rowCount,
          scrollToAlignment = props.scrollToAlignment,
          scrollToRow = props.scrollToRow,
          width = props.width;
      var scrollTop = state.scrollTop;


      if (scrollToRow >= 0 && rowCount > 0) {
        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

        return this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];
        }
      }

      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var scrollTop = state.scrollTop;

      var calculatedScrollTop = this._getCalculatedScrollTop(props, state);

      if (calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        this._setScrollPosition({
          scrollTop: calculatedScrollTop
        });
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== this._scrollingContainer) {
        return;
      }

      this.handleScrollEvent(event.target);
    }
  }]);

  return Grid;
}(_react.PureComponent);

Grid.defaultProps = {
  'aria-label': 'grid',
  cellRangeRenderer: _defaultCellRangeRenderer2.default,
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: _scrollbarSize2.default,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  overscanColumnCount: 0,
  overscanIndicesGetter: _defaultOverscanIndicesGetter2.default,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0
};
exports.default = Grid;
 false ? Grid.propTypes = {
  'aria-label': _propTypes2.default.string,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: _propTypes2.default.bool,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: _propTypes2.default.bool,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: _propTypes2.default.bool,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
   */
  cellRenderer: _propTypes2.default.func.isRequired,

  /**
   * Responsible for rendering a group of cells given their index ranges.
   * Should implement the following interface: ({
   *   cellCache: Map,
   *   cellRenderer: Function,
   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
   *   columnStartIndex: number,
   *   columnStopIndex: number,
   *   isScrolling: boolean,
   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
   *   rowStartIndex: number,
   *   rowStopIndex: number,
   *   scrollLeft: number,
   *   scrollTop: number
   * }): Array<PropTypes.node>
   */
  cellRangeRenderer: _propTypes2.default.func.isRequired,

  /**
   * Optional custom CSS class name to attach to root Grid element.
   */
  className: _propTypes2.default.string,

  /**
   * Number of columns in grid.
   */
  columnCount: _propTypes2.default.number.isRequired,

  /**
   * Either a fixed column width (number) or a function that returns the width of a column given its index.
   * Should implement the following interface: (index: number): number
   */
  columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,

  /** Optional inline style applied to inner cell-container */
  containerStyle: _propTypes2.default.object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: _propTypes2.default.object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: _propTypes2.default.number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _propTypes2.default.number.isRequired,

  /**
   * Exposed for testing purposes only.
   */
  getScrollbarSize: _propTypes2.default.func.isRequired,

  /**
   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
   */
  height: _propTypes2.default.number.isRequired,

  /**
   * Optional custom id to attach to root Grid element.
   */
  id: _propTypes2.default.string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: _propTypes2.default.bool,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
   */
  noContentRenderer: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: _propTypes2.default.func.isRequired,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: _propTypes2.default.func.isRequired,

  /**
   * Callback invoked with information about the section of the Grid that was just rendered.
   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
   */
  onSectionRendered: _propTypes2.default.func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: _propTypes2.default.number.isRequired,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   * Should implement the following interface: ({
   *   cellCount: number,
   *   overscanCellsCount: number,
   *   scrollDirection: number,
   *   startIndex: number,
   *   stopIndex: number
   * }): {overscanStartIndex: number, overscanStopIndex: number}
   */
  overscanIndicesGetter: _propTypes2.default.func.isRequired,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: _propTypes2.default.number.isRequired,

  /**
   * ARIA role for the grid element.
   */
  role: _propTypes2.default.string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,

  /**
   * Number of rows in grid.
   */
  rowCount: _propTypes2.default.number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: _propTypes2.default.number,

  /** Horizontal offset. */
  scrollLeft: _propTypes2.default.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Column index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToColumn: _propTypes2.default.number.isRequired,

  /** Vertical offset. */
  scrollTop: _propTypes2.default.number,

  /**
   * Row index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToRow: _propTypes2.default.number.isRequired,

  /** Optional inline style */
  style: _propTypes2.default.object,

  /** Tab index for focus */
  tabIndex: _propTypes2.default.number,

  /**
   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
   */
  width: _propTypes2.default.number.isRequired
} : void 0;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 *
 * @param cellCount Number of rows or columns in the current axis
 * @param cellsSize Width or height of cells for the current axis
 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
 * @param nextCellsCount Newly updated number of rows or columns in the current axis
 * @param nextCellsSize Newly updated width or height of cells for the current axis
 * @param nextScrollToIndex Newly updated scroll-to-index
 * @param scrollToIndex Scroll-to-index
 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MAX_SCROLL_SIZE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CellSizeAndPositionManager = __webpack_require__(47);

var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */
var DEFAULT_MAX_SCROLL_SIZE = exports.DEFAULT_MAX_SCROLL_SIZE = 1500000;

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */

var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize,
        params = _objectWithoutProperties(_ref, ['maxScrollSize']);

    _classCallCheck(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
    this._maxScrollSize = maxScrollSize;
  }

  _createClass(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex,
          totalSize = _ref3.totalSize;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex,
        totalSize: totalSize
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager = function () {
  function CellSizeAndPositionManager(_ref) {
    var _ref$batchAllCells = _ref.batchAllCells,
        batchAllCells = _ref$batchAllCells === undefined ? false : _ref$batchAllCells,
        cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    _classCallCheck(this, CellSizeAndPositionManager);

    this._batchAllCells = batchAllCells;
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;

    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    this._cellSizeAndPositionData = {};

    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    this._lastMeasuredIndex = -1;

    // Used in deferred mode to track which cells have been queued for measurement.
    this._lastBatchedIndex = -1;
  }

  _createClass(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref3) {
      var containerSize = _ref3.containerSize,
          offset = _ref3.offset;

      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells as measured the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();

      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref4) {
      var _ref4$align = _ref4.align,
          align = _ref4$align === undefined ? 'auto' : _ref4$align,
          containerSize = _ref4.containerSize,
          currentOffset = _ref4.currentOffset,
          targetIndex = _ref4.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
      // eg we can't know a row's height without measuring the height of all columns within that row.
      if (this._batchAllCells) {
        return {
          start: 0,
          stop: this._cellCount - 1
        };
      }

      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(_ref5) {
      var high = _ref5.high,
          low = _ref5.low,
          offset = _ref5.offset;

      var middle = void 0;
      var currentOffset = void 0;

      while (low <= high) {
        middle = low + Math.floor((high - low) / 2);
        currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(_ref6) {
      var index = _ref6.index,
          offset = _ref6.offset;

      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch({
        high: Math.min(index, this._cellCount - 1),
        low: Math.floor(index / 2),
        offset: offset
      });
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch({
          high: lastMeasuredIndex,
          low: 0,
          offset: offset
        });
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch({
          index: lastMeasuredIndex,
          offset: offset
        });
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

exports.default = CellSizeAndPositionManager;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCallbackMemoizer;
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateScrollIndexHelper;
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 *
 * @param cellsSize Width or height of cells for the current axis
 * @param cellSizeAndPositionManager Manages size and position metadata of cells
 * @param previousCellsCount Previous number of rows or columns
 * @param previousCellsSize Previous width or height of cells
 * @param previousScrollToIndex Previous scroll-to-index
 * @param previousSize Previous width or height of the virtualized container
 * @param scrollOffset Current scrollLeft or scrollTop
 * @param scrollToIndex Scroll-to-index
 * @param size Width or height of the virtualized container
 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
 */
function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(51);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultOverscanIndicesGetter;
var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 *
 * @param direction One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
 * @param cellCount Number of rows or columns in the current axis
 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
 * @param overscanCellsCount Maximum number of cells to over-render in either direction
 * @param startIndex Begin of range of visible cells
 * @param stopIndex End of range of visible cells
 */
function defaultOverscanIndicesGetter(_ref) {
  var direction = _ref.direction,
      cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  var overscanStartIndex = void 0;
  var overscanStopIndex = void 0;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  switch (scrollDirection) {
    case SCROLL_DIRECTION_FORWARD:
      overscanStartIndex = startIndex - 1;
      overscanStopIndex = stopIndex + overscanCellsCount;
      break;
    case SCROLL_DIRECTION_BACKWARD:
      overscanStartIndex = startIndex - overscanCellsCount;
      overscanStopIndex = stopIndex + 1;
      break;
  }

  return {
    overscanStartIndex: Math.max(0, overscanStartIndex),
    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
  };
}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var PDFSupport=function PDFSupport(_ref){var enablePdf=_ref.enablePdf,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'checkbox',name:'enablePdf',checked:enablePdf,onChange:onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Install Pandoc and texlive to support conversion of notebooks to LaTeX and PDF files')));};PDFSupport.propTypes={enablePdf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PDFSupport);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var SparkSupport=function SparkSupport(_ref){var enableSpark=_ref.enableSpark,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'checkbox',name:'enableSpark',checked:enableSpark,onChange:onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Install Apache Spark 2.2.0 for Hadoop 2.7 or higher')));};SparkSupport.propTypes={enableSpark:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SparkSupport);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var TextEditors=function TextEditors(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Install text editors for use in the terminal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'checkbox',name:'enableEmacs',checked:props.enableEmacs,onChange:props.onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Emacs'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'checkbox',name:'enableJed',checked:props.enableJed,onChange:props.onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'JED'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'checkbox',name:'enableVim',checked:props.enableVim,onChange:props.onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Vim'))));};TextEditors.propTypes={enableEmacs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,enableJed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,enableVim:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TextEditors);

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = {"packages":[{"label":"AbaqusReader","value":"AbaqusReader"},{"label":"AbbrvKW","value":"AbbrvKW"},{"label":"AbstractDomains","value":"AbstractDomains"},{"label":"AbstractFFTs","value":"AbstractFFTs"},{"label":"AbstractOperators","value":"AbstractOperators"},{"label":"AbstractTables","value":"AbstractTables"},{"label":"AbstractTrees","value":"AbstractTrees"},{"label":"Accumulo","value":"Accumulo"},{"label":"ACME","value":"ACME"},{"label":"ActiveAppearanceModels","value":"ActiveAppearanceModels"},{"label":"Actors","value":"Actors"},{"label":"ActuarialScience","value":"ActuarialScience"},{"label":"AdaptiveDistanceFields","value":"AdaptiveDistanceFields"},{"label":"AdjacentFloats","value":"AdjacentFloats"},{"label":"AdobeGlyphList","value":"AdobeGlyphList"},{"label":"AffineInvariantMCMC","value":"AffineInvariantMCMC"},{"label":"AffineTransforms","value":"AffineTransforms"},{"label":"AlgebraicDiffEq","value":"AlgebraicDiffEq"},{"label":"AMD","value":"AMD"},{"label":"AmplNLReader","value":"AmplNLReader"},{"label":"AmplNLWriter","value":"AmplNLWriter"},{"label":"AMQPClient","value":"AMQPClient"},{"label":"Anasol","value":"Anasol"},{"label":"AndorSIF","value":"AndorSIF"},{"label":"AnsiColor","value":"AnsiColor"},{"label":"AppConf","value":"AppConf"},{"label":"AppleAccelerate","value":"AppleAccelerate"},{"label":"ApproxFun","value":"ApproxFun"},{"label":"ArbFloats","value":"ArbFloats"},{"label":"Arbiter","value":"Arbiter"},{"label":"ArcadeLearningEnvironment","value":"ArcadeLearningEnvironment"},{"label":"Arduino","value":"Arduino"},{"label":"ArgCheck","value":"ArgCheck"},{"label":"ArgParse","value":"ArgParse"},{"label":"ArrayFire","value":"ArrayFire"},{"label":"ArrayViews","value":"ArrayViews"},{"label":"Arrowhead","value":"Arrowhead"},{"label":"ASCIIPlots","value":"ASCIIPlots"},{"label":"AsterReader","value":"AsterReader"},{"label":"ASTInterpreter","value":"ASTInterpreter"},{"label":"AstroLib","value":"AstroLib"},{"label":"AtariAlgos","value":"AtariAlgos"},{"label":"Atom","value":"Atom"},{"label":"AudioIO","value":"AudioIO"},{"label":"AuditoryFilters","value":"AuditoryFilters"},{"label":"Augmentor","value":"Augmentor"},{"label":"Augur","value":"Augur"},{"label":"AutoDiffSource","value":"AutoDiffSource"},{"label":"AutoGrad","value":"AutoGrad"},{"label":"AutoHashEquals","value":"AutoHashEquals"},{"label":"Automa","value":"Automa"},{"label":"Autoreload","value":"Autoreload"},{"label":"AutoTypeParameters","value":"AutoTypeParameters"},{"label":"AverageShiftedHistograms","value":"AverageShiftedHistograms"},{"label":"Avro","value":"Avro"},{"label":"AWS","value":"AWS"},{"label":"AWSCore","value":"AWSCore"},{"label":"AWSEC2","value":"AWSEC2"},{"label":"AWSIAM","value":"AWSIAM"},{"label":"AWSLambda","value":"AWSLambda"},{"label":"AWSS3","value":"AWSS3"},{"label":"AWSSDB","value":"AWSSDB"},{"label":"AWSSDK","value":"AWSSDK"},{"label":"AWSSES","value":"AWSSES"},{"label":"AWSSNS","value":"AWSSNS"},{"label":"AWSSQS","value":"AWSSQS"},{"label":"AxisAlgorithms","value":"AxisAlgorithms"},{"label":"AxisArrays","value":"AxisArrays"},{"label":"BackpropNeuralNet","value":"BackpropNeuralNet"},{"label":"BandedMatrices","value":"BandedMatrices"},{"label":"Bandits","value":"Bandits"},{"label":"BARON","value":"BARON"},{"label":"BaseTestDeprecated","value":"BaseTestDeprecated"},{"label":"BaseTestNext","value":"BaseTestNext"},{"label":"BasisFunctionExpansions","value":"BasisFunctionExpansions"},{"label":"BasisMatrices","value":"BasisMatrices"},{"label":"BayesianDataFusion","value":"BayesianDataFusion"},{"label":"BayesianNonparametrics","value":"BayesianNonparametrics"},{"label":"BayesNets","value":"BayesNets"},{"label":"BDF","value":"BDF"},{"label":"BeaData","value":"BeaData"},{"label":"Bebop","value":"Bebop"},{"label":"Bedgraph","value":"Bedgraph"},{"label":"BedgraphFiles","value":"BedgraphFiles"},{"label":"Benchmark","value":"Benchmark"},{"label":"BenchmarkLite","value":"BenchmarkLite"},{"label":"BenchmarkProfiles","value":"BenchmarkProfiles"},{"label":"BenchmarkTools","value":"BenchmarkTools"},{"label":"BEncode","value":"BEncode"},{"label":"Bezier","value":"Bezier"},{"label":"BGZFStreams","value":"BGZFStreams"},{"label":"BigArrays","value":"BigArrays"},{"label":"BIGUQ","value":"BIGUQ"},{"label":"BinDeps","value":"BinDeps"},{"label":"Bio","value":"Bio"},{"label":"BioAlignments","value":"BioAlignments"},{"label":"BioArgParse","value":"BioArgParse"},{"label":"BioBridgeR","value":"BioBridgeR"},{"label":"BioCore","value":"BioCore"},{"label":"BioEnergeticFoodWebs","value":"BioEnergeticFoodWebs"},{"label":"BioMedQuery","value":"BioMedQuery"},{"label":"BiomolecularStructures","value":"BiomolecularStructures"},{"label":"BioSeq","value":"BioSeq"},{"label":"BioSequences","value":"BioSequences"},{"label":"BioStructures","value":"BioStructures"},{"label":"BioSymbols","value":"BioSymbols"},{"label":"Biryani","value":"Biryani"},{"label":"BlackBoxOptim","value":"BlackBoxOptim"},{"label":"Blink","value":"Blink"},{"label":"BlockArrays","value":"BlockArrays"},{"label":"Blocks","value":"Blocks"},{"label":"BloomFilters","value":"BloomFilters"},{"label":"Blosc","value":"Blosc"},{"label":"BlossomV","value":"BlossomV"},{"label":"BlsData","value":"BlsData"},{"label":"Bokeh","value":"Bokeh"},{"label":"Boltzmann","value":"Boltzmann"},{"label":"Bootstrap","value":"Bootstrap"},{"label":"BOSSArrays","value":"BOSSArrays"},{"label":"BoundaryValueDiffEq","value":"BoundaryValueDiffEq"},{"label":"BoundingBoxes","value":"BoundingBoxes"},{"label":"Box0","value":"Box0"},{"label":"Bridge","value":"Bridge"},{"label":"Brim","value":"Brim"},{"label":"Brownian","value":"Brownian"},{"label":"BSplines","value":"BSplines"},{"label":"BufferedStreams","value":"BufferedStreams"},{"label":"BuildExecutable","value":"BuildExecutable"},{"label":"Bukdu","value":"Bukdu"},{"label":"BusinessDays","value":"BusinessDays"},{"label":"Caesar","value":"Caesar"},{"label":"Cairo","value":"Cairo"},{"label":"Calc","value":"Calc"},{"label":"Calculus","value":"Calculus"},{"label":"Calendar","value":"Calendar"},{"label":"CardinalDicts","value":"CardinalDicts"},{"label":"Cartesian","value":"Cartesian"},{"label":"CasaCore","value":"CasaCore"},{"label":"Cascadia","value":"Cascadia"},{"label":"Catalan","value":"Catalan"},{"label":"CategoricalArrays","value":"CategoricalArrays"},{"label":"CatIndices","value":"CatIndices"},{"label":"CatViews","value":"CatViews"},{"label":"CausalInference","value":"CausalInference"},{"label":"CauseMap","value":"CauseMap"},{"label":"Cbc","value":"Cbc"},{"label":"CBOR","value":"CBOR"},{"label":"CDDLib","value":"CDDLib"},{"label":"Celeste","value":"Celeste"},{"label":"CellularAutomata","value":"CellularAutomata"},{"label":"ChainedVectors","value":"ChainedVectors"},{"label":"ChainMap","value":"ChainMap"},{"label":"ChainRecursive","value":"ChainRecursive"},{"label":"Changepoints","value":"Changepoints"},{"label":"ChaosCommunications","value":"ChaosCommunications"},{"label":"Chatter","value":"Chatter"},{"label":"Checkers","value":"Checkers"},{"label":"Chemfiles","value":"Chemfiles"},{"label":"ChemicalKinetics","value":"ChemicalKinetics"},{"label":"Chipmunk","value":"Chipmunk"},{"label":"ChunkedArrays","value":"ChunkedArrays"},{"label":"Church","value":"Church"},{"label":"Circuitscape","value":"Circuitscape"},{"label":"CirruParser","value":"CirruParser"},{"label":"Clang","value":"Clang"},{"label":"CLArrays","value":"CLArrays"},{"label":"Clarus","value":"Clarus"},{"label":"ClassicalCiphers","value":"ClassicalCiphers"},{"label":"CLBLAS","value":"CLBLAS"},{"label":"CLFFT","value":"CLFFT"},{"label":"Cliffords","value":"Cliffords"},{"label":"ClimateTools","value":"ClimateTools"},{"label":"ClinicalTrialSampleSize","value":"ClinicalTrialSampleSize"},{"label":"Clipper","value":"Clipper"},{"label":"ClobberingReload","value":"ClobberingReload"},{"label":"Clockwork","value":"Clockwork"},{"label":"CloudGraphs","value":"CloudGraphs"},{"label":"Clp","value":"Clp"},{"label":"ClusterDicts","value":"ClusterDicts"},{"label":"Clustering","value":"Clustering"},{"label":"ClusterManagers","value":"ClusterManagers"},{"label":"ClusterUtils","value":"ClusterUtils"},{"label":"CMakeWrapper","value":"CMakeWrapper"},{"label":"CmplxRoots","value":"CmplxRoots"},{"label":"COBRA","value":"COBRA"},{"label":"CodecBase","value":"CodecBase"},{"label":"CodecBzip2","value":"CodecBzip2"},{"label":"Codecs","value":"Codecs"},{"label":"CodecXz","value":"CodecXz"},{"label":"CodecZlib","value":"CodecZlib"},{"label":"CodecZstd","value":"CodecZstd"},{"label":"CodeTools","value":"CodeTools"},{"label":"COESA","value":"COESA"},{"label":"COFF","value":"COFF"},{"label":"CoinOptServices","value":"CoinOptServices"},{"label":"CollisionDetection","value":"CollisionDetection"},{"label":"Color","value":"Color"},{"label":"ColorBrewer","value":"ColorBrewer"},{"label":"Colors","value":"Colors"},{"label":"ColorSchemes","value":"ColorSchemes"},{"label":"ColorTypes","value":"ColorTypes"},{"label":"ColorVectorSpace","value":"ColorVectorSpace"},{"label":"Combinatorics","value":"Combinatorics"},{"label":"CommonCrawl","value":"CommonCrawl"},{"label":"CommonSubexpressions","value":"CommonSubexpressions"},{"label":"CommunityDetection","value":"CommunityDetection"},{"label":"Compat","value":"Compat"},{"label":"CompEcon","value":"CompEcon"},{"label":"CompilerOptions","value":"CompilerOptions"},{"label":"CompilerTools","value":"CompilerTools"},{"label":"Complementarity","value":"Complementarity"},{"label":"Compose","value":"Compose"},{"label":"ComposeDiff","value":"ComposeDiff"},{"label":"CompressedSensing","value":"CompressedSensing"},{"label":"CompScienceMeshes","value":"CompScienceMeshes"},{"label":"ComputationalResources","value":"ComputationalResources"},{"label":"COMTRADE","value":"COMTRADE"},{"label":"ConcaveHull","value":"ConcaveHull"},{"label":"Conda","value":"Conda"},{"label":"ConditionalJuMP","value":"ConditionalJuMP"},{"label":"ConfidenceWeighted","value":"ConfidenceWeighted"},{"label":"ConfParser","value":"ConfParser"},{"label":"ConicBenchmarkUtilities","value":"ConicBenchmarkUtilities"},{"label":"ConicIP","value":"ConicIP"},{"label":"ConicNonlinearBridge","value":"ConicNonlinearBridge"},{"label":"ConjugatePriors","value":"ConjugatePriors"},{"label":"ConnectionPools","value":"ConnectionPools"},{"label":"ConnectSDK","value":"ConnectSDK"},{"label":"ConstructiveSolidGeometry","value":"ConstructiveSolidGeometry"},{"label":"ContinuedFractions","value":"ContinuedFractions"},{"label":"ContMechTensors","value":"ContMechTensors"},{"label":"Contour","value":"Contour"},{"label":"ControlCore","value":"ControlCore"},{"label":"ControlSystems","value":"ControlSystems"},{"label":"Convertible","value":"Convertible"},{"label":"Convex","value":"Convex"},{"label":"ConvexSwitch","value":"ConvexSwitch"},{"label":"CoordinateDescent","value":"CoordinateDescent"},{"label":"CoordinateTransformations","value":"CoordinateTransformations"},{"label":"CoreNLP","value":"CoreNLP"},{"label":"CorpusTools","value":"CorpusTools"},{"label":"Cosmology","value":"Cosmology"},{"label":"Counters","value":"Counters"},{"label":"CoupledFields","value":"CoupledFields"},{"label":"CovarianceMatrices","value":"CovarianceMatrices"},{"label":"Coverage","value":"Coverage"},{"label":"CoverageBase","value":"CoverageBase"},{"label":"CPLEX","value":"CPLEX"},{"label":"Cpp","value":"Cpp"},{"label":"CpuId","value":"CpuId"},{"label":"CPUTime","value":"CPUTime"},{"label":"CQL","value":"CQL"},{"label":"Crayons","value":"Crayons"},{"label":"CRC","value":"CRC"},{"label":"CRC32","value":"CRC32"},{"label":"CreateMacrosFrom","value":"CreateMacrosFrom"},{"label":"CRF","value":"CRF"},{"label":"CRlibm","value":"CRlibm"},{"label":"CrossDecomposition","value":"CrossDecomposition"},{"label":"CrossfilterCharts","value":"CrossfilterCharts"},{"label":"Crypto","value":"Crypto"},{"label":"CSDP","value":"CSDP"},{"label":"CSTParser","value":"CSTParser"},{"label":"CSV","value":"CSV"},{"label":"CSVFiles","value":"CSVFiles"},{"label":"CuArrays","value":"CuArrays"},{"label":"Cuba","value":"Cuba"},{"label":"Cubature","value":"Cubature"},{"label":"CUBLAS","value":"CUBLAS"},{"label":"CUDA","value":"CUDA"},{"label":"CUDAapi","value":"CUDAapi"},{"label":"CUDAdrv","value":"CUDAdrv"},{"label":"CUDAnative","value":"CUDAnative"},{"label":"CUDAnativelib","value":"CUDAnativelib"},{"label":"CUDArt","value":"CUDArt"},{"label":"CUDD","value":"CUDD"},{"label":"CUDNN","value":"CUDNN"},{"label":"CUFFT","value":"CUFFT"},{"label":"Cumulants","value":"Cumulants"},{"label":"CURAND","value":"CURAND"},{"label":"Curl","value":"Curl"},{"label":"Currencies","value":"Currencies"},{"label":"CurveFit","value":"CurveFit"},{"label":"Curvelet","value":"Curvelet"},{"label":"CUSOLVER","value":"CUSOLVER"},{"label":"CUSPARSE","value":"CUSPARSE"},{"label":"CustomUnitRanges","value":"CustomUnitRanges"},{"label":"CUTEst","value":"CUTEst"},{"label":"CutPruners","value":"CutPruners"},{"label":"CVXOPT","value":"CVXOPT"},{"label":"Cxx","value":"Cxx"},{"label":"CxxWrap","value":"CxxWrap"},{"label":"D3Trees","value":"D3Trees"},{"label":"Dagger","value":"Dagger"},{"label":"DASKR","value":"DASKR"},{"label":"DASSL","value":"DASSL"},{"label":"DataArrays","value":"DataArrays"},{"label":"DataAssim","value":"DataAssim"},{"label":"DataCubes","value":"DataCubes"},{"label":"DataFlow","value":"DataFlow"},{"label":"DataFrames","value":"DataFrames"},{"label":"DataFramesMeta","value":"DataFramesMeta"},{"label":"DataStreams","value":"DataStreams"},{"label":"DataStreamsIntegrationTests","value":"DataStreamsIntegrationTests"},{"label":"DataStructures","value":"DataStructures"},{"label":"DataTables","value":"DataTables"},{"label":"DataValueArrays","value":"DataValueArrays"},{"label":"DataValues","value":"DataValues"},{"label":"DateParser","value":"DateParser"},{"label":"Dates","value":"Dates"},{"label":"Datetime","value":"Datetime"},{"label":"DBAPI","value":"DBAPI"},{"label":"DBFTables","value":"DBFTables"},{"label":"DCEMRI","value":"DCEMRI"},{"label":"Debug","value":"Debug"},{"label":"DecFP","value":"DecFP"},{"label":"Decimals","value":"Decimals"},{"label":"DecisionTree","value":"DecisionTree"},{"label":"DeclarativePackages","value":"DeclarativePackages"},{"label":"Deconvolution","value":"Deconvolution"},{"label":"DeepDiffs","value":"DeepDiffs"},{"label":"Defer","value":"Defer"},{"label":"DeferredFutures","value":"DeferredFutures"},{"label":"DelaunayMeshes","value":"DelaunayMeshes"},{"label":"DelayDiffEq","value":"DelayDiffEq"},{"label":"Deldir","value":"Deldir"},{"label":"Dendriform","value":"Dendriform"},{"label":"DependentBootstrap","value":"DependentBootstrap"},{"label":"DetectionTheory","value":"DetectionTheory"},{"label":"DeterminantalPointProcesses","value":"DeterminantalPointProcesses"},{"label":"DeterministicPolicyGradient","value":"DeterministicPolicyGradient"},{"label":"Devectorize","value":"Devectorize"},{"label":"DevIL","value":"DevIL"},{"label":"Diana","value":"Diana"},{"label":"DICOM","value":"DICOM"},{"label":"DictFiles","value":"DictFiles"},{"label":"DictUtils","value":"DictUtils"},{"label":"Dierckx","value":"Dierckx"},{"label":"DiffBase","value":"DiffBase"},{"label":"DiffEqBase","value":"DiffEqBase"},{"label":"DiffEqBiological","value":"DiffEqBiological"},{"label":"DiffEqCallbacks","value":"DiffEqCallbacks"},{"label":"DiffEqDevTools","value":"DiffEqDevTools"},{"label":"DiffEqDiffTools","value":"DiffEqDiffTools"},{"label":"DiffEqFinancial","value":"DiffEqFinancial"},{"label":"DiffEqJump","value":"DiffEqJump"},{"label":"DiffEqMonteCarlo","value":"DiffEqMonteCarlo"},{"label":"DiffEqNoiseProcess","value":"DiffEqNoiseProcess"},{"label":"DiffEqParamEstim","value":"DiffEqParamEstim"},{"label":"DiffEqPDEBase","value":"DiffEqPDEBase"},{"label":"DiffEqProblemLibrary","value":"DiffEqProblemLibrary"},{"label":"DiffEqSensitivity","value":"DiffEqSensitivity"},{"label":"DiffEqUncertainty","value":"DiffEqUncertainty"},{"label":"DifferentialDynamicProgramming","value":"DifferentialDynamicProgramming"},{"label":"DifferentialEquations","value":"DifferentialEquations"},{"label":"DiffResults","value":"DiffResults"},{"label":"DiffRules","value":"DiffRules"},{"label":"DiffTests","value":"DiffTests"},{"label":"Digits","value":"Digits"},{"label":"DimensionalityReduction","value":"DimensionalityReduction"},{"label":"DimensionalPlotRecipes","value":"DimensionalPlotRecipes"},{"label":"DirichletProcessMixtures","value":"DirichletProcessMixtures"},{"label":"DiscreteFactor","value":"DiscreteFactor"},{"label":"Discretizers","value":"Discretizers"},{"label":"DiscriminantAnalysis","value":"DiscriminantAnalysis"},{"label":"Dispatcher","value":"Dispatcher"},{"label":"Displaz","value":"Displaz"},{"label":"Distance","value":"Distance"},{"label":"Distances","value":"Distances"},{"label":"DistQuads","value":"DistQuads"},{"label":"DistributedArrays","value":"DistributedArrays"},{"label":"Distributions","value":"Distributions"},{"label":"Divergences","value":"Divergences"},{"label":"Diversity","value":"Diversity"},{"label":"Docile","value":"Docile"},{"label":"Docker","value":"Docker"},{"label":"DocOpt","value":"DocOpt"},{"label":"DocSeeker","value":"DocSeeker"},{"label":"DocStringExtensions","value":"DocStringExtensions"},{"label":"Documenter","value":"Documenter"},{"label":"DocumentFormat","value":"DocumentFormat"},{"label":"DocumentFunction","value":"DocumentFunction"},{"label":"Dolang","value":"Dolang"},{"label":"Dolo","value":"Dolo"},{"label":"Dopri","value":"Dopri"},{"label":"DotOverloading","value":"DotOverloading"},{"label":"DoubleDouble","value":"DoubleDouble"},{"label":"DrakeVisualizer","value":"DrakeVisualizer"},{"label":"Drawing","value":"Drawing"},{"label":"DReal","value":"DReal"},{"label":"DriftDiffusion","value":"DriftDiffusion"},{"label":"DriftDiffusionPoissonSystems","value":"DriftDiffusionPoissonSystems"},{"label":"DSGE","value":"DSGE"},{"label":"DSP","value":"DSP"},{"label":"Dtree","value":"Dtree"},{"label":"DualNumbers","value":"DualNumbers"},{"label":"DustExtinction","value":"DustExtinction"},{"label":"DWARF","value":"DWARF"},{"label":"DynamicalBilliards","value":"DynamicalBilliards"},{"label":"DynamicalBilliardsPlotting","value":"DynamicalBilliardsPlotting"},{"label":"DynamicalSystems","value":"DynamicalSystems"},{"label":"DynamicDiscreteModels","value":"DynamicDiscreteModels"},{"label":"DynamicMovementPrimitives","value":"DynamicMovementPrimitives"},{"label":"DynamicPolynomials","value":"DynamicPolynomials"},{"label":"DynamoDB","value":"DynamoDB"},{"label":"Dynare","value":"Dynare"},{"label":"DynMultiply","value":"DynMultiply"},{"label":"EarthOrientation","value":"EarthOrientation"},{"label":"EasyPhys","value":"EasyPhys"},{"label":"EasyPkg","value":"EasyPkg"},{"label":"EcologicalNetwork","value":"EcologicalNetwork"},{"label":"EconDatasets","value":"EconDatasets"},{"label":"EconModels","value":"EconModels"},{"label":"ECOS","value":"ECOS"},{"label":"EEG","value":"EEG"},{"label":"Eglob","value":"Eglob"},{"label":"EGM96","value":"EGM96"},{"label":"EgyptianFractions","value":"EgyptianFractions"},{"label":"Einsum","value":"Einsum"},{"label":"ElasticFDA","value":"ElasticFDA"},{"label":"Elemental","value":"Elemental"},{"label":"ELF","value":"ELF"},{"label":"EllipsisNotation","value":"EllipsisNotation"},{"label":"Elliptic","value":"Elliptic"},{"label":"EllipticFEM","value":"EllipticFEM"},{"label":"Elly","value":"Elly"},{"label":"EMIRT","value":"EMIRT"},{"label":"EmpiricalRisks","value":"EmpiricalRisks"},{"label":"EndpointRanges","value":"EndpointRanges"},{"label":"EnglishText","value":"EnglishText"},{"label":"EnhancedGJK","value":"EnhancedGJK"},{"label":"Ensemble","value":"Ensemble"},{"label":"Equations","value":"Equations"},{"label":"Erdos","value":"Erdos"},{"label":"ERFA","value":"ERFA"},{"label":"ErrorfreeArithmetic","value":"ErrorfreeArithmetic"},{"label":"ErrorFreeTransforms","value":"ErrorFreeTransforms"},{"label":"EscapeString","value":"EscapeString"},{"label":"Escher","value":"Escher"},{"label":"Espresso","value":"Espresso"},{"label":"Etcd","value":"Etcd"},{"label":"Evapotranspiration","value":"Evapotranspiration"},{"label":"EventHistory","value":"EventHistory"},{"label":"EventSimulation","value":"EventSimulation"},{"label":"Evolutionary","value":"Evolutionary"},{"label":"EvolvingGraphs","value":"EvolvingGraphs"},{"label":"Example","value":"Example"},{"label":"ExcelFiles","value":"ExcelFiles"},{"label":"ExcelReaders","value":"ExcelReaders"},{"label":"Expect","value":"Expect"},{"label":"ExperimentalAnalysis","value":"ExperimentalAnalysis"},{"label":"ExpressionPatterns","value":"ExpressionPatterns"},{"label":"ExpressionUtils","value":"ExpressionUtils"},{"label":"Extern","value":"Extern"},{"label":"ExtractMacro","value":"ExtractMacro"},{"label":"ExtremelyRandomizedTrees","value":"ExtremelyRandomizedTrees"},{"label":"EzXML","value":"EzXML"},{"label":"FaceDatasets","value":"FaceDatasets"},{"label":"FactCheck","value":"FactCheck"},{"label":"FactorModels","value":"FactorModels"},{"label":"Faker","value":"Faker"},{"label":"FastaIO","value":"FastaIO"},{"label":"FastAnonymous","value":"FastAnonymous"},{"label":"FastArrayOps","value":"FastArrayOps"},{"label":"FastClosures","value":"FastClosures"},{"label":"FastCombinations","value":"FastCombinations"},{"label":"FastGaussQuadrature","value":"FastGaussQuadrature"},{"label":"FaSTLMM","value":"FaSTLMM"},{"label":"FastRounding","value":"FastRounding"},{"label":"FastTransforms","value":"FastTransforms"},{"label":"Fatou","value":"Fatou"},{"label":"Feather","value":"Feather"},{"label":"FeatherFiles","value":"FeatherFiles"},{"label":"FEMBasis","value":"FEMBasis"},{"label":"FEModels","value":"FEModels"},{"label":"FEMQuad","value":"FEMQuad"},{"label":"FEniCS","value":"FEniCS"},{"label":"FFTViews","value":"FFTViews"},{"label":"FFTW","value":"FFTW"},{"label":"FileFind","value":"FileFind"},{"label":"FileIO","value":"FileIO"},{"label":"FilePaths","value":"FilePaths"},{"label":"FinancialMarkets","value":"FinancialMarkets"},{"label":"FinancialToolbox","value":"FinancialToolbox"},{"label":"FiniteElementDiffEq","value":"FiniteElementDiffEq"},{"label":"FiniteStateMachine","value":"FiniteStateMachine"},{"label":"Fire","value":"Fire"},{"label":"FirstOrderSolvers","value":"FirstOrderSolvers"},{"label":"FITSIO","value":"FITSIO"},{"label":"FixedEffectModels","value":"FixedEffectModels"},{"label":"FixedPoint","value":"FixedPoint"},{"label":"FixedPointDecimals","value":"FixedPointDecimals"},{"label":"FixedPointNumbers","value":"FixedPointNumbers"},{"label":"FixedPolynomials","value":"FixedPolynomials"},{"label":"FixedSizeArrays","value":"FixedSizeArrays"},{"label":"FixedSizeDictionaries","value":"FixedSizeDictionaries"},{"label":"FixedSizeStrings","value":"FixedSizeStrings"},{"label":"Fixtures","value":"Fixtures"},{"label":"FLAC","value":"FLAC"},{"label":"FLANN","value":"FLANN"},{"label":"FlatBuffers","value":"FlatBuffers"},{"label":"FlexibleArrays","value":"FlexibleArrays"},{"label":"Flux","value":"Flux"},{"label":"FMIndexes","value":"FMIndexes"},{"label":"FNVHash","value":"FNVHash"},{"label":"Fontconfig","value":"Fontconfig"},{"label":"ForecastEval","value":"ForecastEval"},{"label":"Formatting","value":"Formatting"},{"label":"FortranFiles","value":"FortranFiles"},{"label":"ForwardDiff","value":"ForwardDiff"},{"label":"FPTControl","value":"FPTControl"},{"label":"FredData","value":"FredData"},{"label":"FreeType","value":"FreeType"},{"label":"FreeTypeAbstraction","value":"FreeTypeAbstraction"},{"label":"FreqTables","value":"FreqTables"},{"label":"FTPClient","value":"FTPClient"},{"label":"Fuji","value":"Fuji"},{"label":"FunctionalCollections","value":"FunctionalCollections"},{"label":"FunctionalData","value":"FunctionalData"},{"label":"FunctionalDataUtils","value":"FunctionalDataUtils"},{"label":"FunctionalUtils","value":"FunctionalUtils"},{"label":"FunctionWrappers","value":"FunctionWrappers"},{"label":"FusionDirect","value":"FusionDirect"},{"label":"Gadfly","value":"Gadfly"},{"label":"GadflyDiff","value":"GadflyDiff"},{"label":"Gallium","value":"Gallium"},{"label":"GARCH","value":"GARCH"},{"label":"GasModels","value":"GasModels"},{"label":"Gasp","value":"Gasp"},{"label":"Gaston","value":"Gaston"},{"label":"GaussianMixtures","value":"GaussianMixtures"},{"label":"GaussianMixtureTest","value":"GaussianMixtureTest"},{"label":"GaussianProcesses","value":"GaussianProcesses"},{"label":"GaussQuadrature","value":"GaussQuadrature"},{"label":"GeneralizedMetropolisHastings","value":"GeneralizedMetropolisHastings"},{"label":"GeneralizedSampling","value":"GeneralizedSampling"},{"label":"GeneralizedSchurAlgorithm","value":"GeneralizedSchurAlgorithm"},{"label":"GenericSVD","value":"GenericSVD"},{"label":"GeneticAlgorithms","value":"GeneticAlgorithms"},{"label":"GeneticVariation","value":"GeneticVariation"},{"label":"GenomicFeatures","value":"GenomicFeatures"},{"label":"GenomicVectors","value":"GenomicVectors"},{"label":"Geodesy","value":"Geodesy"},{"label":"GeoEfficiency","value":"GeoEfficiency"},{"label":"GeographicLibPy","value":"GeographicLibPy"},{"label":"GeoInterface","value":"GeoInterface"},{"label":"GeoIP","value":"GeoIP"},{"label":"GeoJSON","value":"GeoJSON"},{"label":"GeometricalPredicates","value":"GeometricalPredicates"},{"label":"GeometryTypes","value":"GeometryTypes"},{"label":"GeostatInversion","value":"GeostatInversion"},{"label":"GeoStats","value":"GeoStats"},{"label":"GeoStatsBase","value":"GeoStatsBase"},{"label":"GeoStatsDevTools","value":"GeoStatsDevTools"},{"label":"GeoStatsImages","value":"GeoStatsImages"},{"label":"GetC","value":"GetC"},{"label":"Gettext","value":"Gettext"},{"label":"GibbsSeaWater","value":"GibbsSeaWater"},{"label":"Gillespie","value":"Gillespie"},{"label":"Git","value":"Git"},{"label":"GitHub","value":"GitHub"},{"label":"GitLab","value":"GitLab"},{"label":"GLAbstraction","value":"GLAbstraction"},{"label":"GLBooks","value":"GLBooks"},{"label":"GLFW","value":"GLFW"},{"label":"GLM","value":"GLM"},{"label":"GLMNet","value":"GLMNet"},{"label":"Glob","value":"Glob"},{"label":"GLPK","value":"GLPK"},{"label":"GLPKMathProgInterface","value":"GLPKMathProgInterface"},{"label":"GLPlot","value":"GLPlot"},{"label":"GLText","value":"GLText"},{"label":"GLUT","value":"GLUT"},{"label":"GLVisualize","value":"GLVisualize"},{"label":"GLWindow","value":"GLWindow"},{"label":"GMT","value":"GMT"},{"label":"Gnuplot","value":"Gnuplot"},{"label":"GnuTLS","value":"GnuTLS"},{"label":"GoogleCharts","value":"GoogleCharts"},{"label":"GoogleCloud","value":"GoogleCloud"},{"label":"GPUArrays","value":"GPUArrays"},{"label":"GR","value":"GR"},{"label":"GracePlot","value":"GracePlot"},{"label":"GradDescent","value":"GradDescent"},{"label":"GradientBoost","value":"GradientBoost"},{"label":"Graft","value":"Graft"},{"label":"Graph500","value":"Graph500"},{"label":"GraphCentrality","value":"GraphCentrality"},{"label":"GraphGLRM","value":"GraphGLRM"},{"label":"Graphics","value":"Graphics"},{"label":"GraphIO","value":"GraphIO"},{"label":"GraphLayout","value":"GraphLayout"},{"label":"GraphMatrices","value":"GraphMatrices"},{"label":"GraphPlot","value":"GraphPlot"},{"label":"Graphs","value":"Graphs"},{"label":"GraphViz","value":"GraphViz"},{"label":"GreatCircle","value":"GreatCircle"},{"label":"Grid","value":"Grid"},{"label":"GridInterpolations","value":"GridInterpolations"},{"label":"GroupedErrors","value":"GroupedErrors"},{"label":"GroupSlices","value":"GroupSlices"},{"label":"GroveAlg","value":"GroveAlg"},{"label":"GrowableArrays","value":"GrowableArrays"},{"label":"GSDicts","value":"GSDicts"},{"label":"GSL","value":"GSL"},{"label":"GslibIO","value":"GslibIO"},{"label":"Gtk","value":"Gtk"},{"label":"GtkBuilderAid","value":"GtkBuilderAid"},{"label":"GtkReactive","value":"GtkReactive"},{"label":"GtkSourceWidget","value":"GtkSourceWidget"},{"label":"GtkUtilities","value":"GtkUtilities"},{"label":"GUITestRunner","value":"GUITestRunner"},{"label":"Gumbo","value":"Gumbo"},{"label":"Gunrock","value":"Gunrock"},{"label":"Gurobi","value":"Gurobi"},{"label":"GZip","value":"GZip"},{"label":"H5SectionsArrays","value":"H5SectionsArrays"},{"label":"Hadamard","value":"Hadamard"},{"label":"HarwellRutherfordBoeing","value":"HarwellRutherfordBoeing"},{"label":"HCubature","value":"HCubature"},{"label":"HDF5","value":"HDF5"},{"label":"HDFS","value":"HDFS"},{"label":"Hecke","value":"Hecke"},{"label":"Helpme","value":"Helpme"},{"label":"Hermetic","value":"Hermetic"},{"label":"Hexagons","value":"Hexagons"},{"label":"HexEdit","value":"HexEdit"},{"label":"Hiccup","value":"Hiccup"},{"label":"HiddenMarkovModels","value":"HiddenMarkovModels"},{"label":"HierarchicalMatrices","value":"HierarchicalMatrices"},{"label":"Highlights","value":"Highlights"},{"label":"HilbertSchmidtIndependenceCriterion","value":"HilbertSchmidtIndependenceCriterion"},{"label":"Hinton","value":"Hinton"},{"label":"HiRedis","value":"HiRedis"},{"label":"Hive","value":"Hive"},{"label":"Homebrew","value":"Homebrew"},{"label":"Hop","value":"Hop"},{"label":"HopfieldNets","value":"HopfieldNets"},{"label":"HPack","value":"HPack"},{"label":"HPAT","value":"HPAT"},{"label":"HSA","value":"HSA"},{"label":"HTSLIB","value":"HTSLIB"},{"label":"HTTP","value":"HTTP"},{"label":"HTTP2","value":"HTTP2"},{"label":"HTTPClient","value":"HTTPClient"},{"label":"HttpCommon","value":"HttpCommon"},{"label":"HttpParser","value":"HttpParser"},{"label":"HttpServer","value":"HttpServer"},{"label":"Humanize","value":"Humanize"},{"label":"Hungarian","value":"Hungarian"},{"label":"Hwloc","value":"Hwloc"},{"label":"HyperDualNumbers","value":"HyperDualNumbers"},{"label":"HyperLogLog","value":"HyperLogLog"},{"label":"HypothesisTests","value":"HypothesisTests"},{"label":"ICOADSDict","value":"ICOADSDict"},{"label":"ICU","value":"ICU"},{"label":"IdentityRanges","value":"IdentityRanges"},{"label":"IDRsSolver","value":"IDRsSolver"},{"label":"IDXParser","value":"IDXParser"},{"label":"IJulia","value":"IJulia"},{"label":"IJuliaPortrayals","value":"IJuliaPortrayals"},{"label":"ImageAxes","value":"ImageAxes"},{"label":"ImageCore","value":"ImageCore"},{"label":"ImageDraw","value":"ImageDraw"},{"label":"ImageFeatures","value":"ImageFeatures"},{"label":"ImageFiltering","value":"ImageFiltering"},{"label":"ImageInTerminal","value":"ImageInTerminal"},{"label":"ImageMagick","value":"ImageMagick"},{"label":"ImageMetadata","value":"ImageMetadata"},{"label":"ImageMorphology","value":"ImageMorphology"},{"label":"ImageProjectiveGeometry","value":"ImageProjectiveGeometry"},{"label":"ImageQuilting","value":"ImageQuilting"},{"label":"ImageRegistration","value":"ImageRegistration"},{"label":"Images","value":"Images"},{"label":"ImageSegmentation","value":"ImageSegmentation"},{"label":"ImageTransformations","value":"ImageTransformations"},{"label":"ImageView","value":"ImageView"},{"label":"ImagineFormat","value":"ImagineFormat"},{"label":"Immerse","value":"Immerse"},{"label":"ImmutableArrays","value":"ImmutableArrays"},{"label":"ImplicitEquations","value":"ImplicitEquations"},{"label":"ImputeNaNs","value":"ImputeNaNs"},{"label":"IncGammaBeta","value":"IncGammaBeta"},{"label":"IncrementalInference","value":"IncrementalInference"},{"label":"IndependentRandomSequences","value":"IndependentRandomSequences"},{"label":"IndexableBitVectors","value":"IndexableBitVectors"},{"label":"IndexedArrays","value":"IndexedArrays"},{"label":"IndexedTables","value":"IndexedTables"},{"label":"Indicators","value":"Indicators"},{"label":"IndirectArrays","value":"IndirectArrays"},{"label":"InformationMeasures","value":"InformationMeasures"},{"label":"InformedDifferentialEvolution","value":"InformedDifferentialEvolution"},{"label":"InfoZIP","value":"InfoZIP"},{"label":"IniFile","value":"IniFile"},{"label":"InplaceOps","value":"InplaceOps"},{"label":"InspectDR","value":"InspectDR"},{"label":"Instruments","value":"Instruments"},{"label":"IntArrays","value":"IntArrays"},{"label":"Interact","value":"Interact"},{"label":"InteractiveFixedEffectModels","value":"InteractiveFixedEffectModels"},{"label":"InterestRates","value":"InterestRates"},{"label":"Interfaces","value":"Interfaces"},{"label":"Interpolations","value":"Interpolations"},{"label":"IntervalArithmetic","value":"IntervalArithmetic"},{"label":"IntervalConstraintProgramming","value":"IntervalConstraintProgramming"},{"label":"IntervalContractors","value":"IntervalContractors"},{"label":"IntervalLinearEquations","value":"IntervalLinearEquations"},{"label":"IntervalOptimisation","value":"IntervalOptimisation"},{"label":"IntervalRootFinding","value":"IntervalRootFinding"},{"label":"IntervalSets","value":"IntervalSets"},{"label":"IntervalTrees","value":"IntervalTrees"},{"label":"IntervalWavelets","value":"IntervalWavelets"},{"label":"IntModN","value":"IntModN"},{"label":"InverseDistanceWeighting","value":"InverseDistanceWeighting"},{"label":"IOIndents","value":"IOIndents"},{"label":"IPNets","value":"IPNets"},{"label":"Ipopt","value":"Ipopt"},{"label":"IPPCore","value":"IPPCore"},{"label":"IPPDSP","value":"IPPDSP"},{"label":"IProfile","value":"IProfile"},{"label":"Isotonic","value":"Isotonic"},{"label":"ISPC","value":"ISPC"},{"label":"IterableTables","value":"IterableTables"},{"label":"IterationManagers","value":"IterationManagers"},{"label":"IterativeSolvers","value":"IterativeSolvers"},{"label":"Iterators","value":"Iterators"},{"label":"IterTools","value":"IterTools"},{"label":"Ito","value":"Ito"},{"label":"JACKAudio","value":"JACKAudio"},{"label":"Jackknife","value":"Jackknife"},{"label":"Jacobi","value":"Jacobi"},{"label":"Jags","value":"Jags"},{"label":"JavaCall","value":"JavaCall"},{"label":"JDBC","value":"JDBC"},{"label":"JellyFish","value":"JellyFish"},{"label":"Jewel","value":"Jewel"},{"label":"JFVM","value":"JFVM"},{"label":"JLD","value":"JLD"},{"label":"JLD2","value":"JLD2"},{"label":"JLDArchives","value":"JLDArchives"},{"label":"JointMoments","value":"JointMoments"},{"label":"JPLEphemeris","value":"JPLEphemeris"},{"label":"JSON","value":"JSON"},{"label":"JudyDicts","value":"JudyDicts"},{"label":"JuliaDB","value":"JuliaDB"},{"label":"JuliaFEM","value":"JuliaFEM"},{"label":"JuliaKara","value":"JuliaKara"},{"label":"JuliaParser","value":"JuliaParser"},{"label":"JuliaWebAPI","value":"JuliaWebAPI"},{"label":"JuliaWebRepl","value":"JuliaWebRepl"},{"label":"JulieTest","value":"JulieTest"},{"label":"JuLIP","value":"JuLIP"},{"label":"Julz","value":"Julz"},{"label":"Jumos","value":"Jumos"},{"label":"JuMP","value":"JuMP"},{"label":"JuMPChance","value":"JuMPChance"},{"label":"JuMPeR","value":"JuMPeR"},{"label":"Juno","value":"Juno"},{"label":"Jute","value":"Jute"},{"label":"JWAS","value":"JWAS"},{"label":"Kafka","value":"Kafka"},{"label":"KCores","value":"KCores"},{"label":"KDTrees","value":"KDTrees"},{"label":"KernelDensity","value":"KernelDensity"},{"label":"KernelDensityEstimate","value":"KernelDensityEstimate"},{"label":"KernelEstimator","value":"KernelEstimator"},{"label":"KernSmooth","value":"KernSmooth"},{"label":"Klara","value":"Klara"},{"label":"KLDivergence","value":"KLDivergence"},{"label":"Knet","value":"Knet"},{"label":"KNITRO","value":"KNITRO"},{"label":"kNN","value":"kNN"},{"label":"Kpax3","value":"Kpax3"},{"label":"Kriging","value":"Kriging"},{"label":"KrylovMethods","value":"KrylovMethods"},{"label":"KShiftsClustering","value":"KShiftsClustering"},{"label":"KSVD","value":"KSVD"},{"label":"KyotoCabinet","value":"KyotoCabinet"},{"label":"LabelNumerals","value":"LabelNumerals"},{"label":"LambertW","value":"LambertW"},{"label":"Languages","value":"Languages"},{"label":"LanguageServer","value":"LanguageServer"},{"label":"Laplacians","value":"Laplacians"},{"label":"LARS","value":"LARS"},{"label":"LasIO","value":"LasIO"},{"label":"Lasso","value":"Lasso"},{"label":"LaTeX","value":"LaTeX"},{"label":"LatexPrint","value":"LatexPrint"},{"label":"LaTeXStrings","value":"LaTeXStrings"},{"label":"Lazy","value":"Lazy"},{"label":"LazyCall","value":"LazyCall"},{"label":"LazyContext","value":"LazyContext"},{"label":"LazyQuery","value":"LazyQuery"},{"label":"LazySequences","value":"LazySequences"},{"label":"LCA","value":"LCA"},{"label":"LCIO","value":"LCIO"},{"label":"LCMCore","value":"LCMCore"},{"label":"LCMGL","value":"LCMGL"},{"label":"LearnBase","value":"LearnBase"},{"label":"LearningStrategies","value":"LearningStrategies"},{"label":"LeastSquaresOptim","value":"LeastSquaresOptim"},{"label":"LegacyStrings","value":"LegacyStrings"},{"label":"Lens","value":"Lens"},{"label":"LevelDB","value":"LevelDB"},{"label":"Levenshtein","value":"Levenshtein"},{"label":"Lexicon","value":"Lexicon"},{"label":"LibArchive","value":"LibArchive"},{"label":"LibBSON","value":"LibBSON"},{"label":"LibCloud","value":"LibCloud"},{"label":"LibCURL","value":"LibCURL"},{"label":"LibExpat","value":"LibExpat"},{"label":"LibGEOS","value":"LibGEOS"},{"label":"LibGit2","value":"LibGit2"},{"label":"LibHealpix","value":"LibHealpix"},{"label":"LIBLINEAR","value":"LIBLINEAR"},{"label":"LibPSF","value":"LibPSF"},{"label":"LibSndFile","value":"LibSndFile"},{"label":"LIBSVM","value":"LIBSVM"},{"label":"LibTrading","value":"LibTrading"},{"label":"Libz","value":"Libz"},{"label":"LifeTable","value":"LifeTable"},{"label":"LightGraphs","value":"LightGraphs"},{"label":"LightGraphsExtras","value":"LightGraphsExtras"},{"label":"LightXML","value":"LightXML"},{"label":"LinearLeastSquares","value":"LinearLeastSquares"},{"label":"LinearMaps","value":"LinearMaps"},{"label":"LinearOperators","value":"LinearOperators"},{"label":"LinearResponseVariationalBayes","value":"LinearResponseVariationalBayes"},{"label":"LineEdit","value":"LineEdit"},{"label":"LineSearches","value":"LineSearches"},{"label":"LinguisticData","value":"LinguisticData"},{"label":"LinkedLists","value":"LinkedLists"},{"label":"Lint","value":"Lint"},{"label":"LispSyntax","value":"LispSyntax"},{"label":"LittleEndianBase128","value":"LittleEndianBase128"},{"label":"LLLplus","value":"LLLplus"},{"label":"LLVM","value":"LLVM"},{"label":"LMDB","value":"LMDB"},{"label":"LNR","value":"LNR"},{"label":"Loess","value":"Loess"},{"label":"LoggedDicts","value":"LoggedDicts"},{"label":"Logging","value":"Logging"},{"label":"LogParser","value":"LogParser"},{"label":"LombScargle","value":"LombScargle"},{"label":"LoopThrottle","value":"LoopThrottle"},{"label":"Lora","value":"Lora"},{"label":"Loss","value":"Loss"},{"label":"LossFunctions","value":"LossFunctions"},{"label":"LowDimNearestNeighbors","value":"LowDimNearestNeighbors"},{"label":"LowRankApprox","value":"LowRankApprox"},{"label":"LowRankModels","value":"LowRankModels"},{"label":"LPVSpectral","value":"LPVSpectral"},{"label":"LRSLib","value":"LRSLib"},{"label":"LRUCache","value":"LRUCache"},{"label":"LSODA","value":"LSODA"},{"label":"LsqFit","value":"LsqFit"},{"label":"LTISystems","value":"LTISystems"},{"label":"Lumberjack","value":"Lumberjack"},{"label":"Lumira","value":"Lumira"},{"label":"Luxor","value":"Luxor"},{"label":"MachineLearning","value":"MachineLearning"},{"label":"MachineLearningMetrics","value":"MachineLearningMetrics"},{"label":"MachO","value":"MachO"},{"label":"MacroTools","value":"MacroTools"},{"label":"Mads","value":"Mads"},{"label":"Maker","value":"Maker"},{"label":"Mamba","value":"Mamba"},{"label":"Mandrill","value":"Mandrill"},{"label":"ManifoldLearning","value":"ManifoldLearning"},{"label":"MapLight","value":"MapLight"},{"label":"MappedArrays","value":"MappedArrays"},{"label":"Markdown","value":"Markdown"},{"label":"MarketData","value":"MarketData"},{"label":"MarketTechnicals","value":"MarketTechnicals"},{"label":"MarkovTransitionMatrices","value":"MarkovTransitionMatrices"},{"label":"MAT","value":"MAT"},{"label":"Match","value":"Match"},{"label":"Matcha","value":"Matcha"},{"label":"Mathematica","value":"Mathematica"},{"label":"MathLink","value":"MathLink"},{"label":"MathProgBase","value":"MathProgBase"},{"label":"MathToolkit","value":"MathToolkit"},{"label":"MATLAB","value":"MATLAB"},{"label":"MATLABCluster","value":"MATLABCluster"},{"label":"MatlabCompat","value":"MatlabCompat"},{"label":"MatpowerCases","value":"MatpowerCases"},{"label":"MatrixChainMultiply","value":"MatrixChainMultiply"},{"label":"MatrixDepot","value":"MatrixDepot"},{"label":"MatrixMarket","value":"MatrixMarket"},{"label":"MatrixNetworks","value":"MatrixNetworks"},{"label":"Maxima","value":"Maxima"},{"label":"Mayday","value":"Mayday"},{"label":"MbedTLS","value":"MbedTLS"},{"label":"MCMC","value":"MCMC"},{"label":"MDCT","value":"MDCT"},{"label":"MDPs","value":"MDPs"},{"label":"Measurements","value":"Measurements"},{"label":"Measures","value":"Measures"},{"label":"MeCab","value":"MeCab"},{"label":"Meddle","value":"Meddle"},{"label":"Media","value":"Media"},{"label":"MelGeneralizedCepstrums","value":"MelGeneralizedCepstrums"},{"label":"Memcache","value":"Memcache"},{"label":"Memento","value":"Memento"},{"label":"Memoize","value":"Memoize"},{"label":"MemPool","value":"MemPool"},{"label":"MergedMethods","value":"MergedMethods"},{"label":"Merly","value":"Merly"},{"label":"Meshes","value":"Meshes"},{"label":"Meshing","value":"Meshing"},{"label":"MeshIO","value":"MeshIO"},{"label":"MessageUtils","value":"MessageUtils"},{"label":"MetadataTools","value":"MetadataTools"},{"label":"MetaGraphs","value":"MetaGraphs"},{"label":"MetaImageFormat","value":"MetaImageFormat"},{"label":"Metamath","value":"Metamath"},{"label":"MetaProgTools","value":"MetaProgTools"},{"label":"MetaTools","value":"MetaTools"},{"label":"Metis","value":"Metis"},{"label":"MFCC","value":"MFCC"},{"label":"Microeconometrics","value":"Microeconometrics"},{"label":"MicroLogging","value":"MicroLogging"},{"label":"MIDI","value":"MIDI"},{"label":"Millboard","value":"Millboard"},{"label":"Mimi","value":"Mimi"},{"label":"Miniball","value":"Miniball"},{"label":"MiniLogging","value":"MiniLogging"},{"label":"MinimalPerfectHashes","value":"MinimalPerfectHashes"},{"label":"MINPACK","value":"MINPACK"},{"label":"MIToS","value":"MIToS"},{"label":"MixedModels","value":"MixedModels"},{"label":"MixtureModels","value":"MixtureModels"},{"label":"MKLSparse","value":"MKLSparse"},{"label":"MLBase","value":"MLBase"},{"label":"MLDataPattern","value":"MLDataPattern"},{"label":"MLDataUtils","value":"MLDataUtils"},{"label":"MLKernels","value":"MLKernels"},{"label":"MLLabelUtils","value":"MLLabelUtils"},{"label":"MNIST","value":"MNIST"},{"label":"Mocha","value":"Mocha"},{"label":"Mocking","value":"Mocking"},{"label":"ModelReduction","value":"ModelReduction"},{"label":"ModernGL","value":"ModernGL"},{"label":"MolecularDataType","value":"MolecularDataType"},{"label":"MolecularDynamics","value":"MolecularDynamics"},{"label":"MolecularPDB","value":"MolecularPDB"},{"label":"Monads","value":"Monads"},{"label":"Mongo","value":"Mongo"},{"label":"Mongrel2","value":"Mongrel2"},{"label":"Morsel","value":"Morsel"},{"label":"Mortar2D","value":"Mortar2D"},{"label":"Mortar3D","value":"Mortar3D"},{"label":"Mosek","value":"Mosek"},{"label":"MotoServer","value":"MotoServer"},{"label":"MP3","value":"MP3"},{"label":"MPFI","value":"MPFI"},{"label":"MPI","value":"MPI"},{"label":"mPulseAPI","value":"mPulseAPI"},{"label":"MsgPack","value":"MsgPack"},{"label":"MsgPackRpcClient","value":"MsgPackRpcClient"},{"label":"MsgPackRpcServer","value":"MsgPackRpcServer"},{"label":"MuKanren","value":"MuKanren"},{"label":"MuladdMacro","value":"MuladdMacro"},{"label":"MultidimensionalTables","value":"MultidimensionalTables"},{"label":"MultiNest","value":"MultiNest"},{"label":"MultipleTesting","value":"MultipleTesting"},{"label":"MultiPoly","value":"MultiPoly"},{"label":"Multirate","value":"Multirate"},{"label":"MultiScaleArrays","value":"MultiScaleArrays"},{"label":"Multisets","value":"Multisets"},{"label":"MultivariateAnomalies","value":"MultivariateAnomalies"},{"label":"MultivariateMoments","value":"MultivariateMoments"},{"label":"MultivariatePolynomials","value":"MultivariatePolynomials"},{"label":"MultivariateStats","value":"MultivariateStats"},{"label":"MUMPS","value":"MUMPS"},{"label":"Munkres","value":"Munkres"},{"label":"Murmur3","value":"Murmur3"},{"label":"Mustache","value":"Mustache"},{"label":"MutableStrings","value":"MutableStrings"},{"label":"Mux","value":"Mux"},{"label":"MXNet","value":"MXNet"},{"label":"MySQL","value":"MySQL"},{"label":"NaiveBayes","value":"NaiveBayes"},{"label":"Named","value":"Named"},{"label":"NamedArrays","value":"NamedArrays"},{"label":"NamedColors","value":"NamedColors"},{"label":"NamedDimensions","value":"NamedDimensions"},{"label":"NamedTuples","value":"NamedTuples"},{"label":"NaNMath","value":"NaNMath"},{"label":"Napier","value":"Napier"},{"label":"NaturalSort","value":"NaturalSort"},{"label":"NBInclude","value":"NBInclude"},{"label":"NBTesting","value":"NBTesting"},{"label":"NCDatasets","value":"NCDatasets"},{"label":"NearestNeighbors","value":"NearestNeighbors"},{"label":"Nemo","value":"Nemo"},{"label":"Neo4j","value":"Neo4j"},{"label":"NEOS","value":"NEOS"},{"label":"Neovim","value":"Neovim"},{"label":"NetCDF","value":"NetCDF"},{"label":"Netpbm","value":"Netpbm"},{"label":"Nettle","value":"Nettle"},{"label":"NetworkFlows","value":"NetworkFlows"},{"label":"NetworkInference","value":"NetworkInference"},{"label":"NetworkLayout","value":"NetworkLayout"},{"label":"NetworkViz","value":"NetworkViz"},{"label":"NeuralynxNCS","value":"NeuralynxNCS"},{"label":"NFFT","value":"NFFT"},{"label":"NHST","value":"NHST"},{"label":"NIDAQ","value":"NIDAQ"},{"label":"NIfTI","value":"NIfTI"},{"label":"NKLandscapes","value":"NKLandscapes"},{"label":"NLopt","value":"NLopt"},{"label":"NLOptControl","value":"NLOptControl"},{"label":"NLPModels","value":"NLPModels"},{"label":"NLreg","value":"NLreg"},{"label":"NLsolve","value":"NLsolve"},{"label":"NLSolversBase","value":"NLSolversBase"},{"label":"NMEA","value":"NMEA"},{"label":"NMF","value":"NMF"},{"label":"NNlib","value":"NNlib"},{"label":"NOAAData","value":"NOAAData"},{"label":"NodeJS","value":"NodeJS"},{"label":"NodeNumbering","value":"NodeNumbering"},{"label":"NonNegLeastSquares","value":"NonNegLeastSquares"},{"label":"NormalizeQuantiles","value":"NormalizeQuantiles"},{"label":"NoveltyColors","value":"NoveltyColors"},{"label":"NPZ","value":"NPZ"},{"label":"NRRD","value":"NRRD"},{"label":"NullableArrays","value":"NullableArrays"},{"label":"Nulls","value":"Nulls"},{"label":"NumberedLines","value":"NumberedLines"},{"label":"NumericalIntegration","value":"NumericalIntegration"},{"label":"NumericExtensions","value":"NumericExtensions"},{"label":"NumericFuns","value":"NumericFuns"},{"label":"NumericIO","value":"NumericIO"},{"label":"NumericSuffixes","value":"NumericSuffixes"},{"label":"NumFormat","value":"NumFormat"},{"label":"NURBS","value":"NURBS"},{"label":"OAuth","value":"OAuth"},{"label":"ObjectiveC","value":"ObjectiveC"},{"label":"ObjFileBase","value":"ObjFileBase"},{"label":"Observables","value":"Observables"},{"label":"OCCA","value":"OCCA"},{"label":"ODBC","value":"ODBC"},{"label":"ODE","value":"ODE"},{"label":"ODEInterface","value":"ODEInterface"},{"label":"ODEInterfaceDiffEq","value":"ODEInterfaceDiffEq"},{"label":"OdsIO","value":"OdsIO"},{"label":"OEIS","value":"OEIS"},{"label":"OffsetArrays","value":"OffsetArrays"},{"label":"Ogg","value":"Ogg"},{"label":"OhMyREPL","value":"OhMyREPL"},{"label":"OIFITS","value":"OIFITS"},{"label":"OMETIFF","value":"OMETIFF"},{"label":"OnlineMoments","value":"OnlineMoments"},{"label":"OnlineStats","value":"OnlineStats"},{"label":"OnlineStatsBase","value":"OnlineStatsBase"},{"label":"OOPMacro","value":"OOPMacro"},{"label":"OpenCL","value":"OpenCL"},{"label":"OpenDSSDirect","value":"OpenDSSDirect"},{"label":"OpenEphysLoader","value":"OpenEphysLoader"},{"label":"OpenFOAM","value":"OpenFOAM"},{"label":"OpenGene","value":"OpenGene"},{"label":"OpenGL","value":"OpenGL"},{"label":"OpenSecrets","value":"OpenSecrets"},{"label":"OpenSlide","value":"OpenSlide"},{"label":"OpenSSL","value":"OpenSSL"},{"label":"OpenStreetMap","value":"OpenStreetMap"},{"label":"Optim","value":"Optim"},{"label":"OptimBase","value":"OptimBase"},{"label":"OptiMimi","value":"OptiMimi"},{"label":"OptimPack","value":"OptimPack"},{"label":"OptimTestProblems","value":"OptimTestProblems"},{"label":"OptionalData","value":"OptionalData"},{"label":"Options","value":"Options"},{"label":"Opus","value":"Opus"},{"label":"Orchestra","value":"Orchestra"},{"label":"OrdinaryDiffEq","value":"OrdinaryDiffEq"},{"label":"OSC","value":"OSC"},{"label":"OSXNotifier","value":"OSXNotifier"},{"label":"PackageGenerator","value":"PackageGenerator"},{"label":"Packing","value":"Packing"},{"label":"PaddedViews","value":"PaddedViews"},{"label":"Pages","value":"Pages"},{"label":"PAINTER","value":"PAINTER"},{"label":"PairwiseListMatrices","value":"PairwiseListMatrices"},{"label":"Pajarito","value":"Pajarito"},{"label":"Pandas","value":"Pandas"},{"label":"ParallelAccelerator","value":"ParallelAccelerator"},{"label":"ParallelDataTransfer","value":"ParallelDataTransfer"},{"label":"ParallelSparseMatMul","value":"ParallelSparseMatMul"},{"label":"ParameterizedFunctions","value":"ParameterizedFunctions"},{"label":"Parameters","value":"Parameters"},{"label":"Pardiso","value":"Pardiso"},{"label":"ParserCombinator","value":"ParserCombinator"},{"label":"ParSpMatVec","value":"ParSpMatVec"},{"label":"ParticleFilters","value":"ParticleFilters"},{"label":"Pastebin","value":"Pastebin"},{"label":"Patchwork","value":"Patchwork"},{"label":"PathDistribution","value":"PathDistribution"},{"label":"PATHSolver","value":"PATHSolver"},{"label":"PatternDispatch","value":"PatternDispatch"},{"label":"Pcap","value":"Pcap"},{"label":"PdbTool","value":"PdbTool"},{"label":"PDFIO","value":"PDFIO"},{"label":"PDMats","value":"PDMats"},{"label":"Pedigrees","value":"Pedigrees"},{"label":"PEG","value":"PEG"},{"label":"PEGParser","value":"PEGParser"},{"label":"PenaltyFunctions","value":"PenaltyFunctions"},{"label":"PerceptualColourMaps","value":"PerceptualColourMaps"},{"label":"Permutations","value":"Permutations"},{"label":"Persist","value":"Persist"},{"label":"PGFPlots","value":"PGFPlots"},{"label":"PGFPlotsX","value":"PGFPlotsX"},{"label":"PGM","value":"PGM"},{"label":"PhantomJS","value":"PhantomJS"},{"label":"Phonetics","value":"Phonetics"},{"label":"Phylo","value":"Phylo"},{"label":"Phylogenetics","value":"Phylogenetics"},{"label":"Phylogenies","value":"Phylogenies"},{"label":"PhyloModels","value":"PhyloModels"},{"label":"PhyloNetworks","value":"PhyloNetworks"},{"label":"PhyloTrees","value":"PhyloTrees"},{"label":"PhysOcean","value":"PhysOcean"},{"label":"PicoSAT","value":"PicoSAT"},{"label":"PiCraft","value":"PiCraft"},{"label":"PiecewiseAffineTransforms","value":"PiecewiseAffineTransforms"},{"label":"PiecewiseIncreasingRanges","value":"PiecewiseIncreasingRanges"},{"label":"PiecewiseLinearOpt","value":"PiecewiseLinearOpt"},{"label":"Pipe","value":"Pipe"},{"label":"PkgBenchmark","value":"PkgBenchmark"},{"label":"PkgDev","value":"PkgDev"},{"label":"PkgTemplates","value":"PkgTemplates"},{"label":"PlanOut","value":"PlanOut"},{"label":"Playground","value":"Playground"},{"label":"Plotly","value":"Plotly"},{"label":"PlotlyJS","value":"PlotlyJS"},{"label":"PlotRecipes","value":"PlotRecipes"},{"label":"Plots","value":"Plots"},{"label":"PlotThemes","value":"PlotThemes"},{"label":"PlotUtils","value":"PlotUtils"},{"label":"PLX","value":"PLX"},{"label":"PlyIO","value":"PlyIO"},{"label":"PolarFact","value":"PolarFact"},{"label":"Poltergeist","value":"Poltergeist"},{"label":"Polyglot","value":"Polyglot"},{"label":"Polyhedra","value":"Polyhedra"},{"label":"PolyJuMP","value":"PolyJuMP"},{"label":"Polynomial","value":"Polynomial"},{"label":"PolynomialFactors","value":"PolynomialFactors"},{"label":"PolynomialMatrices","value":"PolynomialMatrices"},{"label":"PolynomialRoots","value":"PolynomialRoots"},{"label":"Polynomials","value":"Polynomials"},{"label":"PolynomialZeros","value":"PolynomialZeros"},{"label":"POMDPModels","value":"POMDPModels"},{"label":"POMDPs","value":"POMDPs"},{"label":"POMDPToolbox","value":"POMDPToolbox"},{"label":"PooledArrays","value":"PooledArrays"},{"label":"PortableGameNotation","value":"PortableGameNotation"},{"label":"PortAudio","value":"PortAudio"},{"label":"PositiveFactorizations","value":"PositiveFactorizations"},{"label":"PowerLaws","value":"PowerLaws"},{"label":"PowerModels","value":"PowerModels"},{"label":"PowerModelsAnnex","value":"PowerModelsAnnex"},{"label":"PowerSeries","value":"PowerSeries"},{"label":"PrettyNumber","value":"PrettyNumber"},{"label":"PrettyPlots","value":"PrettyPlots"},{"label":"Primes","value":"Primes"},{"label":"PrivateModules","value":"PrivateModules"},{"label":"PrivateMultiplicativeWeights","value":"PrivateMultiplicativeWeights"},{"label":"Processing","value":"Processing"},{"label":"ProfileView","value":"ProfileView"},{"label":"ProgressiveAligner","value":"ProgressiveAligner"},{"label":"ProgressMeter","value":"ProgressMeter"},{"label":"Proj4","value":"Proj4"},{"label":"ProjectiveDictionaryPairLearning","value":"ProjectiveDictionaryPairLearning"},{"label":"ProjectTemplate","value":"ProjectTemplate"},{"label":"PropertyGraph","value":"PropertyGraph"},{"label":"ProteinEnsembles","value":"ProteinEnsembles"},{"label":"ProtoBuf","value":"ProtoBuf"},{"label":"ProximalBase","value":"ProximalBase"},{"label":"ProximalOperators","value":"ProximalOperators"},{"label":"Psychro","value":"Psychro"},{"label":"PtFEM","value":"PtFEM"},{"label":"PTools","value":"PTools"},{"label":"PublicSuffix","value":"PublicSuffix"},{"label":"Push","value":"Push"},{"label":"Pushover","value":"Pushover"},{"label":"PValueAdjust","value":"PValueAdjust"},{"label":"PyAMG","value":"PyAMG"},{"label":"PyCall","value":"PyCall"},{"label":"PyCallJLD","value":"PyCallJLD"},{"label":"PyDSTool","value":"PyDSTool"},{"label":"PyLCM","value":"PyLCM"},{"label":"PyLexYacc","value":"PyLexYacc"},{"label":"PyLogging","value":"PyLogging"},{"label":"PyPlot","value":"PyPlot"},{"label":"PyProj","value":"PyProj"},{"label":"Pyramids","value":"Pyramids"},{"label":"PySide","value":"PySide"},{"label":"PySyntax","value":"PySyntax"},{"label":"PyTest","value":"PyTest"},{"label":"PyX","value":"PyX"},{"label":"Q","value":"Q"},{"label":"QDates","value":"QDates"},{"label":"QDXML","value":"QDXML"},{"label":"QML","value":"QML"},{"label":"QNaNs","value":"QNaNs"},{"label":"QRupdate","value":"QRupdate"},{"label":"QuadGK","value":"QuadGK"},{"label":"Quandl","value":"Quandl"},{"label":"QuantEcon","value":"QuantEcon"},{"label":"QuantumBayesian","value":"QuantumBayesian"},{"label":"QuantumInfo","value":"QuantumInfo"},{"label":"QuantumLab","value":"QuantumLab"},{"label":"QuantumOptics","value":"QuantumOptics"},{"label":"QuantumTomography","value":"QuantumTomography"},{"label":"QuartzImageIO","value":"QuartzImageIO"},{"label":"Quaternions","value":"Quaternions"},{"label":"QuDirac","value":"QuDirac"},{"label":"Query","value":"Query"},{"label":"QueryOperators","value":"QueryOperators"},{"label":"Queueing","value":"Queueing"},{"label":"QuickCheck","value":"QuickCheck"},{"label":"QuickHull","value":"QuickHull"},{"label":"QuickShiftClustering","value":"QuickShiftClustering"},{"label":"QuickTypes","value":"QuickTypes"},{"label":"QuTiP","value":"QuTiP"},{"label":"Qwt","value":"Qwt"},{"label":"QWTwPlot","value":"QWTwPlot"},{"label":"RaggedArrays","value":"RaggedArrays"},{"label":"Rainflow","value":"Rainflow"},{"label":"RandomCorrelationMatrices","value":"RandomCorrelationMatrices"},{"label":"RandomFerns","value":"RandomFerns"},{"label":"RandomMatrices","value":"RandomMatrices"},{"label":"RandomNumbers","value":"RandomNumbers"},{"label":"RandomQuantum","value":"RandomQuantum"},{"label":"RangeArrays","value":"RangeArrays"},{"label":"Ranges","value":"Ranges"},{"label":"RationalExtensions","value":"RationalExtensions"},{"label":"RationalFunctions","value":"RationalFunctions"},{"label":"Ratios","value":"Ratios"},{"label":"RawArray","value":"RawArray"},{"label":"RayTraceEllipsoid","value":"RayTraceEllipsoid"},{"label":"RCall","value":"RCall"},{"label":"RData","value":"RData"},{"label":"RDatasets","value":"RDatasets"},{"label":"RDF","value":"RDF"},{"label":"RdRand","value":"RdRand"},{"label":"React","value":"React"},{"label":"Reactive","value":"Reactive"},{"label":"ReactiveBasics","value":"ReactiveBasics"},{"label":"ReadableNumbers","value":"ReadableNumbers"},{"label":"ReadStat","value":"ReadStat"},{"label":"ReadWriteDlm2","value":"ReadWriteDlm2"},{"label":"ReadWriteLocks","value":"ReadWriteLocks"},{"label":"RealInterface","value":"RealInterface"},{"label":"RecipesBase","value":"RecipesBase"},{"label":"Recommendation","value":"Recommendation"},{"label":"RecurrenceAnalysis","value":"RecurrenceAnalysis"},{"label":"RecursiveArrayTools","value":"RecursiveArrayTools"},{"label":"RecurUnroll","value":"RecurUnroll"},{"label":"Redis","value":"Redis"},{"label":"Reduce","value":"Reduce"},{"label":"Reel","value":"Reel"},{"label":"Reexport","value":"Reexport"},{"label":"ReferenceTests","value":"ReferenceTests"},{"label":"RegERMs","value":"RegERMs"},{"label":"RegionTrees","value":"RegionTrees"},{"label":"Regression","value":"Regression"},{"label":"Reinforce","value":"Reinforce"},{"label":"Remez","value":"Remez"},{"label":"RemoteFiles","value":"RemoteFiles"},{"label":"REPL","value":"REPL"},{"label":"REPLCompletions","value":"REPLCompletions"},{"label":"Requests","value":"Requests"},{"label":"RequestsCache","value":"RequestsCache"},{"label":"RequiredKeywords","value":"RequiredKeywords"},{"label":"RequirementVersions","value":"RequirementVersions"},{"label":"Requires","value":"Requires"},{"label":"Resampling","value":"Resampling"},{"label":"ResettableStacks","value":"ResettableStacks"},{"label":"Restful","value":"Restful"},{"label":"RestrictProlong","value":"RestrictProlong"},{"label":"ResultTypes","value":"ResultTypes"},{"label":"ResumableFunctions","value":"ResumableFunctions"},{"label":"Retry","value":"Retry"},{"label":"ReusableFunctions","value":"ReusableFunctions"},{"label":"Revealables","value":"Revealables"},{"label":"ReverseDiff","value":"ReverseDiff"},{"label":"ReverseDiffOverload","value":"ReverseDiffOverload"},{"label":"ReverseDiffSource","value":"ReverseDiffSource"},{"label":"ReverseDiffSparse","value":"ReverseDiffSparse"},{"label":"Revise","value":"Revise"},{"label":"RiemannComplexNumbers","value":"RiemannComplexNumbers"},{"label":"Rif","value":"Rif"},{"label":"RigidBodyDynamics","value":"RigidBodyDynamics"},{"label":"RigidBodyTreeInspector","value":"RigidBodyTreeInspector"},{"label":"RingArrays","value":"RingArrays"},{"label":"RingBuffers","value":"RingBuffers"},{"label":"RLEVectors","value":"RLEVectors"},{"label":"Rmath","value":"Rmath"},{"label":"RNGTest","value":"RNGTest"},{"label":"Robotlib","value":"Robotlib"},{"label":"RobotOS","value":"RobotOS"},{"label":"RobustLeastSquares","value":"RobustLeastSquares"},{"label":"RobustPmap","value":"RobustPmap"},{"label":"RobustShortestPath","value":"RobustShortestPath"},{"label":"RobustStats","value":"RobustStats"},{"label":"ROCAnalysis","value":"ROCAnalysis"},{"label":"RollingFunctions","value":"RollingFunctions"},{"label":"RomanNumerals","value":"RomanNumerals"},{"label":"RoME","value":"RoME"},{"label":"ROOT","value":"ROOT"},{"label":"Roots","value":"Roots"},{"label":"Rotations","value":"Rotations"},{"label":"RouletteWheels","value":"RouletteWheels"},{"label":"RoundingIntegers","value":"RoundingIntegers"},{"label":"RowEchelon","value":"RowEchelon"},{"label":"RRRMC","value":"RRRMC"},{"label":"Rsvg","value":"Rsvg"},{"label":"RudeOil","value":"RudeOil"},{"label":"RunTests","value":"RunTests"},{"label":"S3Dicts","value":"S3Dicts"},{"label":"SALSA","value":"SALSA"},{"label":"SampledSignals","value":"SampledSignals"},{"label":"Sampling","value":"Sampling"},{"label":"SaveREPL","value":"SaveREPL"},{"label":"SchattenNorms","value":"SchattenNorms"},{"label":"SchumakerSpline","value":"SchumakerSpline"},{"label":"ScikitLearn","value":"ScikitLearn"},{"label":"ScikitLearnBase","value":"ScikitLearnBase"},{"label":"SCIP","value":"SCIP"},{"label":"SCS","value":"SCS"},{"label":"SDE","value":"SDE"},{"label":"SDL","value":"SDL"},{"label":"SDWBA","value":"SDWBA"},{"label":"Seaborn","value":"Seaborn"},{"label":"SecureSessions","value":"SecureSessions"},{"label":"Seismic","value":"Seismic"},{"label":"SemialgebraicSets","value":"SemialgebraicSets"},{"label":"SemidefiniteModel","value":"SemidefiniteModel"},{"label":"SemidefiniteModels","value":"SemidefiniteModels"},{"label":"SemidefiniteProgramming","value":"SemidefiniteProgramming"},{"label":"SenseHat","value":"SenseHat"},{"label":"SeqMaker","value":"SeqMaker"},{"label":"SerialPorts","value":"SerialPorts"},{"label":"SFML","value":"SFML"},{"label":"SGDOptim","value":"SGDOptim"},{"label":"SGP4","value":"SGP4"},{"label":"SHA","value":"SHA"},{"label":"Shannon","value":"Shannon"},{"label":"Shapefile","value":"Shapefile"},{"label":"ShapeModels","value":"ShapeModels"},{"label":"Shearlab","value":"Shearlab"},{"label":"Shoco","value":"Shoco"},{"label":"ShowItLikeYouBuildIt","value":"ShowItLikeYouBuildIt"},{"label":"Showoff","value":"Showoff"},{"label":"ShowSet","value":"ShowSet"},{"label":"Sigma","value":"Sigma"},{"label":"SigmoidalProgramming","value":"SigmoidalProgramming"},{"label":"SignalView","value":"SignalView"},{"label":"SignedDistanceFields","value":"SignedDistanceFields"},{"label":"Silo","value":"Silo"},{"label":"SIMD","value":"SIMD"},{"label":"SimilaritySearch","value":"SimilaritySearch"},{"label":"SimJulia","value":"SimJulia"},{"label":"SimpleStructs","value":"SimpleStructs"},{"label":"SimpleTasks","value":"SimpleTasks"},{"label":"SimpleTraits","value":"SimpleTraits"},{"label":"SimpleWeightedGraphs","value":"SimpleWeightedGraphs"},{"label":"Sims","value":"Sims"},{"label":"SingularIntegralEquations","value":"SingularIntegralEquations"},{"label":"SingularSpectrumAnalysis","value":"SingularSpectrumAnalysis"},{"label":"SIUnits","value":"SIUnits"},{"label":"SkyCoords","value":"SkyCoords"},{"label":"SLHA","value":"SLHA"},{"label":"SliceSampler","value":"SliceSampler"},{"label":"SloanDigitalSkySurvey","value":"SloanDigitalSkySurvey"},{"label":"Slugify","value":"Slugify"},{"label":"Smile","value":"Smile"},{"label":"SmoothingKernels","value":"SmoothingKernels"},{"label":"SmoothingSplines","value":"SmoothingSplines"},{"label":"SMTPClient","value":"SMTPClient"},{"label":"SNAPDatasets","value":"SNAPDatasets"},{"label":"Snappy","value":"Snappy"},{"label":"SnFFT","value":"SnFFT"},{"label":"SnoopCompile","value":"SnoopCompile"},{"label":"SnowballStemmer","value":"SnowballStemmer"},{"label":"Sobol","value":"Sobol"},{"label":"Sodium","value":"Sodium"},{"label":"SoftConfidenceWeighted","value":"SoftConfidenceWeighted"},{"label":"SolarSystemLib","value":"SolarSystemLib"},{"label":"SolveBio","value":"SolveBio"},{"label":"SolveDSGE","value":"SolveDSGE"},{"label":"SortingAlgorithms","value":"SortingAlgorithms"},{"label":"SortingNetworks","value":"SortingNetworks"},{"label":"SortPerf","value":"SortPerf"},{"label":"Soundex","value":"Soundex"},{"label":"Spark","value":"Spark"},{"label":"Sparklines","value":"Sparklines"},{"label":"Sparrow","value":"Sparrow"},{"label":"SparseGrids","value":"SparseGrids"},{"label":"SparseVectors","value":"SparseVectors"},{"label":"SpatialEcology","value":"SpatialEcology"},{"label":"SpecialFunctions","value":"SpecialFunctions"},{"label":"SpecialMatrices","value":"SpecialMatrices"},{"label":"Spectra","value":"Spectra"},{"label":"SpeedDate","value":"SpeedDate"},{"label":"SpiceData","value":"SpiceData"},{"label":"SpikingNetworks","value":"SpikingNetworks"},{"label":"SPTK","value":"SPTK"},{"label":"SQLite","value":"SQLite"},{"label":"SQSChannels","value":"SQSChannels"},{"label":"StackedNets","value":"StackedNets"},{"label":"StackTraces","value":"StackTraces"},{"label":"Stan","value":"Stan"},{"label":"StandardizedMatrices","value":"StandardizedMatrices"},{"label":"StatefulIterators","value":"StatefulIterators"},{"label":"StateSpaceRoutines","value":"StateSpaceRoutines"},{"label":"StatFiles","value":"StatFiles"},{"label":"StaticArrays","value":"StaticArrays"},{"label":"StatPlots","value":"StatPlots"},{"label":"StatProfilerHTML","value":"StatProfilerHTML"},{"label":"Stats","value":"Stats"},{"label":"StatsBase","value":"StatsBase"},{"label":"StatsdClient","value":"StatsdClient"},{"label":"StatsFuns","value":"StatsFuns"},{"label":"StatsModels","value":"StatsModels"},{"label":"SteadyStateDiffEq","value":"SteadyStateDiffEq"},{"label":"SteinDiscrepancy","value":"SteinDiscrepancy"},{"label":"StingerGraphs","value":"StingerGraphs"},{"label":"StochasticDiffEq","value":"StochasticDiffEq"},{"label":"StochasticSearch","value":"StochasticSearch"},{"label":"StochDynamicProgramming","value":"StochDynamicProgramming"},{"label":"Stochy","value":"Stochy"},{"label":"StokesDiffEq","value":"StokesDiffEq"},{"label":"StreamStats","value":"StreamStats"},{"label":"StringDistances","value":"StringDistances"},{"label":"StringEncodings","value":"StringEncodings"},{"label":"StringInterpolation","value":"StringInterpolation"},{"label":"StrPack","value":"StrPack"},{"label":"StructDualDynProg","value":"StructDualDynProg"},{"label":"StructIO","value":"StructIO"},{"label":"StructJuMP","value":"StructJuMP"},{"label":"StructsOfArrays","value":"StructsOfArrays"},{"label":"StructuredQueries","value":"StructuredQueries"},{"label":"Subsequences","value":"Subsequences"},{"label":"SubsetSelection","value":"SubsetSelection"},{"label":"SuffixArrays","value":"SuffixArrays"},{"label":"Sugar","value":"Sugar"},{"label":"SugarBLAS","value":"SugarBLAS"},{"label":"SuiteSparse","value":"SuiteSparse"},{"label":"SumOfSquares","value":"SumOfSquares"},{"label":"Sundials","value":"Sundials"},{"label":"SunlightAPIs","value":"SunlightAPIs"},{"label":"Suppressor","value":"Suppressor"},{"label":"SVM","value":"SVM"},{"label":"SVMLightLoader","value":"SVMLightLoader"},{"label":"SVR","value":"SVR"},{"label":"SweepOperator","value":"SweepOperator"},{"label":"Swifter","value":"Swifter"},{"label":"SwiftObjectStores","value":"SwiftObjectStores"},{"label":"Switch","value":"Switch"},{"label":"SwitchTimeOpt","value":"SwitchTimeOpt"},{"label":"Symata","value":"Symata"},{"label":"SymDict","value":"SymDict"},{"label":"SymEngine","value":"SymEngine"},{"label":"SymmetricBitArrays","value":"SymmetricBitArrays"},{"label":"SymmetricTensors","value":"SymmetricTensors"},{"label":"SymPy","value":"SymPy"},{"label":"Synchrony","value":"Synchrony"},{"label":"SynthesisFilters","value":"SynthesisFilters"},{"label":"SyntheticGrids","value":"SyntheticGrids"},{"label":"SystemImageBuilder","value":"SystemImageBuilder"},{"label":"TablesDemo","value":"TablesDemo"},{"label":"TableTraits","value":"TableTraits"},{"label":"TableTraitsUtils","value":"TableTraitsUtils"},{"label":"TakingBroadcastSeriously","value":"TakingBroadcastSeriously"},{"label":"Taro","value":"Taro"},{"label":"Tau","value":"Tau"},{"label":"TaylorIntegration","value":"TaylorIntegration"},{"label":"TaylorSeries","value":"TaylorSeries"},{"label":"TeaSeis","value":"TeaSeis"},{"label":"Temporal","value":"Temporal"},{"label":"TensorDecompositions","value":"TensorDecompositions"},{"label":"TensorFlow","value":"TensorFlow"},{"label":"TensorOperations","value":"TensorOperations"},{"label":"Tensors","value":"Tensors"},{"label":"TensorToolbox","value":"TensorToolbox"},{"label":"TerminalExtensions","value":"TerminalExtensions"},{"label":"TerminalMenus","value":"TerminalMenus"},{"label":"Terminals","value":"Terminals"},{"label":"TerminalUI","value":"TerminalUI"},{"label":"TermWin","value":"TermWin"},{"label":"TestImages","value":"TestImages"},{"label":"TestRunner","value":"TestRunner"},{"label":"TestSetExtensions","value":"TestSetExtensions"},{"label":"TexExtensions","value":"TexExtensions"},{"label":"TextAnalysis","value":"TextAnalysis"},{"label":"TextModel","value":"TextModel"},{"label":"TextParse","value":"TextParse"},{"label":"TextPlots","value":"TextPlots"},{"label":"TextWrap","value":"TextWrap"},{"label":"ThermodynamicsTable","value":"ThermodynamicsTable"},{"label":"ThingSpeak","value":"ThingSpeak"},{"label":"ThreeJS","value":"ThreeJS"},{"label":"Thrift","value":"Thrift"},{"label":"TikzGraphs","value":"TikzGraphs"},{"label":"TikzPictures","value":"TikzPictures"},{"label":"TiledIteration","value":"TiledIteration"},{"label":"TimeData","value":"TimeData"},{"label":"TimeFrames","value":"TimeFrames"},{"label":"TimeModels","value":"TimeModels"},{"label":"TimerOutputs","value":"TimerOutputs"},{"label":"TimeSeries","value":"TimeSeries"},{"label":"TimeSeriesIO","value":"TimeSeriesIO"},{"label":"TimeSeriesResampler","value":"TimeSeriesResampler"},{"label":"Timestamps","value":"Timestamps"},{"label":"TimeZones","value":"TimeZones"},{"label":"TinyInt","value":"TinyInt"},{"label":"TinySegmenter","value":"TinySegmenter"},{"label":"TinySparse","value":"TinySparse"},{"label":"Tk","value":"Tk"},{"label":"ToeplitzMatrices","value":"ToeplitzMatrices"},{"label":"Tokamak","value":"Tokamak"},{"label":"Tokenize","value":"Tokenize"},{"label":"TOML","value":"TOML"},{"label":"TopicModels","value":"TopicModels"},{"label":"TopicModelsVB","value":"TopicModelsVB"},{"label":"TotalVariation","value":"TotalVariation"},{"label":"TraceCalls","value":"TraceCalls"},{"label":"TrafficAssignment","value":"TrafficAssignment"},{"label":"TranscodingStreams","value":"TranscodingStreams"},{"label":"TransformUtils","value":"TransformUtils"},{"label":"Transit","value":"Transit"},{"label":"Transpiler","value":"Transpiler"},{"label":"TravelingSalesmanHeuristics","value":"TravelingSalesmanHeuristics"},{"label":"TreeView","value":"TreeView"},{"label":"Trie","value":"Trie"},{"label":"TSne","value":"TSne"},{"label":"Turing","value":"Turing"},{"label":"Twiddle","value":"Twiddle"},{"label":"Twitter","value":"Twitter"},{"label":"TwoBasedIndexing","value":"TwoBasedIndexing"},{"label":"TypeCheck","value":"TypeCheck"},{"label":"Typeclass","value":"Typeclass"},{"label":"TypedBools","value":"TypedBools"},{"label":"TypedDelegation","value":"TypedDelegation"},{"label":"TypedTables","value":"TypedTables"},{"label":"TypeSortedCollections","value":"TypeSortedCollections"},{"label":"UAParser","value":"UAParser"},{"label":"uCSV","value":"uCSV"},{"label":"ULID","value":"ULID"},{"label":"UnalignedVectors","value":"UnalignedVectors"},{"label":"UnicodeFun","value":"UnicodeFun"},{"label":"UnicodePlots","value":"UnicodePlots"},{"label":"UniqueVectors","value":"UniqueVectors"},{"label":"Unitful","value":"Unitful"},{"label":"UnitfulAngles","value":"UnitfulAngles"},{"label":"UnitfulAstro","value":"UnitfulAstro"},{"label":"UnitfulIntegration","value":"UnitfulIntegration"},{"label":"UnitfulUS","value":"UnitfulUS"},{"label":"Units","value":"Units"},{"label":"Unmarshal","value":"Unmarshal"},{"label":"Unrolled","value":"Unrolled"},{"label":"UnsafeAtomics","value":"UnsafeAtomics"},{"label":"Unums","value":"Unums"},{"label":"URIParser","value":"URIParser"},{"label":"URITemplate","value":"URITemplate"},{"label":"URLParse","value":"URLParse"},{"label":"UTF16","value":"UTF16"},{"label":"UUID","value":"UUID"},{"label":"ValidatedNumerics","value":"ValidatedNumerics"},{"label":"ValueDispatch","value":"ValueDispatch"},{"label":"ValuedTuples","value":"ValuedTuples"},{"label":"ValueHistories","value":"ValueHistories"},{"label":"ValueOrientedRiskManagementInsurance","value":"ValueOrientedRiskManagementInsurance"},{"label":"ValueSymbols","value":"ValueSymbols"},{"label":"VarianceComponentTest","value":"VarianceComponentTest"},{"label":"VariationalInequality","value":"VariationalInequality"},{"label":"Vectorize","value":"Vectorize"},{"label":"VectorizedRoutines","value":"VectorizedRoutines"},{"label":"Vega","value":"Vega"},{"label":"VegaLite","value":"VegaLite"},{"label":"VehicleModels","value":"VehicleModels"},{"label":"VennEuler","value":"VennEuler"},{"label":"VideoIO","value":"VideoIO"},{"label":"Viridis","value":"Viridis"},{"label":"VirtualArrays","value":"VirtualArrays"},{"label":"VisualRegressionTests","value":"VisualRegressionTests"},{"label":"VLFeat","value":"VLFeat"},{"label":"VML","value":"VML"},{"label":"Voronoi","value":"Voronoi"},{"label":"VoronoiCells","value":"VoronoiCells"},{"label":"VoronoiDelaunay","value":"VoronoiDelaunay"},{"label":"Voting","value":"Voting"},{"label":"VSL","value":"VSL"},{"label":"VStatistic","value":"VStatistic"},{"label":"VT100","value":"VT100"},{"label":"VulkanCore","value":"VulkanCore"},{"label":"Wallace","value":"Wallace"},{"label":"Watcher","value":"Watcher"},{"label":"Watershed","value":"Watershed"},{"label":"WAV","value":"WAV"},{"label":"WaveletMatrices","value":"WaveletMatrices"},{"label":"Wavelets","value":"Wavelets"},{"label":"WCS","value":"WCS"},{"label":"WCSLIB","value":"WCSLIB"},{"label":"WeakRefStrings","value":"WeakRefStrings"},{"label":"Weave","value":"Weave"},{"label":"Weber","value":"Weber"},{"label":"WeberCedrus","value":"WeberCedrus"},{"label":"WeberDAQmx","value":"WeberDAQmx"},{"label":"WebSockets","value":"WebSockets"},{"label":"Whittaker","value":"Whittaker"},{"label":"WiltonInts84","value":"WiltonInts84"},{"label":"WinReg","value":"WinReg"},{"label":"WinRPM","value":"WinRPM"},{"label":"Winston","value":"Winston"},{"label":"WoodburyMatrices","value":"WoodburyMatrices"},{"label":"Word2Vec","value":"Word2Vec"},{"label":"WordNet","value":"WordNet"},{"label":"WORLD","value":"WORLD"},{"label":"WorldBankData","value":"WorldBankData"},{"label":"WriteVTK","value":"WriteVTK"},{"label":"XClipboard","value":"XClipboard"},{"label":"XDiff","value":"XDiff"},{"label":"XGBoost","value":"XGBoost"},{"label":"XKPasswd","value":"XKPasswd"},{"label":"XMLconvert","value":"XMLconvert"},{"label":"XMLDict","value":"XMLDict"},{"label":"XMLRPC","value":"XMLRPC"},{"label":"Xpress","value":"Xpress"},{"label":"XSim","value":"XSim"},{"label":"XSV","value":"XSV"},{"label":"Xtensor","value":"Xtensor"},{"label":"YAML","value":"YAML"},{"label":"Yelp","value":"Yelp"},{"label":"Yeppp","value":"Yeppp"},{"label":"YT","value":"YT"},{"label":"ZChop","value":"ZChop"},{"label":"Zeros","value":"Zeros"},{"label":"ZipCode","value":"ZipCode"},{"label":"ZipFile","value":"ZipFile"},{"label":"Zlib","value":"Zlib"},{"label":"ZMQ","value":"ZMQ"},{"label":"ZVSimulator","value":"ZVSimulator"}]}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = {"packages":[{"label":"addict","value":"addict"},{"label":"ads","value":"ads"},{"label":"affine","value":"affine"},{"label":"agate","value":"agate"},{"label":"agate-dbf","value":"agate-dbf"},{"label":"agate-excel","value":"agate-excel"},{"label":"agate-lookup","value":"agate-lookup"},{"label":"agate-remote","value":"agate-remote"},{"label":"agate-sql","value":"agate-sql"},{"label":"agate-stats","value":"agate-stats"},{"label":"ago","value":"ago"},{"label":"aioeasywebdav","value":"aioeasywebdav"},{"label":"aiohttp","value":"aiohttp"},{"label":"aipy","value":"aipy"},{"label":"airflow","value":"airflow"},{"label":"alabaster","value":"alabaster"},{"label":"aldjemy","value":"aldjemy"},{"label":"alembic","value":"alembic"},{"label":"algopy","value":"algopy"},{"label":"aloe","value":"aloe"},{"label":"alpenglow","value":"alpenglow"},{"label":"alps","value":"alps"},{"label":"altair","value":"altair"},{"label":"ampl-mp","value":"ampl-mp"},{"label":"amqp","value":"amqp"},{"label":"anaconda-client","value":"anaconda-client"},{"label":"anaconda-project","value":"anaconda-project"},{"label":"anaconda-verify","value":"anaconda-verify"},{"label":"aniso8601","value":"aniso8601"},{"label":"ansible","value":"ansible"},{"label":"antlr","value":"antlr"},{"label":"anyjson","value":"anyjson"},{"label":"anypytools","value":"anypytools"},{"label":"anyqt","value":"anyqt"},{"label":"aospy","value":"aospy"},{"label":"apache-libcloud","value":"apache-libcloud"},{"label":"apipkg","value":"apipkg"},{"label":"apispec","value":"apispec"},{"label":"aplpy","value":"aplpy"},{"label":"aplus","value":"aplus"},{"label":"appdirs","value":"appdirs"},{"label":"appnope","value":"appnope"},{"label":"appscript","value":"appscript"},{"label":"apptools","value":"apptools"},{"label":"apscheduler","value":"apscheduler"},{"label":"apsw","value":"apsw"},{"label":"arb","value":"arb"},{"label":"arcsi","value":"arcsi"},{"label":"argcomplete","value":"argcomplete"},{"label":"argh","value":"argh"},{"label":"argon2_cffi","value":"argon2_cffi"},{"label":"argparse","value":"argparse"},{"label":"args","value":"args"},{"label":"argtable2","value":"argtable2"},{"label":"arm_pyart","value":"arm_pyart"},{"label":"armadillo","value":"armadillo"},{"label":"arpack","value":"arpack"},{"label":"arpackpp","value":"arpackpp"},{"label":"arrow","value":"arrow"},{"label":"arrow-cpp","value":"arrow-cpp"},{"label":"artview","value":"artview"},{"label":"asap","value":"asap"},{"label":"asciitree","value":"asciitree"},{"label":"asdf","value":"asdf"},{"label":"ase","value":"ase"},{"label":"asn1crypto","value":"asn1crypto"},{"label":"aspy.yaml","value":"aspy.yaml"},{"label":"assetid","value":"assetid"},{"label":"assimulo","value":"assimulo"},{"label":"asteval","value":"asteval"},{"label":"astor","value":"astor"},{"label":"astro-gala","value":"astro-gala"},{"label":"astrocats","value":"astrocats"},{"label":"astroid","value":"astroid"},{"label":"astroml","value":"astroml"},{"label":"astroplan","value":"astroplan"},{"label":"astropy","value":"astropy"},{"label":"astropy-healpix","value":"astropy-healpix"},{"label":"astroquery","value":"astroquery"},{"label":"astroscrappy","value":"astroscrappy"},{"label":"astunparse","value":"astunparse"},{"label":"asv","value":"asv"},{"label":"async-timeout","value":"async-timeout"},{"label":"asyncpg","value":"asyncpg"},{"label":"asyncpgsa","value":"asyncpgsa"},{"label":"asyncssh","value":"asyncssh"},{"label":"atk","value":"atk"},{"label":"atom","value":"atom"},{"label":"atomicwrites","value":"atomicwrites"},{"label":"attrdict","value":"attrdict"},{"label":"attrs","value":"attrs"},{"label":"attrs-sqlalchemy","value":"attrs-sqlalchemy"},{"label":"aubio","value":"aubio"},{"label":"audioread","value":"audioread"},{"label":"auditwheel","value":"auditwheel"},{"label":"autobahn","value":"autobahn"},{"label":"autoconf","value":"autoconf"},{"label":"autodocsumm","value":"autodocsumm"},{"label":"autograd","value":"autograd"},{"label":"automake","value":"automake"},{"label":"automat","value":"automat"},{"label":"autopep8","value":"autopep8"},{"label":"autovizwidget","value":"autovizwidget"},{"label":"autowrap","value":"autowrap"},{"label":"av","value":"av"},{"label":"avro","value":"avro"},{"label":"awesome-slugify","value":"awesome-slugify"},{"label":"awscli","value":"awscli"},{"label":"axelrod","value":"axelrod"},{"label":"azure","value":"azure"},{"label":"azure-common","value":"azure-common"},{"label":"azure-mgmt","value":"azure-mgmt"},{"label":"azure-mgmt-common","value":"azure-mgmt-common"},{"label":"azure-mgmt-compute","value":"azure-mgmt-compute"},{"label":"azure-mgmt-network","value":"azure-mgmt-network"},{"label":"azure-mgmt-nspkg","value":"azure-mgmt-nspkg"},{"label":"azure-mgmt-resource","value":"azure-mgmt-resource"},{"label":"azure-mgmt-storage","value":"azure-mgmt-storage"},{"label":"azure-nspkg","value":"azure-nspkg"},{"label":"azure-servicebus","value":"azure-servicebus"},{"label":"azure-servicemanagement-legacy","value":"azure-servicemanagement-legacy"},{"label":"azure-storage","value":"azure-storage"},{"label":"babel","value":"babel"},{"label":"backoff","value":"backoff"},{"label":"backports","value":"backports"},{"label":"backports.csv","value":"backports.csv"},{"label":"backports.functools_lru_cache","value":"backports.functools_lru_cache"},{"label":"backports.lzma","value":"backports.lzma"},{"label":"backports.shutil_get_terminal_size","value":"backports.shutil_get_terminal_size"},{"label":"backports.shutil_which","value":"backports.shutil_which"},{"label":"backports.ssl","value":"backports.ssl"},{"label":"backports.weakref","value":"backports.weakref"},{"label":"backports_abc","value":"backports_abc"},{"label":"backward-cpp","value":"backward-cpp"},{"label":"bagit","value":"bagit"},{"label":"basemap","value":"basemap"},{"label":"basemap-data-hires","value":"basemap-data-hires"},{"label":"bazel","value":"bazel"},{"label":"bc","value":"bc"},{"label":"bcdoc","value":"bcdoc"},{"label":"bcolz","value":"bcolz"},{"label":"bdw-gc","value":"bdw-gc"},{"label":"beaker","value":"beaker"},{"label":"beakerx","value":"beakerx"},{"label":"beautifulsoup4","value":"beautifulsoup4"},{"label":"begins","value":"begins"},{"label":"behave","value":"behave"},{"label":"betamax","value":"betamax"},{"label":"betamax-matchers","value":"betamax-matchers"},{"label":"betfairlightweight","value":"betfairlightweight"},{"label":"bfg","value":"bfg"},{"label":"bgen","value":"bgen"},{"label":"bhmm","value":"bhmm"},{"label":"bibtexparser","value":"bibtexparser"},{"label":"bidict","value":"bidict"},{"label":"biggus","value":"biggus"},{"label":"billiard","value":"billiard"},{"label":"billingegroup","value":"billingegroup"},{"label":"binaryornot","value":"binaryornot"},{"label":"binutils","value":"binutils"},{"label":"biopandas","value":"biopandas"},{"label":"biopython","value":"biopython"},{"label":"bison","value":"bison"},{"label":"bitarray","value":"bitarray"},{"label":"bkcharts","value":"bkcharts"},{"label":"blas","value":"blas"},{"label":"blaze","value":"blaze"},{"label":"bleach","value":"bleach"},{"label":"blessings","value":"blessings"},{"label":"blinker","value":"blinker"},{"label":"blosc","value":"blosc"},{"label":"bloscpack","value":"bloscpack"},{"label":"bob","value":"bob"},{"label":"bob.ap","value":"bob.ap"},{"label":"bob.blitz","value":"bob.blitz"},{"label":"bob.core","value":"bob.core"},{"label":"bob.db.atnt","value":"bob.db.atnt"},{"label":"bob.db.base","value":"bob.db.base"},{"label":"bob.db.iris","value":"bob.db.iris"},{"label":"bob.db.mnist","value":"bob.db.mnist"},{"label":"bob.db.wine","value":"bob.db.wine"},{"label":"bob.extension","value":"bob.extension"},{"label":"bob.io.audio","value":"bob.io.audio"},{"label":"bob.io.base","value":"bob.io.base"},{"label":"bob.io.image","value":"bob.io.image"},{"label":"bob.io.matlab","value":"bob.io.matlab"},{"label":"bob.io.video","value":"bob.io.video"},{"label":"bob.ip.base","value":"bob.ip.base"},{"label":"bob.ip.color","value":"bob.ip.color"},{"label":"bob.ip.draw","value":"bob.ip.draw"},{"label":"bob.ip.facedetect","value":"bob.ip.facedetect"},{"label":"bob.ip.flandmark","value":"bob.ip.flandmark"},{"label":"bob.ip.gabor","value":"bob.ip.gabor"},{"label":"bob.ip.optflow.hornschunck","value":"bob.ip.optflow.hornschunck"},{"label":"bob.ip.optflow.liu","value":"bob.ip.optflow.liu"},{"label":"bob.learn.activation","value":"bob.learn.activation"},{"label":"bob.learn.boosting","value":"bob.learn.boosting"},{"label":"bob.learn.em","value":"bob.learn.em"},{"label":"bob.learn.libsvm","value":"bob.learn.libsvm"},{"label":"bob.learn.linear","value":"bob.learn.linear"},{"label":"bob.learn.mlp","value":"bob.learn.mlp"},{"label":"bob.math","value":"bob.math"},{"label":"bob.measure","value":"bob.measure"},{"label":"bob.sp","value":"bob.sp"},{"label":"bokeh","value":"bokeh"},{"label":"boltons","value":"boltons"},{"label":"boost","value":"boost"},{"label":"boost-cpp","value":"boost-cpp"},{"label":"bootstrap_contrast","value":"bootstrap_contrast"},{"label":"boto3","value":"boto3"},{"label":"botocore","value":"botocore"},{"label":"bottle","value":"bottle"},{"label":"bottleneck","value":"bottleneck"},{"label":"bowerstatic","value":"bowerstatic"},{"label":"bqplot","value":"bqplot"},{"label":"branca","value":"branca"},{"label":"breathe","value":"breathe"},{"label":"brent-search","value":"brent-search"},{"label":"brent_search","value":"brent_search"},{"label":"brewer2mpl","value":"brewer2mpl"},{"label":"brial","value":"brial"},{"label":"brotli","value":"brotli"},{"label":"bson","value":"bson"},{"label":"build-capi","value":"build-capi"},{"label":"build_capi","value":"build_capi"},{"label":"bumpversion","value":"bumpversion"},{"label":"bunch","value":"bunch"},{"label":"bzip2","value":"bzip2"},{"label":"c-progressbar","value":"c-progressbar"},{"label":"c99-to-c89","value":"c99-to-c89"},{"label":"ca-certificates","value":"ca-certificates"},{"label":"cached-property","value":"cached-property"},{"label":"cachetools","value":"cachetools"},{"label":"caffe","value":"caffe"},{"label":"cairo","value":"cairo"},{"label":"cairocffi","value":"cairocffi"},{"label":"cairomm","value":"cairomm"},{"label":"cairosvg","value":"cairosvg"},{"label":"calliope","value":"calliope"},{"label":"capnproto","value":"capnproto"},{"label":"capturer","value":"capturer"},{"label":"cartopy","value":"cartopy"},{"label":"casacore","value":"casacore"},{"label":"casadi","value":"casadi"},{"label":"case","value":"case"},{"label":"cassandra-driver","value":"cassandra-driver"},{"label":"category_encoders","value":"category_encoders"},{"label":"catimg","value":"catimg"},{"label":"catzzz","value":"catzzz"},{"label":"cbsyst","value":"cbsyst"},{"label":"cc-plugin-glider","value":"cc-plugin-glider"},{"label":"cc-plugin-ncei","value":"cc-plugin-ncei"},{"label":"ccache","value":"ccache"},{"label":"ccache-toolchain","value":"ccache-toolchain"},{"label":"ccdproc","value":"ccdproc"},{"label":"cchardet","value":"cchardet"},{"label":"cdat-lite","value":"cdat-lite"},{"label":"cdat_info","value":"cdat_info"},{"label":"cddlib","value":"cddlib"},{"label":"cdecimal","value":"cdecimal"},{"label":"cdms2","value":"cdms2"},{"label":"cdo","value":"cdo"},{"label":"cdtime","value":"cdtime"},{"label":"cdutil","value":"cdutil"},{"label":"celerite","value":"celerite"},{"label":"celery","value":"celery"},{"label":"celiagg","value":"celiagg"},{"label":"cell_tree2d","value":"cell_tree2d"},{"label":"cement","value":"cement"},{"label":"census","value":"census"},{"label":"centrally-managed-conda","value":"centrally-managed-conda"},{"label":"cerberus","value":"cerberus"},{"label":"certifi","value":"certifi"},{"label":"cf_units","value":"cf_units"},{"label":"cfchecker","value":"cfchecker"},{"label":"cffi","value":"cffi"},{"label":"cfitsio","value":"cfitsio"},{"label":"cfortran-cfitsio","value":"cfortran-cfitsio"},{"label":"cfunits","value":"cfunits"},{"label":"cgal","value":"cgal"},{"label":"cgen","value":"cgen"},{"label":"cgsn-parsers","value":"cgsn-parsers"},{"label":"cgsn_parsers","value":"cgsn_parsers"},{"label":"cgsn_processing","value":"cgsn_processing"},{"label":"chai","value":"chai"},{"label":"channelarchiver","value":"channelarchiver"},{"label":"chardet","value":"chardet"},{"label":"chartkick","value":"chartkick"},{"label":"cheat","value":"cheat"},{"label":"check","value":"check"},{"label":"chemfiles","value":"chemfiles"},{"label":"chemfiles-lib","value":"chemfiles-lib"},{"label":"chemfiles-python","value":"chemfiles-python"},{"label":"cheroot","value":"cheroot"},{"label":"cherrypy","value":"cherrypy"},{"label":"chest","value":"chest"},{"label":"chrpath","value":"chrpath"},{"label":"cibots","value":"cibots"},{"label":"ciocheck","value":"ciocheck"},{"label":"circleci-helpers","value":"circleci-helpers"},{"label":"circleclient","value":"circleclient"},{"label":"circus","value":"circus"},{"label":"cis","value":"cis"},{"label":"ciso","value":"ciso"},{"label":"ciso8601","value":"ciso8601"},{"label":"ckanapi","value":"ckanapi"},{"label":"clamd","value":"clamd"},{"label":"clangdev","value":"clangdev"},{"label":"clapack","value":"clapack"},{"label":"clblas","value":"clblas"},{"label":"clblast","value":"clblast"},{"label":"clcache","value":"clcache"},{"label":"cld2-cffi","value":"cld2-cffi"},{"label":"clfft","value":"clfft"},{"label":"clhpp","value":"clhpp"},{"label":"cli_helpers","value":"cli_helpers"},{"label":"click","value":"click"},{"label":"click-help-colors","value":"click-help-colors"},{"label":"click-plugins","value":"click-plugins"},{"label":"clickclick","value":"clickclick"},{"label":"clickhouse-cityhash","value":"clickhouse-cityhash"},{"label":"clickhouse-driver","value":"clickhouse-driver"},{"label":"clickhouse-sqlalchemy","value":"clickhouse-sqlalchemy"},{"label":"cliff","value":"cliff"},{"label":"cligj","value":"cligj"},{"label":"climlab","value":"climlab"},{"label":"cling","value":"cling"},{"label":"cling-patches","value":"cling-patches"},{"label":"clint","value":"clint"},{"label":"cliquer","value":"cliquer"},{"label":"cloog","value":"cloog"},{"label":"cloud_sptheme","value":"cloud_sptheme"},{"label":"cloudant","value":"cloudant"},{"label":"cloudpickle","value":"cloudpickle"},{"label":"clrng","value":"clrng"},{"label":"clsparse","value":"clsparse"},{"label":"cluster-lensing","value":"cluster-lensing"},{"label":"clusterpy","value":"clusterpy"},{"label":"clyent","value":"clyent"},{"label":"cmake","value":"cmake"},{"label":"cmd2","value":"cmd2"},{"label":"cmocean","value":"cmocean"},{"label":"cmt","value":"cmt"},{"label":"coconut","value":"coconut"},{"label":"codar2netcdf","value":"codar2netcdf"},{"label":"codecov","value":"codecov"},{"label":"cogapp","value":"cogapp"},{"label":"coincbc","value":"coincbc"},{"label":"coinmp","value":"coinmp"},{"label":"collectfast","value":"collectfast"},{"label":"colorama","value":"colorama"},{"label":"coloredlogs","value":"coloredlogs"},{"label":"colorlog","value":"colorlog"},{"label":"colormap","value":"colormap"},{"label":"colormath","value":"colormath"},{"label":"colour","value":"colour"},{"label":"colour-science","value":"colour-science"},{"label":"commonmark","value":"commonmark"},{"label":"compliance-checker","value":"compliance-checker"},{"label":"comtypes","value":"comtypes"},{"label":"concurrentloghandler","value":"concurrentloghandler"},{"label":"conda","value":"conda"},{"label":"conda-build","value":"conda-build"},{"label":"conda-build-all","value":"conda-build-all"},{"label":"conda-devenv","value":"conda-devenv"},{"label":"conda-env","value":"conda-env"},{"label":"conda-exec","value":"conda-exec"},{"label":"conda-execute","value":"conda-execute"},{"label":"conda-forge-build-setup","value":"conda-forge-build-setup"},{"label":"conda-gitenv","value":"conda-gitenv"},{"label":"conda-mirror","value":"conda-mirror"},{"label":"conda-smithy","value":"conda-smithy"},{"label":"conda-testenv","value":"conda-testenv"},{"label":"conda-verify","value":"conda-verify"},{"label":"conda-workon","value":"conda-workon"},{"label":"conda-wrappers","value":"conda-wrappers"},{"label":"configargparse","value":"configargparse"},{"label":"configparser","value":"configparser"},{"label":"configurable-http-proxy","value":"configurable-http-proxy"},{"label":"connexion","value":"connexion"},{"label":"constantly","value":"constantly"},{"label":"constructor","value":"constructor"},{"label":"consul","value":"consul"},{"label":"consul-template","value":"consul-template"},{"label":"containerpilot","value":"containerpilot"},{"label":"contextily","value":"contextily"},{"label":"contextlib2","value":"contextlib2"},{"label":"control","value":"control"},{"label":"convertdate","value":"convertdate"},{"label":"cookiecutter","value":"cookiecutter"},{"label":"corner","value":"corner"},{"label":"cotire","value":"cotire"},{"label":"coursera-dl","value":"coursera-dl"},{"label":"courtana","value":"courtana"},{"label":"cov-core","value":"cov-core"},{"label":"coverage","value":"coverage"},{"label":"coveralls","value":"coveralls"},{"label":"cppcheck","value":"cppcheck"},{"label":"cppunit","value":"cppunit"},{"label":"cppzmq","value":"cppzmq"},{"label":"cpulimit","value":"cpulimit"},{"label":"cquadpack","value":"cquadpack"},{"label":"craftr","value":"craftr"},{"label":"cram","value":"cram"},{"label":"creoleparser","value":"creoleparser"},{"label":"crick","value":"crick"},{"label":"crochet","value":"crochet"},{"label":"croniter","value":"croniter"},{"label":"cryptography","value":"cryptography"},{"label":"cryptography-vectors","value":"cryptography-vectors"},{"label":"cryptopp","value":"cryptopp"},{"label":"csa","value":"csa"},{"label":"cson","value":"cson"},{"label":"cssmin","value":"cssmin"},{"label":"cssselect","value":"cssselect"},{"label":"cssutils","value":"cssutils"},{"label":"csvkit","value":"csvkit"},{"label":"ctags","value":"ctags"},{"label":"ctd","value":"ctd"},{"label":"ctds","value":"ctds"},{"label":"ctk-cli","value":"ctk-cli"},{"label":"cube_browser","value":"cube_browser"},{"label":"cunit","value":"cunit"},{"label":"curio","value":"curio"},{"label":"curl","value":"curl"},{"label":"cvloop","value":"cvloop"},{"label":"cvxopt","value":"cvxopt"},{"label":"cxxopts","value":"cxxopts"},{"label":"cyavro","value":"cyavro"},{"label":"cycamore","value":"cycamore"},{"label":"cycler","value":"cycler"},{"label":"cyclus","value":"cyclus"},{"label":"cyclus-build-deps","value":"cyclus-build-deps"},{"label":"cyflann","value":"cyflann"},{"label":"cyipopt","value":"cyipopt"},{"label":"cymem","value":"cymem"},{"label":"cymetric","value":"cymetric"},{"label":"cyordereddict","value":"cyordereddict"},{"label":"cypari2","value":"cypari2"},{"label":"cysignals","value":"cysignals"},{"label":"cython","value":"cython"},{"label":"cythongsl","value":"cythongsl"},{"label":"cytoolz","value":"cytoolz"},{"label":"d2to1","value":"d2to1"},{"label":"dask","value":"dask"},{"label":"dask-core","value":"dask-core"},{"label":"dask-distance","value":"dask-distance"},{"label":"dask-funk","value":"dask-funk"},{"label":"dask-imread","value":"dask-imread"},{"label":"dask-ndfilters","value":"dask-ndfilters"},{"label":"dask-ndfourier","value":"dask-ndfourier"},{"label":"dask-ndmeasure","value":"dask-ndmeasure"},{"label":"dask-ndmorph","value":"dask-ndmorph"},{"label":"dask-searchcv","value":"dask-searchcv"},{"label":"dask-xgboost","value":"dask-xgboost"},{"label":"datacube","value":"datacube"},{"label":"datadotworld-py","value":"datadotworld-py"},{"label":"datamountaineer-schemaregistry","value":"datamountaineer-schemaregistry"},{"label":"datapackage-py","value":"datapackage-py"},{"label":"datashape","value":"datashape"},{"label":"dateparser","value":"dateparser"},{"label":"dateutils","value":"dateutils"},{"label":"datreant","value":"datreant"},{"label":"datreant.core","value":"datreant.core"},{"label":"datreant.data","value":"datreant.data"},{"label":"dawg","value":"dawg"},{"label":"dbf","value":"dbf"},{"label":"dbfread","value":"dbfread"},{"label":"dbt","value":"dbt"},{"label":"dbus","value":"dbus"},{"label":"dbus-cxx","value":"dbus-cxx"},{"label":"dcmstack","value":"dcmstack"},{"label":"dcw-gmt","value":"dcw-gmt"},{"label":"ddt","value":"ddt"},{"label":"deap","value":"deap"},{"label":"debtcollector","value":"debtcollector"},{"label":"dec2","value":"dec2"},{"label":"decorator","value":"decorator"},{"label":"dectate","value":"dectate"},{"label":"deepdiff","value":"deepdiff"},{"label":"deepdish","value":"deepdish"},{"label":"deepgraph","value":"deepgraph"},{"label":"defusedxml","value":"defusedxml"},{"label":"delegator","value":"delegator"},{"label":"depfinder","value":"depfinder"},{"label":"deprecation","value":"deprecation"},{"label":"descartes","value":"descartes"},{"label":"descarteslabs","value":"descarteslabs"},{"label":"desktop3","value":"desktop3"},{"label":"df2gspread","value":"df2gspread"},{"label":"dicttoxml","value":"dicttoxml"},{"label":"diff-match-patch","value":"diff-match-patch"},{"label":"diffoscope","value":"diffoscope"},{"label":"diffpy.structure","value":"diffpy.structure"},{"label":"diffpy.utils","value":"diffpy.utils"},{"label":"dill","value":"dill"},{"label":"dionysus","value":"dionysus"},{"label":"dipy","value":"dipy"},{"label":"dirent","value":"dirent"},{"label":"discretisedfield","value":"discretisedfield"},{"label":"discretizer","value":"discretizer"},{"label":"diskcache","value":"diskcache"},{"label":"distarray","value":"distarray"},{"label":"distributed","value":"distributed"},{"label":"dj-database-url","value":"dj-database-url"},{"label":"dj-static","value":"dj-static"},{"label":"django","value":"django"},{"label":"django-admin-shortcuts","value":"django-admin-shortcuts"},{"label":"django-ajax-selects","value":"django-ajax-selects"},{"label":"django-allauth","value":"django-allauth"},{"label":"django-anymail","value":"django-anymail"},{"label":"django-appconf","value":"django-appconf"},{"label":"django-apptemplates","value":"django-apptemplates"},{"label":"django-autoslug","value":"django-autoslug"},{"label":"django-bakery","value":"django-bakery"},{"label":"django-bootstrap3","value":"django-bootstrap3"},{"label":"django-braces","value":"django-braces"},{"label":"django-cachalot","value":"django-cachalot"},{"label":"django-celery","value":"django-celery"},{"label":"django-chunked-upload","value":"django-chunked-upload"},{"label":"django-configurations","value":"django-configurations"},{"label":"django-crispy-forms","value":"django-crispy-forms"},{"label":"django-daterange-filter","value":"django-daterange-filter"},{"label":"django-debug-toolbar","value":"django-debug-toolbar"},{"label":"django-enumfields","value":"django-enumfields"},{"label":"django-environ","value":"django-environ"},{"label":"django-extensions","value":"django-extensions"},{"label":"django-filter","value":"django-filter"},{"label":"django-foundation-formtags","value":"django-foundation-formtags"},{"label":"django-fsm","value":"django-fsm"},{"label":"django-grappelli","value":"django-grappelli"},{"label":"django-guardian","value":"django-guardian"},{"label":"django-import-export","value":"django-import-export"},{"label":"django-jquery","value":"django-jquery"},{"label":"django-leaflet","value":"django-leaflet"},{"label":"django-makemessages-xgettext","value":"django-makemessages-xgettext"},{"label":"django-material","value":"django-material"},{"label":"django-model-utils","value":"django-model-utils"},{"label":"django-modelcluster","value":"django-modelcluster"},{"label":"django-nested-admin","value":"django-nested-admin"},{"label":"django-nested-inline","value":"django-nested-inline"},{"label":"django-nose","value":"django-nose"},{"label":"django-pyodbc-azure","value":"django-pyodbc-azure"},{"label":"django-recaptcha","value":"django-recaptcha"},{"label":"django-redis","value":"django-redis"},{"label":"django-redis-cache","value":"django-redis-cache"},{"label":"django-rest-hooks","value":"django-rest-hooks"},{"label":"django-storages","value":"django-storages"},{"label":"django-storages-redux","value":"django-storages-redux"},{"label":"django-taggit","value":"django-taggit"},{"label":"django-test-plus","value":"django-test-plus"},{"label":"django-treebeard","value":"django-treebeard"},{"label":"django-typed-models","value":"django-typed-models"},{"label":"django-unique-upload","value":"django-unique-upload"},{"label":"django-uuidfield","value":"django-uuidfield"},{"label":"django-versatileimagefield","value":"django-versatileimagefield"},{"label":"django-viewflow","value":"django-viewflow"},{"label":"django_compressor","value":"django_compressor"},{"label":"django_coverage_plugin","value":"django_coverage_plugin"},{"label":"django_polymorphic","value":"django_polymorphic"},{"label":"djangocms-admin-style","value":"djangocms-admin-style"},{"label":"djangorestframework","value":"djangorestframework"},{"label":"djangorestframework-gis","value":"djangorestframework-gis"},{"label":"dlib","value":"dlib"},{"label":"dmd","value":"dmd"},{"label":"dnspython","value":"dnspython"},{"label":"doc8","value":"doc8"},{"label":"docker-py","value":"docker-py"},{"label":"docker-pycreds","value":"docker-pycreds"},{"label":"doconce","value":"doconce"},{"label":"docopt","value":"docopt"},{"label":"docrep","value":"docrep"},{"label":"docstring-coverage","value":"docstring-coverage"},{"label":"doct","value":"doct"},{"label":"doctr","value":"doctr"},{"label":"docutils","value":"docutils"},{"label":"docx2txt","value":"docx2txt"},{"label":"dodgy","value":"dodgy"},{"label":"dogpile.cache","value":"dogpile.cache"},{"label":"dolfin-adjoint","value":"dolfin-adjoint"},{"label":"dolfyn","value":"dolfyn"},{"label":"dominate","value":"dominate"},{"label":"dose","value":"dose"},{"label":"dotmap","value":"dotmap"},{"label":"doublemetaphone","value":"doublemetaphone"},{"label":"doxygen","value":"doxygen"},{"label":"dpath","value":"dpath"},{"label":"dropbox","value":"dropbox"},{"label":"ds-lime","value":"ds-lime"},{"label":"dxchange","value":"dxchange"},{"label":"dxfgrabber","value":"dxfgrabber"},{"label":"dxfile","value":"dxfile"},{"label":"dynamicisttoolkit","value":"dynamicisttoolkit"},{"label":"easybuild","value":"easybuild"},{"label":"easybuild-easyblocks","value":"easybuild-easyblocks"},{"label":"easybuild-easyconfigs","value":"easybuild-easyconfigs"},{"label":"easybuild-framework","value":"easybuild-framework"},{"label":"easydev","value":"easydev"},{"label":"easyprocess","value":"easyprocess"},{"label":"easytest","value":"easytest"},{"label":"ebooklib","value":"ebooklib"},{"label":"eccodes","value":"eccodes"},{"label":"ecl","value":"ecl"},{"label":"eclib","value":"eclib"},{"label":"ecm","value":"ecm"},{"label":"ecmwf-api-client","value":"ecmwf-api-client"},{"label":"ecmwf_grib","value":"ecmwf_grib"},{"label":"edffile","value":"edffile"},{"label":"effect","value":"effect"},{"label":"egal","value":"egal"},{"label":"eigen","value":"eigen"},{"label":"eight","value":"eight"},{"label":"elastic","value":"elastic"},{"label":"elasticsearch","value":"elasticsearch"},{"label":"elasticsearch-async","value":"elasticsearch-async"},{"label":"elasticsearch-dsl","value":"elasticsearch-dsl"},{"label":"elektronn","value":"elektronn"},{"label":"elektronn2","value":"elektronn2"},{"label":"elfutils","value":"elfutils"},{"label":"eli5","value":"eli5"},{"label":"emacs","value":"emacs"},{"label":"email_validator","value":"email_validator"},{"label":"embree","value":"embree"},{"label":"emcee","value":"emcee"},{"label":"empath","value":"empath"},{"label":"emperor","value":"emperor"},{"label":"engarde","value":"engarde"},{"label":"entrypoints","value":"entrypoints"},{"label":"enum34","value":"enum34"},{"label":"environment-modules","value":"environment-modules"},{"label":"envisage","value":"envisage"},{"label":"eofs","value":"eofs"},{"label":"ephem","value":"ephem"},{"label":"epic2cf","value":"epic2cf"},{"label":"eqcorrscan","value":"eqcorrscan"},{"label":"erlang","value":"erlang"},{"label":"esgf-pyclient","value":"esgf-pyclient"},{"label":"esmf","value":"esmf"},{"label":"esmp","value":"esmp"},{"label":"esmpy","value":"esmpy"},{"label":"espei","value":"espei"},{"label":"et_xmlfile","value":"et_xmlfile"},{"label":"event-model","value":"event-model"},{"label":"eventlet","value":"eventlet"},{"label":"exec-wrappers","value":"exec-wrappers"},{"label":"execnet","value":"execnet"},{"label":"exempi","value":"exempi"},{"label":"exifread","value":"exifread"},{"label":"expat","value":"expat"},{"label":"extinction","value":"extinction"},{"label":"extras","value":"extras"},{"label":"ez_setup","value":"ez_setup"},{"label":"ezodf","value":"ezodf"},{"label":"f90nml","value":"f90nml"},{"label":"f90wrap","value":"f90wrap"},{"label":"fabio","value":"fabio"},{"label":"fabric","value":"fabric"},{"label":"fabric3","value":"fabric3"},{"label":"factory_boy","value":"factory_boy"},{"label":"fake-factory","value":"fake-factory"},{"label":"faker","value":"faker"},{"label":"falcon","value":"falcon"},{"label":"fancycompleter","value":"fancycompleter"},{"label":"fast-histogram","value":"fast-histogram"},{"label":"fastavro","value":"fastavro"},{"label":"fastcache","value":"fastcache"},{"label":"fastcluster","value":"fastcluster"},{"label":"fasteners","value":"fasteners"},{"label":"fastnumbers","value":"fastnumbers"},{"label":"fastparquet","value":"fastparquet"},{"label":"fatiando","value":"fatiando"},{"label":"fbprophet","value":"fbprophet"},{"label":"fdupes","value":"fdupes"},{"label":"feather-format","value":"feather-format"},{"label":"feedgenerator","value":"feedgenerator"},{"label":"feedstockrot","value":"feedstockrot"},{"label":"fenics","value":"fenics"},{"label":"fermipy","value":"fermipy"},{"label":"ferret_datasets","value":"ferret_datasets"},{"label":"fflas-ffpack","value":"fflas-ffpack"},{"label":"ffmpeg","value":"ffmpeg"},{"label":"fftw","value":"fftw"},{"label":"ffx","value":"ffx"},{"label":"fig2dev","value":"fig2dev"},{"label":"filechunkio","value":"filechunkio"},{"label":"filelock","value":"filelock"},{"label":"filesdb","value":"filesdb"},{"label":"filterpy","value":"filterpy"},{"label":"findspark","value":"findspark"},{"label":"fiona","value":"fiona"},{"label":"fire","value":"fire"},{"label":"fish","value":"fish"},{"label":"fixtures","value":"fixtures"},{"label":"flake8","value":"flake8"},{"label":"flake8-blind-except","value":"flake8-blind-except"},{"label":"flake8-builtins","value":"flake8-builtins"},{"label":"flake8-comprehensions","value":"flake8-comprehensions"},{"label":"flake8-copyright","value":"flake8-copyright"},{"label":"flake8-docstrings","value":"flake8-docstrings"},{"label":"flake8-import-order","value":"flake8-import-order"},{"label":"flake8-mutable","value":"flake8-mutable"},{"label":"flake8-pep3101","value":"flake8-pep3101"},{"label":"flake8-polyfill","value":"flake8-polyfill"},{"label":"flake8-print","value":"flake8-print"},{"label":"flake8-quotes","value":"flake8-quotes"},{"label":"flaky","value":"flaky"},{"label":"flann","value":"flann"},{"label":"flask","value":"flask"},{"label":"flask-admin","value":"flask-admin"},{"label":"flask-allows","value":"flask-allows"},{"label":"flask-apispec","value":"flask-apispec"},{"label":"flask-appbuilder","value":"flask-appbuilder"},{"label":"flask-assets","value":"flask-assets"},{"label":"flask-babel","value":"flask-babel"},{"label":"flask-babelex","value":"flask-babelex"},{"label":"flask-basicauth","value":"flask-basicauth"},{"label":"flask-bcrypt","value":"flask-bcrypt"},{"label":"flask-cache","value":"flask-cache"},{"label":"flask-celery-helper","value":"flask-celery-helper"},{"label":"flask-cors","value":"flask-cors"},{"label":"flask-couchdb","value":"flask-couchdb"},{"label":"flask-creole","value":"flask-creole"},{"label":"flask-debugtoolbar","value":"flask-debugtoolbar"},{"label":"flask-flatpages","value":"flask-flatpages"},{"label":"flask-genshi","value":"flask-genshi"},{"label":"flask-httpauth","value":"flask-httpauth"},{"label":"flask-jsonpify","value":"flask-jsonpify"},{"label":"flask-ldap3-login","value":"flask-ldap3-login"},{"label":"flask-login","value":"flask-login"},{"label":"flask-mail","value":"flask-mail"},{"label":"flask-marshmallow","value":"flask-marshmallow"},{"label":"flask-migrate","value":"flask-migrate"},{"label":"flask-moment","value":"flask-moment"},{"label":"flask-oauthlib","value":"flask-oauthlib"},{"label":"flask-openid","value":"flask-openid"},{"label":"flask-principal","value":"flask-principal"},{"label":"flask-redis-helper","value":"flask-redis-helper"},{"label":"flask-rest-jsonapi","value":"flask-rest-jsonapi"},{"label":"flask-restful","value":"flask-restful"},{"label":"flask-restless","value":"flask-restless"},{"label":"flask-restplus","value":"flask-restplus"},{"label":"flask-script","value":"flask-script"},{"label":"flask-seasurf","value":"flask-seasurf"},{"label":"flask-security","value":"flask-security"},{"label":"flask-socketio","value":"flask-socketio"},{"label":"flask-sqlalchemy","value":"flask-sqlalchemy"},{"label":"flask-swagger","value":"flask-swagger"},{"label":"flask-testing","value":"flask-testing"},{"label":"flask-turbolinks","value":"flask-turbolinks"},{"label":"flask-uploads","value":"flask-uploads"},{"label":"flask-user","value":"flask-user"},{"label":"flask-webpack","value":"flask-webpack"},{"label":"flask-wtf","value":"flask-wtf"},{"label":"flask-xml-rpc","value":"flask-xml-rpc"},{"label":"flatbuffers","value":"flatbuffers"},{"label":"flex","value":"flex"},{"label":"flexx","value":"flexx"},{"label":"flintqs","value":"flintqs"},{"label":"flit","value":"flit"},{"label":"flit_install_py2","value":"flit_install_py2"},{"label":"flo","value":"flo"},{"label":"flopy","value":"flopy"},{"label":"flower","value":"flower"},{"label":"flufl.enum","value":"flufl.enum"},{"label":"flup","value":"flup"},{"label":"fmilib","value":"fmilib"},{"label":"fmipp","value":"fmipp"},{"label":"folium","value":"folium"},{"label":"fontconfig","value":"fontconfig"},{"label":"forestci","value":"forestci"},{"label":"fortran-magic","value":"fortran-magic"},{"label":"fplll","value":"fplll"},{"label":"fpylll","value":"fpylll"},{"label":"freediscovery","value":"freediscovery"},{"label":"freeglut","value":"freeglut"},{"label":"freeimage","value":"freeimage"},{"label":"freetds","value":"freetds"},{"label":"freetype","value":"freetype"},{"label":"freexl","value":"freexl"},{"label":"freezegun","value":"freezegun"},{"label":"fretbursts","value":"fretbursts"},{"label":"frosted","value":"frosted"},{"label":"frozen-flask","value":"frozen-flask"},{"label":"frozendict","value":"frozendict"},{"label":"fs","value":"fs"},{"label":"ftfy","value":"ftfy"},{"label":"ftputil","value":"ftputil"},{"label":"funcargparse","value":"funcargparse"},{"label":"funcsigs","value":"funcsigs"},{"label":"functools32","value":"functools32"},{"label":"funcy","value":"funcy"},{"label":"furl","value":"furl"},{"label":"future","value":"future"},{"label":"futures","value":"futures"},{"label":"fuzzywuzzy","value":"fuzzywuzzy"},{"label":"g2clib","value":"g2clib"},{"label":"gala","value":"gala"},{"label":"galpy","value":"galpy"},{"label":"gammapy","value":"gammapy"},{"label":"gap","value":"gap"},{"label":"gazar","value":"gazar"},{"label":"gcsfs","value":"gcsfs"},{"label":"gdal","value":"gdal"},{"label":"gdb","value":"gdb"},{"label":"gdcm","value":"gdcm"},{"label":"gdk-pixbuf","value":"gdk-pixbuf"},{"label":"genpy","value":"genpy"},{"label":"genshi","value":"genshi"},{"label":"gensim","value":"gensim"},{"label":"genson","value":"genson"},{"label":"genutil","value":"genutil"},{"label":"geoalchemy2","value":"geoalchemy2"},{"label":"geocoder","value":"geocoder"},{"label":"geographiclib","value":"geographiclib"},{"label":"geoip","value":"geoip"},{"label":"geojson","value":"geojson"},{"label":"geojsonio","value":"geojsonio"},{"label":"geolinks","value":"geolinks"},{"label":"geomalgo","value":"geomalgo"},{"label":"geopandas","value":"geopandas"},{"label":"geoplot","value":"geoplot"},{"label":"geopy","value":"geopy"},{"label":"georaster","value":"georaster"},{"label":"george","value":"george"},{"label":"geos","value":"geos"},{"label":"gettext","value":"gettext"},{"label":"gevent","value":"gevent"},{"label":"gf2x","value":"gf2x"},{"label":"gfan","value":"gfan"},{"label":"gflags","value":"gflags"},{"label":"ggplot","value":"ggplot"},{"label":"gherkin-official","value":"gherkin-official"},{"label":"ghost.py","value":"ghost.py"},{"label":"ghostscript","value":"ghostscript"},{"label":"ghp-import","value":"ghp-import"},{"label":"giac","value":"giac"},{"label":"giflib","value":"giflib"},{"label":"ginga","value":"ginga"},{"label":"girder","value":"girder"},{"label":"girder-client","value":"girder-client"},{"label":"git","value":"git"},{"label":"git-lfs","value":"git-lfs"},{"label":"gitdb","value":"gitdb"},{"label":"gitdb2","value":"gitdb2"},{"label":"github3.py","value":"github3.py"},{"label":"gitpython","value":"gitpython"},{"label":"givaro","value":"givaro"},{"label":"gj2ascii","value":"gj2ascii"},{"label":"glances","value":"glances"},{"label":"glew","value":"glew"},{"label":"glib","value":"glib"},{"label":"glibmm","value":"glibmm"},{"label":"glimix-core","value":"glimix-core"},{"label":"glmnet","value":"glmnet"},{"label":"glob2","value":"glob2"},{"label":"glog","value":"glog"},{"label":"glpk","value":"glpk"},{"label":"glue-core","value":"glue-core"},{"label":"glue-vispy-viewers","value":"glue-vispy-viewers"},{"label":"glueviz","value":"glueviz"},{"label":"glymur","value":"glymur"},{"label":"gmaps","value":"gmaps"},{"label":"gmp","value":"gmp"},{"label":"gmpy2","value":"gmpy2"},{"label":"gmt","value":"gmt"},{"label":"gnuplot","value":"gnuplot"},{"label":"gnureadline","value":"gnureadline"},{"label":"gnutls","value":"gnutls"},{"label":"go-spatial","value":"go-spatial"},{"label":"gobject-introspection","value":"gobject-introspection"},{"label":"goftests","value":"goftests"},{"label":"google-api-python-client","value":"google-api-python-client"},{"label":"google-apputils","value":"google-apputils"},{"label":"google-auth","value":"google-auth"},{"label":"google-auth-httplib2","value":"google-auth-httplib2"},{"label":"google-auth-oauthlib","value":"google-auth-oauthlib"},{"label":"google-cloud-bigquery","value":"google-cloud-bigquery"},{"label":"google-cloud-core","value":"google-cloud-core"},{"label":"google-cloud-monitoring","value":"google-cloud-monitoring"},{"label":"google-cloud-storage","value":"google-cloud-storage"},{"label":"google-resumable-media","value":"google-resumable-media"},{"label":"googleapis-common-protos","value":"googleapis-common-protos"},{"label":"gperf","value":"gperf"},{"label":"gpxpy","value":"gpxpy"},{"label":"gpy","value":"gpy"},{"label":"graph","value":"graph"},{"label":"graphene","value":"graphene"},{"label":"graphite2","value":"graphite2"},{"label":"graphql-core","value":"graphql-core"},{"label":"graphql-relay","value":"graphql-relay"},{"label":"graphviz","value":"graphviz"},{"label":"green","value":"green"},{"label":"greenlet","value":"greenlet"},{"label":"grequests","value":"grequests"},{"label":"griddataformats","value":"griddataformats"},{"label":"gridded","value":"gridded"},{"label":"gridfill","value":"gridfill"},{"label":"gridgen","value":"gridgen"},{"label":"gridgeo","value":"gridgeo"},{"label":"gridutils","value":"gridutils"},{"label":"grin","value":"grin"},{"label":"gshhg-gmt","value":"gshhg-gmt"},{"label":"gsl","value":"gsl"},{"label":"gspread","value":"gspread"},{"label":"gsshapy","value":"gsshapy"},{"label":"gst-plugins-base","value":"gst-plugins-base"},{"label":"gstreamer","value":"gstreamer"},{"label":"gsw","value":"gsw"},{"label":"gtest","value":"gtest"},{"label":"gunicorn","value":"gunicorn"},{"label":"gwcs","value":"gwcs"},{"label":"h5netcdf","value":"h5netcdf"},{"label":"h5py","value":"h5py"},{"label":"habanero","value":"habanero"},{"label":"hachoir-core","value":"hachoir-core"},{"label":"hachoir-metadata","value":"hachoir-metadata"},{"label":"hachoir-parser","value":"hachoir-parser"},{"label":"hachoir-regex","value":"hachoir-regex"},{"label":"hachoir-subfile","value":"hachoir-subfile"},{"label":"hachoir-urwid","value":"hachoir-urwid"},{"label":"hachoir-wx","value":"hachoir-wx"},{"label":"halide","value":"halide"},{"label":"halotools","value":"halotools"},{"label":"happybase","value":"happybase"},{"label":"harfbuzz","value":"harfbuzz"},{"label":"haversine","value":"haversine"},{"label":"hcephes","value":"hcephes"},{"label":"hdbscan","value":"hdbscan"},{"label":"hdf4","value":"hdf4"},{"label":"hdf5","value":"hdf5"},{"label":"hdf5storage","value":"hdf5storage"},{"label":"hdfeos2","value":"hdfeos2"},{"label":"hdfeos5","value":"hdfeos5"},{"label":"hdfs3","value":"hdfs3"},{"label":"hdijupyterutils","value":"hdijupyterutils"},{"label":"healpy","value":"healpy"},{"label":"heapdict","value":"heapdict"},{"label":"help2man","value":"help2man"},{"label":"helper","value":"helper"},{"label":"hiredis","value":"hiredis"},{"label":"historydict","value":"historydict"},{"label":"hive-thrift-py","value":"hive-thrift-py"},{"label":"hiveplot","value":"hiveplot"},{"label":"hkdf","value":"hkdf"},{"label":"hmat-oss","value":"hmat-oss"},{"label":"holopy","value":"holopy"},{"label":"holoviews","value":"holoviews"},{"label":"homura","value":"homura"},{"label":"hpc05","value":"hpc05"},{"label":"html5lib","value":"html5lib"},{"label":"htmlmin","value":"htmlmin"},{"label":"htop","value":"htop"},{"label":"httplib2","value":"httplib2"},{"label":"httpretty","value":"httpretty"},{"label":"hug","value":"hug"},{"label":"humanfriendly","value":"humanfriendly"},{"label":"humanize","value":"humanize"},{"label":"hunspell","value":"hunspell"},{"label":"hunspell-en","value":"hunspell-en"},{"label":"hy","value":"hy"},{"label":"hyperion","value":"hyperion"},{"label":"hyperion-fortran","value":"hyperion-fortran"},{"label":"hyperlink","value":"hyperlink"},{"label":"hyperspy","value":"hyperspy"},{"label":"hyperspy-gui-ipywidgets","value":"hyperspy-gui-ipywidgets"},{"label":"hyperspy-gui-traitsui","value":"hyperspy-gui-traitsui"},{"label":"hypothesis","value":"hypothesis"},{"label":"hypre","value":"hypre"},{"label":"iapws","value":"iapws"},{"label":"ibis-framework","value":"ibis-framework"},{"label":"icalendar","value":"icalendar"},{"label":"icu","value":"icu"},{"label":"identify","value":"identify"},{"label":"idna","value":"idna"},{"label":"igraph","value":"igraph"},{"label":"ijroi","value":"ijroi"},{"label":"ijson","value":"ijson"},{"label":"image-meta-tag","value":"image-meta-tag"},{"label":"imagehash","value":"imagehash"},{"label":"imageio","value":"imageio"},{"label":"imagemagick","value":"imagemagick"},{"label":"imagesize","value":"imagesize"},{"label":"imapclient","value":"imapclient"},{"label":"imexam","value":"imexam"},{"label":"imgroi","value":"imgroi"},{"label":"imgurpython","value":"imgurpython"},{"label":"iminuit","value":"iminuit"},{"label":"iml","value":"iml"},{"label":"importlib","value":"importlib"},{"label":"importscan","value":"importscan"},{"label":"impyla","value":"impyla"},{"label":"imread","value":"imread"},{"label":"incremental","value":"incremental"},{"label":"infinity","value":"infinity"},{"label":"inflect","value":"inflect"},{"label":"inflection","value":"inflection"},{"label":"inifile","value":"inifile"},{"label":"inkscape","value":"inkscape"},{"label":"inotify-tools","value":"inotify-tools"},{"label":"inspyred","value":"inspyred"},{"label":"instaseis","value":"instaseis"},{"label":"interlap","value":"interlap"},{"label":"interpolation","value":"interpolation"},{"label":"intervals","value":"intervals"},{"label":"intltool","value":"intltool"},{"label":"invoke","value":"invoke"},{"label":"iolabs","value":"iolabs"},{"label":"ioos_qartod","value":"ioos_qartod"},{"label":"ioos_tools","value":"ioos_tools"},{"label":"iowait","value":"iowait"},{"label":"ipaddr","value":"ipaddr"},{"label":"ipaddress","value":"ipaddress"},{"label":"ipdb","value":"ipdb"},{"label":"iperf","value":"iperf"},{"label":"ipopt","value":"ipopt"},{"label":"ipycache","value":"ipycache"},{"label":"ipykernel","value":"ipykernel"},{"label":"ipyleaflet","value":"ipyleaflet"},{"label":"ipympl","value":"ipympl"},{"label":"ipyparallel","value":"ipyparallel"},{"label":"ipython","value":"ipython"},{"label":"ipython-autotime","value":"ipython-autotime"},{"label":"ipython-sql","value":"ipython-sql"},{"label":"ipython_genutils","value":"ipython_genutils"},{"label":"ipython_unittest","value":"ipython_unittest"},{"label":"ipyvolume","value":"ipyvolume"},{"label":"ipywebrtc","value":"ipywebrtc"},{"label":"ipywidgets","value":"ipywidgets"},{"label":"iris","value":"iris"},{"label":"iris-grib","value":"iris-grib"},{"label":"iris-sample-data","value":"iris-sample-data"},{"label":"isl","value":"isl"},{"label":"islpy","value":"islpy"},{"label":"iso8601","value":"iso8601"},{"label":"isodate","value":"isodate"},{"label":"isort","value":"isort"},{"label":"iteration_utilities","value":"iteration_utilities"},{"label":"iterm2-tools","value":"iterm2-tools"},{"label":"itk","value":"itk"},{"label":"itsdangerous","value":"itsdangerous"},{"label":"iverilog","value":"iverilog"},{"label":"jansson","value":"jansson"},{"label":"jaraco.classes","value":"jaraco.classes"},{"label":"jaraco.logging","value":"jaraco.logging"},{"label":"jaraco.stream","value":"jaraco.stream"},{"label":"jasper","value":"jasper"},{"label":"jbig","value":"jbig"},{"label":"jcc","value":"jcc"},{"label":"jdatetime","value":"jdatetime"},{"label":"jdcal","value":"jdcal"},{"label":"jedi","value":"jedi"},{"label":"jellyfish","value":"jellyfish"},{"label":"jemalloc","value":"jemalloc"},{"label":"jenkspy","value":"jenkspy"},{"label":"jftools","value":"jftools"},{"label":"jieba","value":"jieba"},{"label":"jinja2","value":"jinja2"},{"label":"jinja2-time","value":"jinja2-time"},{"label":"jira","value":"jira"},{"label":"jmespath","value":"jmespath"},{"label":"joblib","value":"joblib"},{"label":"jobtastic","value":"jobtastic"},{"label":"joommfutil","value":"joommfutil"},{"label":"jpeg","value":"jpeg"},{"label":"jplephem","value":"jplephem"},{"label":"jpype1","value":"jpype1"},{"label":"jq","value":"jq"},{"label":"jsanimation","value":"jsanimation"},{"label":"jsdom","value":"jsdom"},{"label":"jsmin","value":"jsmin"},{"label":"json-c","value":"json-c"},{"label":"json-rpc","value":"json-rpc"},{"label":"jsonapi-client","value":"jsonapi-client"},{"label":"jsonapi-requests","value":"jsonapi-requests"},{"label":"jsoncpp","value":"jsoncpp"},{"label":"jsonlines","value":"jsonlines"},{"label":"jsonpatch","value":"jsonpatch"},{"label":"jsonpickle","value":"jsonpickle"},{"label":"jsonpointer","value":"jsonpointer"},{"label":"jsonschema","value":"jsonschema"},{"label":"jsontableschema","value":"jsontableschema"},{"label":"jsontableschema-pandas","value":"jsontableschema-pandas"},{"label":"julia","value":"julia"},{"label":"jupyter","value":"jupyter"},{"label":"jupyter-dashboards-server","value":"jupyter-dashboards-server"},{"label":"jupyter-themer","value":"jupyter-themer"},{"label":"jupyter_client","value":"jupyter_client"},{"label":"jupyter_cms","value":"jupyter_cms"},{"label":"jupyter_console","value":"jupyter_console"},{"label":"jupyter_contrib_core","value":"jupyter_contrib_core"},{"label":"jupyter_contrib_nbextensions","value":"jupyter_contrib_nbextensions"},{"label":"jupyter_core","value":"jupyter_core"},{"label":"jupyter_dashboards","value":"jupyter_dashboards"},{"label":"jupyter_dojo","value":"jupyter_dojo"},{"label":"jupyter_full_width","value":"jupyter_full_width"},{"label":"jupyter_highlight_selected_word","value":"jupyter_highlight_selected_word"},{"label":"jupyter_kernel_gateway","value":"jupyter_kernel_gateway"},{"label":"jupyter_latex_envs","value":"jupyter_latex_envs"},{"label":"jupyter_nbextensions_configurator","value":"jupyter_nbextensions_configurator"},{"label":"jupyter_qtconsole_colorschemes","value":"jupyter_qtconsole_colorschemes"},{"label":"jupyter_sphinx","value":"jupyter_sphinx"},{"label":"jupyterhub","value":"jupyterhub"},{"label":"jupyterlab","value":"jupyterlab"},{"label":"jupyterlab_launcher","value":"jupyterlab_launcher"},{"label":"jupyterthemes","value":"jupyterthemes"},{"label":"kafka-python","value":"kafka-python"},{"label":"kafkacat","value":"kafkacat"},{"label":"kaldi","value":"kaldi"},{"label":"kapteyn","value":"kapteyn"},{"label":"kazoo","value":"kazoo"},{"label":"kealib","value":"kealib"},{"label":"keepalive","value":"keepalive"},{"label":"kenjutsu","value":"kenjutsu"},{"label":"keras","value":"keras"},{"label":"kernda","value":"kernda"},{"label":"keyring","value":"keyring"},{"label":"keyrings.alt","value":"keyrings.alt"},{"label":"keystoneauth1","value":"keystoneauth1"},{"label":"khronos-opencl-icd-loader","value":"khronos-opencl-icd-loader"},{"label":"kiwisolver","value":"kiwisolver"},{"label":"knit","value":"knit"},{"label":"kombu","value":"kombu"},{"label":"krb5","value":"krb5"},{"label":"kuyruk","value":"kuyruk"},{"label":"kwant","value":"kwant"},{"label":"labjackpython","value":"labjackpython"},{"label":"lagranto","value":"lagranto"},{"label":"lancet","value":"lancet"},{"label":"landsat_util","value":"landsat_util"},{"label":"langdetect","value":"langdetect"},{"label":"lapack","value":"lapack"},{"label":"larray","value":"larray"},{"label":"larray_eurostat","value":"larray_eurostat"},{"label":"larrayenv","value":"larrayenv"},{"label":"lastools","value":"lastools"},{"label":"latexcodec","value":"latexcodec"},{"label":"lazy","value":"lazy"},{"label":"lazy-object-proxy","value":"lazy-object-proxy"},{"label":"lazyasd","value":"lazyasd"},{"label":"lbzip2","value":"lbzip2"},{"label":"lcalc","value":"lcalc"},{"label":"ldap3","value":"ldap3"},{"label":"ldaptor","value":"ldaptor"},{"label":"leather","value":"leather"},{"label":"legit","value":"legit"},{"label":"lektor","value":"lektor"},{"label":"lemon","value":"lemon"},{"label":"lesscpy","value":"lesscpy"},{"label":"leveldb","value":"leveldb"},{"label":"lftp","value":"lftp"},{"label":"libadjoint","value":"libadjoint"},{"label":"libarchive","value":"libarchive"},{"label":"libatomic_ops","value":"libatomic_ops"},{"label":"libblitz","value":"libblitz"},{"label":"libcdms","value":"libcdms"},{"label":"libcf","value":"libcf"},{"label":"libcmaes","value":"libcmaes"},{"label":"libconda","value":"libconda"},{"label":"libconfig","value":"libconfig"},{"label":"libcxx","value":"libcxx"},{"label":"libdap4","value":"libdap4"},{"label":"libdrs","value":"libdrs"},{"label":"libdrs_f","value":"libdrs_f"},{"label":"libev","value":"libev"},{"label":"libevent","value":"libevent"},{"label":"libffi","value":"libffi"},{"label":"libflac","value":"libflac"},{"label":"libflint","value":"libflint"},{"label":"libgap","value":"libgap"},{"label":"libgcrypt","value":"libgcrypt"},{"label":"libgd","value":"libgd"},{"label":"libgdal","value":"libgdal"},{"label":"libgfortran","value":"libgfortran"},{"label":"libgit2","value":"libgit2"},{"label":"libglu","value":"libglu"},{"label":"libgpg-error","value":"libgpg-error"},{"label":"libgpuarray","value":"libgpuarray"},{"label":"libgsasl","value":"libgsasl"},{"label":"libhdfs3","value":"libhdfs3"},{"label":"libhwloc","value":"libhwloc"},{"label":"libiconv","value":"libiconv"},{"label":"libidn11","value":"libidn11"},{"label":"libitk","value":"libitk"},{"label":"libjpeg-turbo","value":"libjpeg-turbo"},{"label":"libkml","value":"libkml"},{"label":"libmad","value":"libmad"},{"label":"libmagic","value":"libmagic"},{"label":"libmatio","value":"libmatio"},{"label":"libmemcached","value":"libmemcached"},{"label":"libmo_unpack","value":"libmo_unpack"},{"label":"libnetcdf","value":"libnetcdf"},{"label":"libntlm","value":"libntlm"},{"label":"libogg","value":"libogg"},{"label":"libosxunwind","value":"libosxunwind"},{"label":"libpng","value":"libpng"},{"label":"libpq","value":"libpq"},{"label":"librabbitmq","value":"librabbitmq"},{"label":"libradolan","value":"libradolan"},{"label":"librdkafka","value":"librdkafka"},{"label":"librosa","value":"librosa"},{"label":"libsakura","value":"libsakura"},{"label":"libsass","value":"libsass"},{"label":"libsemigroups","value":"libsemigroups"},{"label":"libsemigroups-python-bindings","value":"libsemigroups-python-bindings"},{"label":"libsigcpp","value":"libsigcpp"},{"label":"libsndfile","value":"libsndfile"},{"label":"libsodium","value":"libsodium"},{"label":"libspatialindex","value":"libspatialindex"},{"label":"libspatialite","value":"libspatialite"},{"label":"libssh2","value":"libssh2"},{"label":"libsvm","value":"libsvm"},{"label":"libtheora","value":"libtheora"},{"label":"libtiff","value":"libtiff"},{"label":"libtool","value":"libtool"},{"label":"libunistring","value":"libunistring"},{"label":"libuuid","value":"libuuid"},{"label":"libuv","value":"libuv"},{"label":"libvorbis","value":"libvorbis"},{"label":"libwebp","value":"libwebp"},{"label":"libxcb","value":"libxcb"},{"label":"libxml2","value":"libxml2"},{"label":"libxmlpp","value":"libxmlpp"},{"label":"libxslt","value":"libxslt"},{"label":"lifelines","value":"lifelines"},{"label":"lightgbm","value":"lightgbm"},{"label":"liknorm","value":"liknorm"},{"label":"liknorm-py","value":"liknorm-py"},{"label":"lime","value":"lime"},{"label":"limix","value":"limix"},{"label":"limix-core","value":"limix-core"},{"label":"limix-inference","value":"limix-inference"},{"label":"limix-legacy","value":"limix-legacy"},{"label":"linbox","value":"linbox"},{"label":"line_profiler","value":"line_profiler"},{"label":"linear-tsv","value":"linear-tsv"},{"label":"linecache2","value":"linecache2"},{"label":"link-traits","value":"link-traits"},{"label":"livereload","value":"livereload"},{"label":"llvmdev","value":"llvmdev"},{"label":"lmdb","value":"lmdb"},{"label":"lmfit","value":"lmfit"},{"label":"lml","value":"lml"},{"label":"lmod","value":"lmod"},{"label":"locket","value":"locket"},{"label":"lockfile","value":"lockfile"},{"label":"loghub","value":"loghub"},{"label":"logilab-common","value":"logilab-common"},{"label":"lorem","value":"lorem"},{"label":"louvain","value":"louvain"},{"label":"lp_solve","value":"lp_solve"},{"label":"lrcalc","value":"lrcalc"},{"label":"lua","value":"lua"},{"label":"lua-luafilesystem","value":"lua-luafilesystem"},{"label":"lua-luaposix","value":"lua-luaposix"},{"label":"luarocks","value":"luarocks"},{"label":"luigi","value":"luigi"},{"label":"lxml","value":"lxml"},{"label":"lynx","value":"lynx"},{"label":"lz4-c","value":"lz4-c"},{"label":"lzfse","value":"lzfse"},{"label":"lzo","value":"lzo"},{"label":"lzstring","value":"lzstring"},{"label":"m2crypto","value":"m2crypto"},{"label":"m2w64-muparser","value":"m2w64-muparser"},{"label":"m4","value":"m4"},{"label":"m4ri","value":"m4ri"},{"label":"m4rie","value":"m4rie"},{"label":"magics","value":"magics"},{"label":"mahotas","value":"mahotas"},{"label":"make","value":"make"},{"label":"mako","value":"mako"},{"label":"maltpynt","value":"maltpynt"},{"label":"mapkit","value":"mapkit"},{"label":"markdown","value":"markdown"},{"label":"markdown-checklist","value":"markdown-checklist"},{"label":"markdown2","value":"markdown2"},{"label":"markovify","value":"markovify"},{"label":"markupsafe","value":"markupsafe"},{"label":"marray","value":"marray"},{"label":"marshmallow","value":"marshmallow"},{"label":"marshmallow-jsonapi","value":"marshmallow-jsonapi"},{"label":"marshmallow-sqlalchemy","value":"marshmallow-sqlalchemy"},{"label":"mastodon.py","value":"mastodon.py"},{"label":"matplotlib","value":"matplotlib"},{"label":"matplotlib-venn","value":"matplotlib-venn"},{"label":"maven","value":"maven"},{"label":"maxima","value":"maxima"},{"label":"maya","value":"maya"},{"label":"mayavi","value":"mayavi"},{"label":"mccabe","value":"mccabe"},{"label":"mdanalysis","value":"mdanalysis"},{"label":"mdanalysistests","value":"mdanalysistests"},{"label":"mdsrv","value":"mdsrv"},{"label":"mdsynthesis","value":"mdsynthesis"},{"label":"mdtraj","value":"mdtraj"},{"label":"mechanicalsoup","value":"mechanicalsoup"},{"label":"mechanize","value":"mechanize"},{"label":"megaman","value":"megaman"},{"label":"memory_profiler","value":"memory_profiler"},{"label":"memprof","value":"memprof"},{"label":"mercantile","value":"mercantile"},{"label":"mercurial","value":"mercurial"},{"label":"mesalib","value":"mesalib"},{"label":"metafone","value":"metafone"},{"label":"metakernel","value":"metakernel"},{"label":"metaphone","value":"metaphone"},{"label":"metawrap","value":"metawrap"},{"label":"metis","value":"metis"},{"label":"metpy","value":"metpy"},{"label":"micromagneticmodel","value":"micromagneticmodel"},{"label":"miktex","value":"miktex"},{"label":"mimerender","value":"mimerender"},{"label":"mingwpy","value":"mingwpy"},{"label":"misaka","value":"misaka"},{"label":"missingno","value":"missingno"},{"label":"mistune","value":"mistune"},{"label":"mizani","value":"mizani"},{"label":"mkdocs","value":"mkdocs"},{"label":"mkdocs-bootstrap","value":"mkdocs-bootstrap"},{"label":"mkdocs-bootswatch","value":"mkdocs-bootswatch"},{"label":"mlxtend","value":"mlxtend"},{"label":"mmtf-python","value":"mmtf-python"},{"label":"mne","value":"mne"},{"label":"mo_pack","value":"mo_pack"},{"label":"moab","value":"moab"},{"label":"mock","value":"mock"},{"label":"mockredispy","value":"mockredispy"},{"label":"mocsy","value":"mocsy"},{"label":"modepy","value":"modepy"},{"label":"modernize","value":"modernize"},{"label":"modflow2netcdf","value":"modflow2netcdf"},{"label":"molpx","value":"molpx"},{"label":"mongoengine","value":"mongoengine"},{"label":"mongoquery","value":"mongoquery"},{"label":"mono","value":"mono"},{"label":"monotonic","value":"monotonic"},{"label":"monty","value":"monty"},{"label":"more-itertools","value":"more-itertools"},{"label":"more.forwarded","value":"more.forwarded"},{"label":"more.pathtool","value":"more.pathtool"},{"label":"more.static","value":"more.static"},{"label":"morepath","value":"morepath"},{"label":"morfessor","value":"morfessor"},{"label":"mosfit","value":"mosfit"},{"label":"mosh","value":"mosh"},{"label":"moto","value":"moto"},{"label":"moviepy","value":"moviepy"},{"label":"mox","value":"mox"},{"label":"mpc","value":"mpc"},{"label":"mpfi","value":"mpfi"},{"label":"mpfr","value":"mpfr"},{"label":"mpg123","value":"mpg123"},{"label":"mpi4py","value":"mpi4py"},{"label":"mpich","value":"mpich"},{"label":"mpifft4py","value":"mpifft4py"},{"label":"mpir","value":"mpir"},{"label":"mpl-probscale","value":"mpl-probscale"},{"label":"mpl-scatter-density","value":"mpl-scatter-density"},{"label":"mpl_sample_data","value":"mpl_sample_data"},{"label":"mpld3","value":"mpld3"},{"label":"mplexporter","value":"mplexporter"},{"label":"mplleaflet","value":"mplleaflet"},{"label":"mplview","value":"mplview"},{"label":"mpmath","value":"mpmath"},{"label":"mppp","value":"mppp"},{"label":"mr.bob","value":"mr.bob"},{"label":"mrjob","value":"mrjob"},{"label":"msg-extractor","value":"msg-extractor"},{"label":"msgpack-c","value":"msgpack-c"},{"label":"msgpack-python","value":"msgpack-python"},{"label":"mshr","value":"mshr"},{"label":"msinttypes","value":"msinttypes"},{"label":"msmbuilder","value":"msmbuilder"},{"label":"msmtools","value":"msmtools"},{"label":"mss","value":"mss"},{"label":"mtspec","value":"mtspec"},{"label":"mu_repo","value":"mu_repo"},{"label":"multidict","value":"multidict"},{"label":"multipledispatch","value":"multipledispatch"},{"label":"multiprocess","value":"multiprocess"},{"label":"mumps","value":"mumps"},{"label":"munch","value":"munch"},{"label":"muparser","value":"muparser"},{"label":"murmurhash","value":"murmurhash"},{"label":"murphy","value":"murphy"},{"label":"mutagen","value":"mutagen"},{"label":"mwclient","value":"mwclient"},{"label":"myproxyclient","value":"myproxyclient"},{"label":"mysql-connector-c","value":"mysql-connector-c"},{"label":"mysql-connector-python","value":"mysql-connector-python"},{"label":"naima","value":"naima"},{"label":"namedlist","value":"namedlist"},{"label":"nanoflann","value":"nanoflann"},{"label":"natsort","value":"natsort"},{"label":"nauty","value":"nauty"},{"label":"nb_anacondacloud","value":"nb_anacondacloud"},{"label":"nb_conda","value":"nb_conda"},{"label":"nb_conda_kernels","value":"nb_conda_kernels"},{"label":"nbbrowserpdf","value":"nbbrowserpdf"},{"label":"nbconvert","value":"nbconvert"},{"label":"nbdime","value":"nbdime"},{"label":"nbexamples","value":"nbexamples"},{"label":"nbfinder","value":"nbfinder"},{"label":"nbformat","value":"nbformat"},{"label":"nbgrader","value":"nbgrader"},{"label":"nbpresent","value":"nbpresent"},{"label":"nbsphinx","value":"nbsphinx"},{"label":"nbstripout","value":"nbstripout"},{"label":"nbtutor","value":"nbtutor"},{"label":"nbval","value":"nbval"},{"label":"nc_time_axis","value":"nc_time_axis"},{"label":"ncephes","value":"ncephes"},{"label":"ncl","value":"ncl"},{"label":"nco","value":"nco"},{"label":"ncpol2sdpa","value":"ncpol2sdpa"},{"label":"ncurses","value":"ncurses"},{"label":"nd2reader","value":"nd2reader"},{"label":"ndarray_listener","value":"ndarray_listener"},{"label":"ndg-httpsclient","value":"ndg-httpsclient"},{"label":"neo4j-python-driver","value":"neo4j-python-driver"},{"label":"neomodel","value":"neomodel"},{"label":"neovim","value":"neovim"},{"label":"nestly","value":"nestly"},{"label":"netaddr","value":"netaddr"},{"label":"netcdf-cxx4","value":"netcdf-cxx4"},{"label":"netcdf-fortran","value":"netcdf-fortran"},{"label":"netcdf4","value":"netcdf4"},{"label":"netifaces","value":"netifaces"},{"label":"nettle","value":"nettle"},{"label":"networkx","value":"networkx"},{"label":"newrelic","value":"newrelic"},{"label":"nfft","value":"nfft"},{"label":"nginx","value":"nginx"},{"label":"nglview","value":"nglview"},{"label":"nibabel","value":"nibabel"},{"label":"nilearn","value":"nilearn"},{"label":"ninja","value":"ninja"},{"label":"ninja_syntax","value":"ninja_syntax"},{"label":"nipy","value":"nipy"},{"label":"nipype","value":"nipype"},{"label":"nitime","value":"nitime"},{"label":"nlopt","value":"nlopt"},{"label":"nltk","value":"nltk"},{"label":"nn","value":"nn"},{"label":"nodeenv","value":"nodeenv"},{"label":"nodejs","value":"nodejs"},{"label":"nose","value":"nose"},{"label":"nose-cov","value":"nose-cov"},{"label":"nose-progressive","value":"nose-progressive"},{"label":"nose-timer","value":"nose-timer"},{"label":"nose_parameterized","value":"nose_parameterized"},{"label":"nosexcover","value":"nosexcover"},{"label":"notebook","value":"notebook"},{"label":"npctypes","value":"npctypes"},{"label":"nr","value":"nr"},{"label":"nsis","value":"nsis"},{"label":"ntl","value":"ntl"},{"label":"nuitka","value":"nuitka"},{"label":"numcodecs","value":"numcodecs"},{"label":"numexpr","value":"numexpr"},{"label":"numpy","value":"numpy"},{"label":"numpy-indexed","value":"numpy-indexed"},{"label":"numpy_groupies","value":"numpy_groupies"},{"label":"numpy_sugar","value":"numpy_sugar"},{"label":"numpydoc","value":"numpydoc"},{"label":"nxviz","value":"nxviz"},{"label":"oauth2client","value":"oauth2client"},{"label":"oauthlib","value":"oauthlib"},{"label":"obspy","value":"obspy"},{"label":"obspyck","value":"obspyck"},{"label":"obvious-ci","value":"obvious-ci"},{"label":"occt","value":"occt"},{"label":"oceans","value":"oceans"},{"label":"ocgis","value":"ocgis"},{"label":"ocl-icd","value":"ocl-icd"},{"label":"oct2py","value":"oct2py"},{"label":"octave","value":"octave"},{"label":"octave_kernel","value":"octave_kernel"},{"label":"ocw","value":"ocw"},{"label":"odfpy","value":"odfpy"},{"label":"odo","value":"odo"},{"label":"odvc","value":"odvc"},{"label":"olefile","value":"olefile"},{"label":"omnifit","value":"omnifit"},{"label":"oniguruma","value":"oniguruma"},{"label":"oommf","value":"oommf"},{"label":"oommfodt","value":"oommfodt"},{"label":"opbeat","value":"opbeat"},{"label":"openblas","value":"openblas"},{"label":"opencv","value":"opencv"},{"label":"openfst","value":"openfst"},{"label":"openjdk","value":"openjdk"},{"label":"openjpeg","value":"openjpeg"},{"label":"openlibm","value":"openlibm"},{"label":"openmc","value":"openmc"},{"label":"openmesh","value":"openmesh"},{"label":"openmotif","value":"openmotif"},{"label":"openmp","value":"openmp"},{"label":"openmpi","value":"openmpi"},{"label":"openpiv","value":"openpiv"},{"label":"openpyxl","value":"openpyxl"},{"label":"openspecfun","value":"openspecfun"},{"label":"openssl","value":"openssl"},{"label":"openstacksdk","value":"openstacksdk"},{"label":"openturns","value":"openturns"},{"label":"opt_einsum","value":"opt_einsum"},{"label":"optimix","value":"optimix"},{"label":"opty","value":"opty"},{"label":"oq-engine","value":"oq-engine"},{"label":"orange3","value":"orange3"},{"label":"orange3-geo","value":"orange3-geo"},{"label":"orange3-network","value":"orange3-network"},{"label":"orange3-text","value":"orange3-text"},{"label":"orange3-timeseries","value":"orange3-timeseries"},{"label":"orca","value":"orca"},{"label":"orcid","value":"orcid"},{"label":"ordered-set","value":"ordered-set"},{"label":"ordereddict","value":"ordereddict"},{"label":"orderedmultidict","value":"orderedmultidict"},{"label":"orderedset","value":"orderedset"},{"label":"orekit","value":"orekit"},{"label":"os-client-config","value":"os-client-config"},{"label":"oset","value":"oset"},{"label":"osfclient","value":"osfclient"},{"label":"oslo.config","value":"oslo.config"},{"label":"oslo.i18n","value":"oslo.i18n"},{"label":"oslo.serialization","value":"oslo.serialization"},{"label":"oslo.utils","value":"oslo.utils"},{"label":"osmnet","value":"osmnet"},{"label":"osmnx","value":"osmnx"},{"label":"ossuuid","value":"ossuuid"},{"label":"osx-pocl-opencl","value":"osx-pocl-opencl"},{"label":"otfftw","value":"otfftw"},{"label":"otfmi","value":"otfmi"},{"label":"otlm","value":"otlm"},{"label":"otmorris","value":"otmorris"},{"label":"otpmml","value":"otpmml"},{"label":"otpod","value":"otpod"},{"label":"otrobopt","value":"otrobopt"},{"label":"otsvm","value":"otsvm"},{"label":"otwrapy","value":"otwrapy"},{"label":"owslib","value":"owslib"},{"label":"packaging","value":"packaging"},{"label":"paegan","value":"paegan"},{"label":"paegan-transport","value":"paegan-transport"},{"label":"pagmo","value":"pagmo"},{"label":"palettable","value":"palettable"},{"label":"palp","value":"palp"},{"label":"pamela","value":"pamela"},{"label":"pandas","value":"pandas"},{"label":"pandas-compat","value":"pandas-compat"},{"label":"pandas-datareader","value":"pandas-datareader"},{"label":"pandas-gbq","value":"pandas-gbq"},{"label":"pandas-highcharts","value":"pandas-highcharts"},{"label":"pandas-msgpack","value":"pandas-msgpack"},{"label":"pandas-plink","value":"pandas-plink"},{"label":"pandas-profiling","value":"pandas-profiling"},{"label":"pandas-summary","value":"pandas-summary"},{"label":"pandoc","value":"pandoc"},{"label":"pandoc-attributes","value":"pandoc-attributes"},{"label":"pandocfilters","value":"pandocfilters"},{"label":"panedr","value":"panedr"},{"label":"pangaea","value":"pangaea"},{"label":"pango","value":"pango"},{"label":"param","value":"param"},{"label":"paramiko","value":"paramiko"},{"label":"paramz","value":"paramz"},{"label":"paraview","value":"paraview"},{"label":"pari","value":"pari"},{"label":"parquet-cpp","value":"parquet-cpp"},{"label":"parse","value":"parse"},{"label":"parse_type","value":"parse_type"},{"label":"parsedatetime","value":"parsedatetime"},{"label":"partd","value":"partd"},{"label":"passlib","value":"passlib"},{"label":"paste","value":"paste"},{"label":"pastescript","value":"pastescript"},{"label":"patch","value":"patch"},{"label":"patchelf","value":"patchelf"},{"label":"path.py","value":"path.py"},{"label":"pathlib","value":"pathlib"},{"label":"pathlib2","value":"pathlib2"},{"label":"pathos","value":"pathos"},{"label":"pathtools","value":"pathtools"},{"label":"patsy","value":"patsy"},{"label":"paver","value":"paver"},{"label":"pbr","value":"pbr"},{"label":"pbzip2","value":"pbzip2"},{"label":"pcre","value":"pcre"},{"label":"pcre2","value":"pcre2"},{"label":"pdbpp","value":"pdbpp"},{"label":"pdfminer","value":"pdfminer"},{"label":"pdfminer.six","value":"pdfminer.six"},{"label":"pdfminer3k","value":"pdfminer3k"},{"label":"pdir2","value":"pdir2"},{"label":"peakutils","value":"peakutils"},{"label":"peewee","value":"peewee"},{"label":"pefile","value":"pefile"},{"label":"pelican","value":"pelican"},{"label":"pendulum","value":"pendulum"},{"label":"pep257","value":"pep257"},{"label":"pep8","value":"pep8"},{"label":"pep8-naming","value":"pep8-naming"},{"label":"periodictable","value":"periodictable"},{"label":"perl","value":"perl"},{"label":"perl-app-cpanminus","value":"perl-app-cpanminus"},{"label":"perl-xml-parser","value":"perl-xml-parser"},{"label":"permission","value":"permission"},{"label":"pescador","value":"pescador"},{"label":"petl","value":"petl"},{"label":"petsc","value":"petsc"},{"label":"petsc4py","value":"petsc4py"},{"label":"petulant-bear","value":"petulant-bear"},{"label":"pexpect","value":"pexpect"},{"label":"pgcli","value":"pgcli"},{"label":"pgplot","value":"pgplot"},{"label":"pgspecial","value":"pgspecial"},{"label":"phantomjs","value":"phantomjs"},{"label":"phconvert","value":"phconvert"},{"label":"phonenumbers","value":"phonenumbers"},{"label":"phonopy","value":"phonopy"},{"label":"photutils","value":"photutils"},{"label":"phreeqpy","value":"phreeqpy"},{"label":"pickleshare","value":"pickleshare"},{"label":"pies","value":"pies"},{"label":"pies2overrides","value":"pies2overrides"},{"label":"pigz","value":"pigz"},{"label":"pika","value":"pika"},{"label":"pillow","value":"pillow"},{"label":"pims","value":"pims"},{"label":"pint","value":"pint"},{"label":"pip","value":"pip"},{"label":"pipreqs","value":"pipreqs"},{"label":"piranha","value":"piranha"},{"label":"pixman","value":"pixman"},{"label":"pkg-config","value":"pkg-config"},{"label":"pkgconfig","value":"pkgconfig"},{"label":"pkginfo","value":"pkginfo"},{"label":"plac","value":"plac"},{"label":"planarity","value":"planarity"},{"label":"planetaryimage","value":"planetaryimage"},{"label":"plotly","value":"plotly"},{"label":"plotnine","value":"plotnine"},{"label":"pluggy","value":"pluggy"},{"label":"plumbum","value":"plumbum"},{"label":"plumpy","value":"plumpy"},{"label":"ply","value":"ply"},{"label":"pmw","value":"pmw"},{"label":"pocean-core","value":"pocean-core"},{"label":"pocket","value":"pocket"},{"label":"pocl","value":"pocl"},{"label":"podaacpy","value":"podaacpy"},{"label":"polcart","value":"polcart"},{"label":"poliastro","value":"poliastro"},{"label":"polib","value":"polib"},{"label":"polyline","value":"polyline"},{"label":"pony","value":"pony"},{"label":"poppler","value":"poppler"},{"label":"poppler-data","value":"poppler-data"},{"label":"port-for","value":"port-for"},{"label":"portend","value":"portend"},{"label":"positional","value":"positional"},{"label":"poster","value":"poster"},{"label":"postgresql","value":"postgresql"},{"label":"pot","value":"pot"},{"label":"pox","value":"pox"},{"label":"poyo","value":"poyo"},{"label":"ppft","value":"ppft"},{"label":"ppl","value":"ppl"},{"label":"pprintpp","value":"pprintpp"},{"label":"pprofile","value":"pprofile"},{"label":"pre_commit","value":"pre_commit"},{"label":"prefsync","value":"prefsync"},{"label":"premailer","value":"premailer"},{"label":"preprocess","value":"preprocess"},{"label":"preshed","value":"preshed"},{"label":"pretend","value":"pretend"},{"label":"prettytable","value":"prettytable"},{"label":"primesieve","value":"primesieve"},{"label":"probableparsing","value":"probableparsing"},{"label":"probablepeople","value":"probablepeople"},{"label":"progress","value":"progress"},{"label":"progress_reporter","value":"progress_reporter"},{"label":"progressbar2","value":"progressbar2"},{"label":"proj.4","value":"proj.4"},{"label":"prometheus_client","value":"prometheus_client"},{"label":"promise","value":"promise"},{"label":"prompt","value":"prompt"},{"label":"prompt_toolkit","value":"prompt_toolkit"},{"label":"proof","value":"proof"},{"label":"properties","value":"properties"},{"label":"prospector","value":"prospector"},{"label":"protobuf","value":"protobuf"},{"label":"prov","value":"prov"},{"label":"psiturk","value":"psiturk"},{"label":"pstdint","value":"pstdint"},{"label":"psutil","value":"psutil"},{"label":"psy-maps","value":"psy-maps"},{"label":"psy-reg","value":"psy-reg"},{"label":"psy-simple","value":"psy-simple"},{"label":"psycogreen","value":"psycogreen"},{"label":"psycopg2","value":"psycopg2"},{"label":"psyplot","value":"psyplot"},{"label":"psyplot-gui","value":"psyplot-gui"},{"label":"pthread-stubs","value":"pthread-stubs"},{"label":"pthreads-win32","value":"pthreads-win32"},{"label":"ptyprocess","value":"ptyprocess"},{"label":"publish","value":"publish"},{"label":"pudb","value":"pudb"},{"label":"pugixml","value":"pugixml"},{"label":"pulsewaves","value":"pulsewaves"},{"label":"pure-sasl","value":"pure-sasl"},{"label":"purepng","value":"purepng"},{"label":"pv","value":"pv"},{"label":"pvl","value":"pvl"},{"label":"pvlib-python","value":"pvlib-python"},{"label":"pweave","value":"pweave"},{"label":"px4tools","value":"px4tools"},{"label":"py","value":"py"},{"label":"py-cpuinfo","value":"py-cpuinfo"},{"label":"py-lz4framed","value":"py-lz4framed"},{"label":"py-ubjson","value":"py-ubjson"},{"label":"py2neo","value":"py2neo"},{"label":"py4j","value":"py4j"},{"label":"py6s","value":"py6s"},{"label":"py_gd","value":"py_gd"},{"label":"pyabel","value":"pyabel"},{"label":"pyagrum","value":"pyagrum"},{"label":"pyamg","value":"pyamg"},{"label":"pyaml","value":"pyaml"},{"label":"pyarrow","value":"pyarrow"},{"label":"pyasdf","value":"pyasdf"},{"label":"pyasn1","value":"pyasn1"},{"label":"pyasn1-modules","value":"pyasn1-modules"},{"label":"pyaxiom","value":"pyaxiom"},{"label":"pybind11","value":"pybind11"},{"label":"pybinding","value":"pybinding"},{"label":"pybroom","value":"pybroom"},{"label":"pybtex","value":"pybtex"},{"label":"pybtex-docutils","value":"pybtex-docutils"},{"label":"pybufr-ecmwf","value":"pybufr-ecmwf"},{"label":"pycairo","value":"pycairo"},{"label":"pycalphad","value":"pycalphad"},{"label":"pycandela","value":"pycandela"},{"label":"pycapnp","value":"pycapnp"},{"label":"pychef","value":"pychef"},{"label":"pycifrw","value":"pycifrw"},{"label":"pycoal","value":"pycoal"},{"label":"pycodestyle","value":"pycodestyle"},{"label":"pycosat","value":"pycosat"},{"label":"pycparser","value":"pycparser"},{"label":"pycrypto","value":"pycrypto"},{"label":"pycsw","value":"pycsw"},{"label":"pydap","value":"pydap"},{"label":"pydicom","value":"pydicom"},{"label":"pydispatcher","value":"pydispatcher"},{"label":"pydl","value":"pydl"},{"label":"pydocstyle","value":"pydocstyle"},{"label":"pydoe","value":"pydoe"},{"label":"pydotplus","value":"pydotplus"},{"label":"pydruid","value":"pydruid"},{"label":"pydstool","value":"pydstool"},{"label":"pydy","value":"pydy"},{"label":"pyedflib","value":"pyedflib"},{"label":"pyelastix","value":"pyelastix"},{"label":"pyelftools","value":"pyelftools"},{"label":"pyembree","value":"pyembree"},{"label":"pyemd","value":"pyemd"},{"label":"pyemma","value":"pyemma"},{"label":"pyephem","value":"pyephem"},{"label":"pyepsg","value":"pyepsg"},{"label":"pyface","value":"pyface"},{"label":"pyfai","value":"pyfai"},{"label":"pyferret","value":"pyferret"},{"label":"pyfftw","value":"pyfftw"},{"label":"pyfiglet","value":"pyfiglet"},{"label":"pyfive","value":"pyfive"},{"label":"pyflakes","value":"pyflakes"},{"label":"pyflann","value":"pyflann"},{"label":"pyfmi","value":"pyfmi"},{"label":"pyfmmlib","value":"pyfmmlib"},{"label":"pyftpdlib","value":"pyftpdlib"},{"label":"pygc","value":"pygc"},{"label":"pygdp","value":"pygdp"},{"label":"pygeobase","value":"pygeobase"},{"label":"pygeogrids","value":"pygeogrids"},{"label":"pygeoif","value":"pygeoif"},{"label":"pygeoip","value":"pygeoip"},{"label":"pygit2","value":"pygit2"},{"label":"pygithub","value":"pygithub"},{"label":"pyglet","value":"pyglet"},{"label":"pygments","value":"pygments"},{"label":"pygments_anyscript","value":"pygments_anyscript"},{"label":"pygmo","value":"pygmo"},{"label":"pygmo_plugins_nonfree","value":"pygmo_plugins_nonfree"},{"label":"pygobject","value":"pygobject"},{"label":"pygpu","value":"pygpu"},{"label":"pygrametl","value":"pygrametl"},{"label":"pygraphml","value":"pygraphml"},{"label":"pygrib","value":"pygrib"},{"label":"pygridgen","value":"pygridgen"},{"label":"pygridtools","value":"pygridtools"},{"label":"pygypsy","value":"pygypsy"},{"label":"pyhamcrest","value":"pyhamcrest"},{"label":"pyhdf","value":"pyhdf"},{"label":"pyhmc","value":"pyhmc"},{"label":"pyhocon","value":"pyhocon"},{"label":"pyhrf","value":"pyhrf"},{"label":"pyhum","value":"pyhum"},{"label":"pyinotify","value":"pyinotify"},{"label":"pyinstaller","value":"pyinstaller"},{"label":"pyinstrument","value":"pyinstrument"},{"label":"pyjwt","value":"pyjwt"},{"label":"pykalman","value":"pykalman"},{"label":"pykdtree","value":"pykdtree"},{"label":"pyke","value":"pyke"},{"label":"pykml","value":"pykml"},{"label":"pykrige","value":"pykrige"},{"label":"pykwalify","value":"pykwalify"},{"label":"pylama","value":"pylama"},{"label":"pylems","value":"pylems"},{"label":"pylibmc","value":"pylibmc"},{"label":"pylint","value":"pylint"},{"label":"pylint-celery","value":"pylint-celery"},{"label":"pylint-common","value":"pylint-common"},{"label":"pylint-django","value":"pylint-django"},{"label":"pylint-flask","value":"pylint-flask"},{"label":"pylint-plugin-utils","value":"pylint-plugin-utils"},{"label":"pymagej","value":"pymagej"},{"label":"pymapd","value":"pymapd"},{"label":"pymatbridge","value":"pymatbridge"},{"label":"pymbar","value":"pymbar"},{"label":"pymbolic","value":"pymbolic"},{"label":"pymc","value":"pymc"},{"label":"pymc3","value":"pymc3"},{"label":"pymeasure","value":"pymeasure"},{"label":"pymks","value":"pymks"},{"label":"pymongo","value":"pymongo"},{"label":"pympler","value":"pympler"},{"label":"pymssql","value":"pymssql"},{"label":"pynac","value":"pynac"},{"label":"pynacl","value":"pynacl"},{"label":"pynamical","value":"pynamical"},{"label":"pyncml","value":"pyncml"},{"label":"pynco","value":"pynco"},{"label":"pyne","value":"pyne"},{"label":"pynfft","value":"pynfft"},{"label":"pyngl","value":"pyngl"},{"label":"pynio","value":"pynio"},{"label":"pyobjc-core","value":"pyobjc-core"},{"label":"pyodbc","value":"pyodbc"},{"label":"pyomo","value":"pyomo"},{"label":"pyomo.extras","value":"pyomo.extras"},{"label":"pyoos","value":"pyoos"},{"label":"pyopcode","value":"pyopcode"},{"label":"pyopencl","value":"pyopencl"},{"label":"pyopengl","value":"pyopengl"},{"label":"pyopenssl","value":"pyopenssl"},{"label":"pyorgmode","value":"pyorgmode"},{"label":"pyosf","value":"pyosf"},{"label":"pypandoc","value":"pypandoc"},{"label":"pyparsing","value":"pyparsing"},{"label":"pypdf2","value":"pypdf2"},{"label":"pypeg2","value":"pypeg2"},{"label":"pyperclip","value":"pyperclip"},{"label":"pyphen","value":"pyphen"},{"label":"pypolyagamma","value":"pypolyagamma"},{"label":"pyprind","value":"pyprind"},{"label":"pyproj","value":"pyproj"},{"label":"pyqt","value":"pyqt"},{"label":"pyqtgraph","value":"pyqtgraph"},{"label":"pyquery","value":"pyquery"},{"label":"pyranha","value":"pyranha"},{"label":"pyreadline","value":"pyreadline"},{"label":"pyregion","value":"pyregion"},{"label":"pyrepl","value":"pyrepl"},{"label":"pyresample","value":"pyresample"},{"label":"pyretis","value":"pyretis"},{"label":"pyro4","value":"pyro4"},{"label":"pyroma","value":"pyroma"},{"label":"pysal","value":"pysal"},{"label":"pyscaffold","value":"pyscaffold"},{"label":"pyscss","value":"pyscss"},{"label":"pysdl2","value":"pysdl2"},{"label":"pyseaweed","value":"pyseaweed"},{"label":"pyseidon","value":"pyseidon"},{"label":"pyserial","value":"pyserial"},{"label":"pysftp","value":"pysftp"},{"label":"pysgrid","value":"pysgrid"},{"label":"pyshp","value":"pyshp"},{"label":"pyside","value":"pyside"},{"label":"pyside2","value":"pyside2"},{"label":"pyslet","value":"pyslet"},{"label":"pysmbclient","value":"pysmbclient"},{"label":"pysocks","value":"pysocks"},{"label":"pysolar","value":"pysolar"},{"label":"pysolr","value":"pysolr"},{"label":"pyspark","value":"pyspark"},{"label":"pyspharm","value":"pyspharm"},{"label":"pystache","value":"pystache"},{"label":"pystan","value":"pystan"},{"label":"pysurfer","value":"pysurfer"},{"label":"pysw4","value":"pysw4"},{"label":"pytables","value":"pytables"},{"label":"pytest","value":"pytest"},{"label":"pytest-ast-back-to-python","value":"pytest-ast-back-to-python"},{"label":"pytest-asyncio","value":"pytest-asyncio"},{"label":"pytest-base-url","value":"pytest-base-url"},{"label":"pytest-benchmark","value":"pytest-benchmark"},{"label":"pytest-cache","value":"pytest-cache"},{"label":"pytest-catchlog","value":"pytest-catchlog"},{"label":"pytest-cookies","value":"pytest-cookies"},{"label":"pytest-cov","value":"pytest-cov"},{"label":"pytest-cpp","value":"pytest-cpp"},{"label":"pytest-datadir","value":"pytest-datadir"},{"label":"pytest-django","value":"pytest-django"},{"label":"pytest-env","value":"pytest-env"},{"label":"pytest-faulthandler","value":"pytest-faulthandler"},{"label":"pytest-flake8","value":"pytest-flake8"},{"label":"pytest-flakes","value":"pytest-flakes"},{"label":"pytest-flask","value":"pytest-flask"},{"label":"pytest-forked","value":"pytest-forked"},{"label":"pytest-html","value":"pytest-html"},{"label":"pytest-json","value":"pytest-json"},{"label":"pytest-lazy-fixture","value":"pytest-lazy-fixture"},{"label":"pytest-localserver","value":"pytest-localserver"},{"label":"pytest-metadata","value":"pytest-metadata"},{"label":"pytest-mock","value":"pytest-mock"},{"label":"pytest-mpl","value":"pytest-mpl"},{"label":"pytest-pep8","value":"pytest-pep8"},{"label":"pytest-qt","value":"pytest-qt"},{"label":"pytest-runner","value":"pytest-runner"},{"label":"pytest-selenium","value":"pytest-selenium"},{"label":"pytest-sftpserver","value":"pytest-sftpserver"},{"label":"pytest-spec","value":"pytest-spec"},{"label":"pytest-sugar","value":"pytest-sugar"},{"label":"pytest-timeout","value":"pytest-timeout"},{"label":"pytest-variables","value":"pytest-variables"},{"label":"pytest-xdist","value":"pytest-xdist"},{"label":"python","value":"python"},{"label":"python-annoy","value":"python-annoy"},{"label":"python-avro","value":"python-avro"},{"label":"python-blosc","value":"python-blosc"},{"label":"python-casacore","value":"python-casacore"},{"label":"python-cdo","value":"python-cdo"},{"label":"python-confluent-kafka","value":"python-confluent-kafka"},{"label":"python-constraint","value":"python-constraint"},{"label":"python-couchdb","value":"python-couchdb"},{"label":"python-coveralls","value":"python-coveralls"},{"label":"python-cpl","value":"python-cpl"},{"label":"python-crfsuite","value":"python-crfsuite"},{"label":"python-dateutil","value":"python-dateutil"},{"label":"python-decouple","value":"python-decouple"},{"label":"python-docx","value":"python-docx"},{"label":"python-dotenv","value":"python-dotenv"},{"label":"python-drmaa","value":"python-drmaa"},{"label":"python-eccodes","value":"python-eccodes"},{"label":"python-ecmwf_grib","value":"python-ecmwf_grib"},{"label":"python-editor","value":"python-editor"},{"label":"python-engineio","value":"python-engineio"},{"label":"python-fmask","value":"python-fmask"},{"label":"python-gflags","value":"python-gflags"},{"label":"python-gnupg","value":"python-gnupg"},{"label":"python-graphviz","value":"python-graphviz"},{"label":"python-hdfs","value":"python-hdfs"},{"label":"python-highcharts","value":"python-highcharts"},{"label":"python-igraph","value":"python-igraph"},{"label":"python-ironicclient","value":"python-ironicclient"},{"label":"python-json-logger","value":"python-json-logger"},{"label":"python-kubernetes","value":"python-kubernetes"},{"label":"python-language-server","value":"python-language-server"},{"label":"python-leveldb","value":"python-leveldb"},{"label":"python-levenshtein","value":"python-levenshtein"},{"label":"python-libarchive-c","value":"python-libarchive-c"},{"label":"python-lmdb","value":"python-lmdb"},{"label":"python-lzo","value":"python-lzo"},{"label":"python-magic","value":"python-magic"},{"label":"python-marisa-trie","value":"python-marisa-trie"},{"label":"python-markdown-math","value":"python-markdown-math"},{"label":"python-memcached","value":"python-memcached"},{"label":"python-mimeparse","value":"python-mimeparse"},{"label":"python-monkey-business","value":"python-monkey-business"},{"label":"python-neo","value":"python-neo"},{"label":"python-nvd3","value":"python-nvd3"},{"label":"python-oauth2","value":"python-oauth2"},{"label":"python-openid","value":"python-openid"},{"label":"python-pptx","value":"python-pptx"},{"label":"python-primesieve","value":"python-primesieve"},{"label":"python-rapidjson","value":"python-rapidjson"},{"label":"python-slugify","value":"python-slugify"},{"label":"python-snappy","value":"python-snappy"},{"label":"python-socketio","value":"python-socketio"},{"label":"python-spake2","value":"python-spake2"},{"label":"python-spams","value":"python-spams"},{"label":"python-stratify","value":"python-stratify"},{"label":"python-symengine","value":"python-symengine"},{"label":"python-termstyle","value":"python-termstyle"},{"label":"python-ternary","value":"python-ternary"},{"label":"python-utils","value":"python-utils"},{"label":"python3-openid","value":"python3-openid"},{"label":"pythreejs","value":"pythreejs"},{"label":"pytimeparse","value":"pytimeparse"},{"label":"pytmatrix","value":"pytmatrix"},{"label":"pytoml","value":"pytoml"},{"label":"pytools","value":"pytools"},{"label":"pytrie","value":"pytrie"},{"label":"pytrilinos","value":"pytrilinos"},{"label":"pytz","value":"pytz"},{"label":"pytzdata","value":"pytzdata"},{"label":"pyuca","value":"pyuca"},{"label":"pyugrid","value":"pyugrid"},{"label":"pyutilib","value":"pyutilib"},{"label":"pyutilsnrw","value":"pyutilsnrw"},{"label":"pyvirtualdisplay","value":"pyvirtualdisplay"},{"label":"pyvisa","value":"pyvisa"},{"label":"pyvisa-py","value":"pyvisa-py"},{"label":"pyvisfile","value":"pyvisfile"},{"label":"pyvo","value":"pyvo"},{"label":"pyvtk","value":"pyvtk"},{"label":"pywavelets","value":"pywavelets"},{"label":"pywebhdfs","value":"pywebhdfs"},{"label":"pywim","value":"pywim"},{"label":"pywin32","value":"pywin32"},{"label":"pywinpty","value":"pywinpty"},{"label":"pywps","value":"pywps"},{"label":"pyxb","value":"pyxb"},{"label":"pyxdameraulevenshtein","value":"pyxdameraulevenshtein"},{"label":"pyxid","value":"pyxid"},{"label":"pyxley","value":"pyxley"},{"label":"pyyaml","value":"pyyaml"},{"label":"pyzmq","value":"pyzmq"},{"label":"qca","value":"qca"},{"label":"qcodes","value":"qcodes"},{"label":"qd","value":"qd"},{"label":"qds-sdk","value":"qds-sdk"},{"label":"qgis","value":"qgis"},{"label":"qimage2ndarray","value":"qimage2ndarray"},{"label":"qjson","value":"qjson"},{"label":"qrcode","value":"qrcode"},{"label":"qscintilla2","value":"qscintilla2"},{"label":"qt","value":"qt"},{"label":"qt.py","value":"qt.py"},{"label":"qt_binder","value":"qt_binder"},{"label":"qtawesome","value":"qtawesome"},{"label":"qtconsole","value":"qtconsole"},{"label":"qtkeychain","value":"qtkeychain"},{"label":"qtpy","value":"qtpy"},{"label":"quantecon","value":"quantecon"},{"label":"quantities","value":"quantities"},{"label":"quantlab","value":"quantlab"},{"label":"quantlab_launcher","value":"quantlab_launcher"},{"label":"qutip","value":"qutip"},{"label":"qwt","value":"qwt"},{"label":"qwtpolar","value":"qwtpolar"},{"label":"r","value":"r"},{"label":"rabbitmq-server","value":"rabbitmq-server"},{"label":"ragel","value":"ragel"},{"label":"randomcolor","value":"randomcolor"},{"label":"rank_filter","value":"rank_filter"},{"label":"rapidjson","value":"rapidjson"},{"label":"rapidpy","value":"rapidpy"},{"label":"rasterio","value":"rasterio"},{"label":"rasterstats","value":"rasterstats"},{"label":"ratelim","value":"ratelim"},{"label":"ratelimiter","value":"ratelimiter"},{"label":"ratpoints","value":"ratpoints"},{"label":"raven","value":"raven"},{"label":"rcssmin","value":"rcssmin"},{"label":"rdflib","value":"rdflib"},{"label":"re2","value":"re2"},{"label":"read-roi","value":"read-roi"},{"label":"readline","value":"readline"},{"label":"rebound","value":"rebound"},{"label":"recommonmark","value":"recommonmark"},{"label":"records","value":"records"},{"label":"redis-py","value":"redis-py"},{"label":"rednose","value":"rednose"},{"label":"reentry","value":"reentry"},{"label":"refnx","value":"refnx"},{"label":"reg","value":"reg"},{"label":"regex","value":"regex"},{"label":"regions","value":"regions"},{"label":"regolith","value":"regolith"},{"label":"reikna","value":"reikna"},{"label":"rejected","value":"rejected"},{"label":"repeated_test","value":"repeated_test"},{"label":"reportlab","value":"reportlab"},{"label":"reports","value":"reports"},{"label":"reproject","value":"reproject"},{"label":"reprounzip","value":"reprounzip"},{"label":"reprounzip-docker","value":"reprounzip-docker"},{"label":"reprounzip-vagrant","value":"reprounzip-vagrant"},{"label":"reprozip","value":"reprozip"},{"label":"requests","value":"requests"},{"label":"requests-cache","value":"requests-cache"},{"label":"requests-ftp","value":"requests-ftp"},{"label":"requests-futures","value":"requests-futures"},{"label":"requests-oauthlib","value":"requests-oauthlib"},{"label":"requests-toolbelt","value":"requests-toolbelt"},{"label":"requests-unixsocket","value":"requests-unixsocket"},{"label":"requests_download","value":"requests_download"},{"label":"requestsexceptions","value":"requestsexceptions"},{"label":"requirements-detector","value":"requirements-detector"},{"label":"resampy","value":"resampy"},{"label":"restructuredtext_lint","value":"restructuredtext_lint"},{"label":"retriever","value":"retriever"},{"label":"retrying","value":"retrying"},{"label":"rever","value":"rever"},{"label":"rfc3339","value":"rfc3339"},{"label":"rfc3986","value":"rfc3986"},{"label":"rhash","value":"rhash"},{"label":"rios","value":"rios"},{"label":"rjsmin","value":"rjsmin"},{"label":"rope","value":"rope"},{"label":"rotamerconvolvemd","value":"rotamerconvolvemd"},{"label":"routes","value":"routes"},{"label":"rpaths","value":"rpaths"},{"label":"rpfits","value":"rpfits"},{"label":"rply","value":"rply"},{"label":"rpy2","value":"rpy2"},{"label":"rq","value":"rq"},{"label":"rsa","value":"rsa"},{"label":"rsgislib","value":"rsgislib"},{"label":"rt1","value":"rt1"},{"label":"rtree","value":"rtree"},{"label":"ruamel.ordereddict","value":"ruamel.ordereddict"},{"label":"ruamel.yaml","value":"ruamel.yaml"},{"label":"ruamel_yaml","value":"ruamel_yaml"},{"label":"rubiks","value":"rubiks"},{"label":"ruby","value":"ruby"},{"label":"runipy","value":"runipy"},{"label":"rust","value":"rust"},{"label":"rvlib","value":"rvlib"},{"label":"rw","value":"rw"},{"label":"s3fs","value":"s3fs"},{"label":"s3transfer","value":"s3transfer"},{"label":"sage","value":"sage"},{"label":"sagelib","value":"sagelib"},{"label":"sagemath-db-combinatorial-designs","value":"sagemath-db-combinatorial-designs"},{"label":"sagemath-db-conway-polynomials","value":"sagemath-db-conway-polynomials"},{"label":"sagemath-db-elliptic-curves","value":"sagemath-db-elliptic-curves"},{"label":"sagemath-db-graphs","value":"sagemath-db-graphs"},{"label":"sagemath-db-polytopes","value":"sagemath-db-polytopes"},{"label":"salib","value":"salib"},{"label":"salt","value":"salt"},{"label":"sarge","value":"sarge"},{"label":"sas_kernel","value":"sas_kernel"},{"label":"saspy","value":"saspy"},{"label":"scalapack","value":"scalapack"},{"label":"scandir","value":"scandir"},{"label":"scattertext","value":"scattertext"},{"label":"schwimmbad","value":"schwimmbad"},{"label":"scijava-jupyter-kernel","value":"scijava-jupyter-kernel"},{"label":"scikit-allel","value":"scikit-allel"},{"label":"scikit-beam","value":"scikit-beam"},{"label":"scikit-bio","value":"scikit-bio"},{"label":"scikit-build","value":"scikit-build"},{"label":"scikit-data","value":"scikit-data"},{"label":"scikit-dsp-comm","value":"scikit-dsp-comm"},{"label":"scikit-image","value":"scikit-image"},{"label":"scikit-learn","value":"scikit-learn"},{"label":"scikit-optimize","value":"scikit-optimize"},{"label":"scikit-plot","value":"scikit-plot"},{"label":"scikit-procrustes","value":"scikit-procrustes"},{"label":"scikit-rf","value":"scikit-rf"},{"label":"scikit-sparse","value":"scikit-sparse"},{"label":"scikit-umfpack","value":"scikit-umfpack"},{"label":"sciluigi","value":"sciluigi"},{"label":"scipy","value":"scipy"},{"label":"scipy-sugar","value":"scipy-sugar"},{"label":"scons","value":"scons"},{"label":"scotch","value":"scotch"},{"label":"scp","value":"scp"},{"label":"scrapy","value":"scrapy"},{"label":"scripttest","value":"scripttest"},{"label":"sdl2","value":"sdl2"},{"label":"sdl2_gfx","value":"sdl2_gfx"},{"label":"sdl2_image","value":"sdl2_image"},{"label":"sdl2_mixer","value":"sdl2_mixer"},{"label":"sdl2_net","value":"sdl2_net"},{"label":"sdl2_ttf","value":"sdl2_ttf"},{"label":"seaborn","value":"seaborn"},{"label":"seapy","value":"seapy"},{"label":"seawater","value":"seawater"},{"label":"sed","value":"sed"},{"label":"segno","value":"segno"},{"label":"selenium","value":"selenium"},{"label":"semver","value":"semver"},{"label":"sensorml2iso","value":"sensorml2iso"},{"label":"sentinels","value":"sentinels"},{"label":"sep","value":"sep"},{"label":"seqan-library","value":"seqan-library"},{"label":"serpent","value":"serpent"},{"label":"serverfiles","value":"serverfiles"},{"label":"setoptconf","value":"setoptconf"},{"label":"setproctitle","value":"setproctitle"},{"label":"setuptools","value":"setuptools"},{"label":"setuptools-git","value":"setuptools-git"},{"label":"setuptools_markdown","value":"setuptools_markdown"},{"label":"setuptools_scm","value":"setuptools_scm"},{"label":"setuptools_scm_git_archive","value":"setuptools_scm_git_archive"},{"label":"setuptools_subversion","value":"setuptools_subversion"},{"label":"sfdmap","value":"sfdmap"},{"label":"sfepy","value":"sfepy"},{"label":"sgp4","value":"sgp4"},{"label":"sh","value":"sh"},{"label":"shade","value":"shade"},{"label":"shapelib","value":"shapelib"},{"label":"shapely","value":"shapely"},{"label":"shogun","value":"shogun"},{"label":"shogun-cpp","value":"shogun-cpp"},{"label":"shutilwhich","value":"shutilwhich"},{"label":"signac","value":"signac"},{"label":"signac-dashboard","value":"signac-dashboard"},{"label":"signac-flow","value":"signac-flow"},{"label":"silx","value":"silx"},{"label":"simbody","value":"simbody"},{"label":"simhash","value":"simhash"},{"label":"simhash-py","value":"simhash-py"},{"label":"simple-salesforce","value":"simple-salesforce"},{"label":"simplegeneric","value":"simplegeneric"},{"label":"simplejson","value":"simplejson"},{"label":"simplekml","value":"simplekml"},{"label":"simpletal","value":"simpletal"},{"label":"simupop","value":"simupop"},{"label":"singledispatch","value":"singledispatch"},{"label":"singular","value":"singular"},{"label":"sip","value":"sip"},{"label":"siphon","value":"siphon"},{"label":"six","value":"six"},{"label":"sixs","value":"sixs"},{"label":"skan","value":"skan"},{"label":"skater","value":"skater"},{"label":"sklearn-contrib-lightning","value":"sklearn-contrib-lightning"},{"label":"skyfield","value":"skyfield"},{"label":"slackclient","value":"slackclient"},{"label":"slacker","value":"slacker"},{"label":"slda","value":"slda"},{"label":"slepc","value":"slepc"},{"label":"slepc4py","value":"slepc4py"},{"label":"slicerator","value":"slicerator"},{"label":"slugify","value":"slugify"},{"label":"slycot","value":"slycot"},{"label":"smart_open","value":"smart_open"},{"label":"smartypants","value":"smartypants"},{"label":"smmap","value":"smmap"},{"label":"smmap2","value":"smmap2"},{"label":"smpeg2","value":"smpeg2"},{"label":"smt","value":"smt"},{"label":"snakebite","value":"snakebite"},{"label":"snakefood","value":"snakefood"},{"label":"snappy","value":"snappy"},{"label":"sncosmo","value":"sncosmo"},{"label":"snowballstemmer","value":"snowballstemmer"},{"label":"snuggs","value":"snuggs"},{"label":"snzip","value":"snzip"},{"label":"soappy","value":"soappy"},{"label":"socat","value":"socat"},{"label":"somoclu","value":"somoclu"},{"label":"sortedcollections","value":"sortedcollections"},{"label":"sortedcontainers","value":"sortedcontainers"},{"label":"sound_field_analysis","value":"sound_field_analysis"},{"label":"sox","value":"sox"},{"label":"spacy","value":"spacy"},{"label":"sparkmagic","value":"sparkmagic"},{"label":"sparqlwrapper","value":"sparqlwrapper"},{"label":"sparsehash","value":"sparsehash"},{"label":"spdlog","value":"spdlog"},{"label":"speaklater","value":"speaklater"},{"label":"spectra","value":"spectra"},{"label":"spectral","value":"spectral"},{"label":"spectral-cube","value":"spectral-cube"},{"label":"spectrum","value":"spectrum"},{"label":"specutils","value":"specutils"},{"label":"speechrecognition","value":"speechrecognition"},{"label":"speex","value":"speex"},{"label":"spefile","value":"spefile"},{"label":"speg","value":"speg"},{"label":"spglib","value":"spglib"},{"label":"spherical-geometry","value":"spherical-geometry"},{"label":"sphinx","value":"sphinx"},{"label":"sphinx-argparse","value":"sphinx-argparse"},{"label":"sphinx-autobuild","value":"sphinx-autobuild"},{"label":"sphinx-bootstrap-theme","value":"sphinx-bootstrap-theme"},{"label":"sphinx-gallery","value":"sphinx-gallery"},{"label":"sphinx-issues","value":"sphinx-issues"},{"label":"sphinx-nbexamples","value":"sphinx-nbexamples"},{"label":"sphinx-pypi-upload","value":"sphinx-pypi-upload"},{"label":"sphinx_bootstrap_theme","value":"sphinx_bootstrap_theme"},{"label":"sphinx_rtd_theme","value":"sphinx_rtd_theme"},{"label":"sphinxcontrib-autodoc_doxygen","value":"sphinxcontrib-autodoc_doxygen"},{"label":"sphinxcontrib-autoprogram","value":"sphinxcontrib-autoprogram"},{"label":"sphinxcontrib-bibtex","value":"sphinxcontrib-bibtex"},{"label":"sphinxcontrib-paverutils","value":"sphinxcontrib-paverutils"},{"label":"sphinxcontrib-spelling","value":"sphinxcontrib-spelling"},{"label":"sphinxcontrib-websupport","value":"sphinxcontrib-websupport"},{"label":"sphinxjp.themecore","value":"sphinxjp.themecore"},{"label":"sphinxjp.themes.impressjs","value":"sphinxjp.themes.impressjs"},{"label":"sphinxjp.themes.solarized","value":"sphinxjp.themes.solarized"},{"label":"splauncher","value":"splauncher"},{"label":"splits","value":"splits"},{"label":"splunk_handler","value":"splunk_handler"},{"label":"spm1d","value":"spm1d"},{"label":"sputnik","value":"sputnik"},{"label":"spyder","value":"spyder"},{"label":"spyder-line-profiler","value":"spyder-line-profiler"},{"label":"spyder-memory-profiler","value":"spyder-memory-profiler"},{"label":"spyder-notebook","value":"spyder-notebook"},{"label":"spyder-reports","value":"spyder-reports"},{"label":"spyder-terminal","value":"spyder-terminal"},{"label":"spyder-unittest","value":"spyder-unittest"},{"label":"spylon","value":"spylon"},{"label":"spylon-kernel","value":"spylon-kernel"},{"label":"spyne","value":"spyne"},{"label":"spyre","value":"spyre"},{"label":"sqlalchemy","value":"sqlalchemy"},{"label":"sqlalchemy-migrate","value":"sqlalchemy-migrate"},{"label":"sqlalchemy-redshift","value":"sqlalchemy-redshift"},{"label":"sqlalchemy-utils","value":"sqlalchemy-utils"},{"label":"sqlite","value":"sqlite"},{"label":"sqlparse","value":"sqlparse"},{"label":"squash","value":"squash"},{"label":"srtm.py","value":"srtm.py"},{"label":"sseclient","value":"sseclient"},{"label":"ssh2-python","value":"ssh2-python"},{"label":"sshtunnel","value":"sshtunnel"},{"label":"ssl_match_hostname","value":"ssl_match_hostname"},{"label":"stack","value":"stack"},{"label":"static","value":"static"},{"label":"statistics","value":"statistics"},{"label":"statsd","value":"statsd"},{"label":"statsmodels","value":"statsmodels"},{"label":"statuspage","value":"statuspage"},{"label":"stdlib-list","value":"stdlib-list"},{"label":"stevedore","value":"stevedore"},{"label":"streamz","value":"streamz"},{"label":"strict-rfc3339","value":"strict-rfc3339"},{"label":"structlog","value":"structlog"},{"label":"subprocess32","value":"subprocess32"},{"label":"sudospawner","value":"sudospawner"},{"label":"suds-jurko","value":"suds-jurko"},{"label":"suitesparse","value":"suitesparse"},{"label":"sundials","value":"sundials"},{"label":"sunpy","value":"sunpy"},{"label":"super_state_machine","value":"super_state_machine"},{"label":"superlance","value":"superlance"},{"label":"superlu","value":"superlu"},{"label":"supervisor","value":"supervisor"},{"label":"svg2png","value":"svg2png"},{"label":"svglib","value":"svglib"},{"label":"svgutils","value":"svgutils"},{"label":"swagger-spec-validator","value":"swagger-spec-validator"},{"label":"swig","value":"swig"},{"label":"swiglpk","value":"swiglpk"},{"label":"symengine","value":"symengine"},{"label":"symmetrica","value":"symmetrica"},{"label":"sympow","value":"sympow"},{"label":"sympy","value":"sympy"},{"label":"tableschema-py","value":"tableschema-py"},{"label":"tablib","value":"tablib"},{"label":"tabulate","value":"tabulate"},{"label":"tabulator-py","value":"tabulator-py"},{"label":"tachyon","value":"tachyon"},{"label":"tangelo","value":"tangelo"},{"label":"tbb","value":"tbb"},{"label":"tblib","value":"tblib"},{"label":"tempdir","value":"tempdir"},{"label":"tempita","value":"tempita"},{"label":"tempora","value":"tempora"},{"label":"tenacity","value":"tenacity"},{"label":"tensorflow","value":"tensorflow"},{"label":"termcolor","value":"termcolor"},{"label":"terminado","value":"terminado"},{"label":"terminaltables","value":"terminaltables"},{"label":"terraform","value":"terraform"},{"label":"testfixtures","value":"testfixtures"},{"label":"testpath","value":"testpath"},{"label":"testtools","value":"testtools"},{"label":"tetgen","value":"tetgen"},{"label":"texinfo","value":"texinfo"},{"label":"texlive-core","value":"texlive-core"},{"label":"textacy","value":"textacy"},{"label":"textadapter","value":"textadapter"},{"label":"textblob","value":"textblob"},{"label":"textract","value":"textract"},{"label":"texttable","value":"texttable"},{"label":"the_silver_searcher","value":"the_silver_searcher"},{"label":"theano","value":"theano"},{"label":"theanolm","value":"theanolm"},{"label":"thermotools","value":"thermotools"},{"label":"thinc","value":"thinc"},{"label":"thinkx","value":"thinkx"},{"label":"thredds_crawler","value":"thredds_crawler"},{"label":"thrift","value":"thrift"},{"label":"thrift-cpp","value":"thrift-cpp"},{"label":"thrift_sasl","value":"thrift_sasl"},{"label":"thriftpy","value":"thriftpy"},{"label":"tifffile","value":"tifffile"},{"label":"tika","value":"tika"},{"label":"tikzmagic","value":"tikzmagic"},{"label":"time","value":"time"},{"label":"timezonefinder","value":"timezonefinder"},{"label":"tini","value":"tini"},{"label":"tinyarray","value":"tinyarray"},{"label":"tinycss","value":"tinycss"},{"label":"tinydb","value":"tinydb"},{"label":"tk","value":"tk"},{"label":"tldextract","value":"tldextract"},{"label":"tlslite","value":"tlslite"},{"label":"tmux","value":"tmux"},{"label":"tokyocabinet","value":"tokyocabinet"},{"label":"toml","value":"toml"},{"label":"tomopy","value":"tomopy"},{"label":"toolchain","value":"toolchain"},{"label":"toolchain3","value":"toolchain3"},{"label":"toolz","value":"toolz"},{"label":"toposort","value":"toposort"},{"label":"tornado","value":"tornado"},{"label":"toro","value":"toro"},{"label":"tox","value":"tox"},{"label":"tpot","value":"tpot"},{"label":"tqdm","value":"tqdm"},{"label":"traceback2","value":"traceback2"},{"label":"trackpy","value":"trackpy"},{"label":"traitlets","value":"traitlets"},{"label":"traits","value":"traits"},{"label":"traitsui","value":"traitsui"},{"label":"traittypes","value":"traittypes"},{"label":"transaction","value":"transaction"},{"label":"trash-cli","value":"trash-cli"},{"label":"travis-encrypt","value":"travis-encrypt"},{"label":"treq","value":"treq"},{"label":"trilinos","value":"trilinos"},{"label":"trmm_rsl","value":"trmm_rsl"},{"label":"trollius","value":"trollius"},{"label":"trottersuzuki","value":"trottersuzuki"},{"label":"tuiview","value":"tuiview"},{"label":"turbodbc","value":"turbodbc"},{"label":"tweepy","value":"tweepy"},{"label":"twine","value":"twine"},{"label":"twython","value":"twython"},{"label":"txaio","value":"txaio"},{"label":"typed-ast","value":"typed-ast"},{"label":"typing","value":"typing"},{"label":"typogrify","value":"typogrify"},{"label":"tyssue","value":"tyssue"},{"label":"tzlocal","value":"tzlocal"},{"label":"u3d","value":"u3d"},{"label":"ua-parser","value":"ua-parser"},{"label":"udunits2","value":"udunits2"},{"label":"ulmo","value":"ulmo"},{"label":"umalqurra","value":"umalqurra"},{"label":"uncertainties","value":"uncertainties"},{"label":"uncommitted","value":"uncommitted"},{"label":"unicodecsv","value":"unicodecsv"},{"label":"unidecode","value":"unidecode"},{"label":"unittest2pytest","value":"unittest2pytest"},{"label":"unixodbc","value":"unixodbc"},{"label":"unzip","value":"unzip"},{"label":"update_checker","value":"update_checker"},{"label":"uritemplate","value":"uritemplate"},{"label":"uritemplate.py","value":"uritemplate.py"},{"label":"uritools","value":"uritools"},{"label":"urllib3","value":"urllib3"},{"label":"urlobject","value":"urlobject"},{"label":"urwid","value":"urwid"},{"label":"us","value":"us"},{"label":"usaddress","value":"usaddress"},{"label":"usagestats","value":"usagestats"},{"label":"user-agents","value":"user-agents"},{"label":"usgs","value":"usgs"},{"label":"utfcpp","value":"utfcpp"},{"label":"utide","value":"utide"},{"label":"utm","value":"utm"},{"label":"uvloop","value":"uvloop"},{"label":"uwsgi","value":"uwsgi"},{"label":"vaex","value":"vaex"},{"label":"validate_email","value":"validate_email"},{"label":"valideer","value":"valideer"},{"label":"validictory","value":"validictory"},{"label":"vault","value":"vault"},{"label":"vc","value":"vc"},{"label":"vcrpy","value":"vcrpy"},{"label":"vcversioner","value":"vcversioner"},{"label":"vectormath","value":"vectormath"},{"label":"vega","value":"vega"},{"label":"verboselogs","value":"verboselogs"},{"label":"version_information","value":"version_information"},{"label":"versioneer","value":"versioneer"},{"label":"versiontools","value":"versiontools"},{"label":"vertica-python","value":"vertica-python"},{"label":"vifm","value":"vifm"},{"label":"vigra","value":"vigra"},{"label":"vincent","value":"vincent"},{"label":"vine","value":"vine"},{"label":"viridis","value":"viridis"},{"label":"virtualenv","value":"virtualenv"},{"label":"visdom","value":"visdom"},{"label":"visitor","value":"visitor"},{"label":"visvis","value":"visvis"},{"label":"vitables","value":"vitables"},{"label":"vlfeat","value":"vlfeat"},{"label":"vobject","value":"vobject"},{"label":"voluptuous","value":"voluptuous"},{"label":"vs2008_express_vc_python_patch","value":"vs2008_express_vc_python_patch"},{"label":"vs2015_runtime","value":"vs2015_runtime"},{"label":"vsc-base","value":"vsc-base"},{"label":"vsc-install","value":"vsc-install"},{"label":"vtk","value":"vtk"},{"label":"vulture","value":"vulture"},{"label":"w3m","value":"w3m"},{"label":"waf","value":"waf"},{"label":"wagtail","value":"wagtail"},{"label":"wakatime","value":"wakatime"},{"label":"warc","value":"warc"},{"label":"warctools","value":"warctools"},{"label":"warlock","value":"warlock"},{"label":"watchdog","value":"watchdog"},{"label":"watchtower","value":"watchtower"},{"label":"watermark","value":"watermark"},{"label":"waybackpack","value":"waybackpack"},{"label":"wcsaxes","value":"wcsaxes"},{"label":"wcslib","value":"wcslib"},{"label":"wcwidth","value":"wcwidth"},{"label":"weave","value":"weave"},{"label":"web.py","value":"web.py"},{"label":"webargs","value":"webargs"},{"label":"webassets","value":"webassets"},{"label":"webcolors","value":"webcolors"},{"label":"webencodings","value":"webencodings"},{"label":"webob","value":"webob"},{"label":"websocket-client","value":"websocket-client"},{"label":"websockets","value":"websockets"},{"label":"weightedcalcs","value":"weightedcalcs"},{"label":"wera2netcdf","value":"wera2netcdf"},{"label":"werkzeug","value":"werkzeug"},{"label":"wgrib2","value":"wgrib2"},{"label":"wheel","value":"wheel"},{"label":"whichcraft","value":"whichcraft"},{"label":"whitenoise","value":"whitenoise"},{"label":"whoosh","value":"whoosh"},{"label":"wicken","value":"wicken"},{"label":"widgetsnbextension","value":"widgetsnbextension"},{"label":"wikipedia","value":"wikipedia"},{"label":"willow","value":"willow"},{"label":"win_inet_pton","value":"win_inet_pton"},{"label":"win_unicode_console","value":"win_unicode_console"},{"label":"wincertstore","value":"wincertstore"},{"label":"windrose","value":"windrose"},{"label":"windspharm","value":"windspharm"},{"label":"winpty","value":"winpty"},{"label":"wmctrl","value":"wmctrl"},{"label":"wordcloud","value":"wordcloud"},{"label":"wradlib","value":"wradlib"},{"label":"wrapt","value":"wrapt"},{"label":"wrf-python","value":"wrf-python"},{"label":"wrighttools","value":"wrighttools"},{"label":"ws4py","value":"ws4py"},{"label":"wsaccel","value":"wsaccel"},{"label":"wsgiref","value":"wsgiref"},{"label":"wstools","value":"wstools"},{"label":"wtf-peewee","value":"wtf-peewee"},{"label":"wtforms","value":"wtforms"},{"label":"wtforms-appengine","value":"wtforms-appengine"},{"label":"wxpython","value":"wxpython"},{"label":"x264","value":"x264"},{"label":"xarray","value":"xarray"},{"label":"xarray-simlab","value":"xarray-simlab"},{"label":"xarray-topo","value":"xarray-topo"},{"label":"xattr","value":"xattr"},{"label":"xbpch","value":"xbpch"},{"label":"xcb-proto","value":"xcb-proto"},{"label":"xerces-c","value":"xerces-c"},{"label":"xerces-c28","value":"xerces-c28"},{"label":"xeus","value":"xeus"},{"label":"xfig","value":"xfig"},{"label":"xgboost","value":"xgboost"},{"label":"xlntpyarrow","value":"xlntpyarrow"},{"label":"xlrd","value":"xlrd"},{"label":"xlsxwriter","value":"xlsxwriter"},{"label":"xlwings","value":"xlwings"},{"label":"xlwt","value":"xlwt"},{"label":"xmltodict","value":"xmltodict"},{"label":"xnumpy","value":"xnumpy"},{"label":"xo","value":"xo"},{"label":"xonsh","value":"xonsh"},{"label":"xorg-applewmproto","value":"xorg-applewmproto"},{"label":"xorg-bigreqsproto","value":"xorg-bigreqsproto"},{"label":"xorg-cf-files","value":"xorg-cf-files"},{"label":"xorg-compositeproto","value":"xorg-compositeproto"},{"label":"xorg-damageproto","value":"xorg-damageproto"},{"label":"xorg-dmxproto","value":"xorg-dmxproto"},{"label":"xorg-evieext","value":"xorg-evieext"},{"label":"xorg-fixesproto","value":"xorg-fixesproto"},{"label":"xorg-font-util","value":"xorg-font-util"},{"label":"xorg-fontcacheproto","value":"xorg-fontcacheproto"},{"label":"xorg-fontsproto","value":"xorg-fontsproto"},{"label":"xorg-gccmakedep","value":"xorg-gccmakedep"},{"label":"xorg-glproto","value":"xorg-glproto"},{"label":"xorg-imake","value":"xorg-imake"},{"label":"xorg-inputproto","value":"xorg-inputproto"},{"label":"xorg-kbproto","value":"xorg-kbproto"},{"label":"xorg-libice","value":"xorg-libice"},{"label":"xorg-libpthread-stubs","value":"xorg-libpthread-stubs"},{"label":"xorg-libsm","value":"xorg-libsm"},{"label":"xorg-libx11","value":"xorg-libx11"},{"label":"xorg-libxau","value":"xorg-libxau"},{"label":"xorg-libxaw","value":"xorg-libxaw"},{"label":"xorg-libxaw3d","value":"xorg-libxaw3d"},{"label":"xorg-libxcb","value":"xorg-libxcb"},{"label":"xorg-libxcursor","value":"xorg-libxcursor"},{"label":"xorg-libxdmcp","value":"xorg-libxdmcp"},{"label":"xorg-libxext","value":"xorg-libxext"},{"label":"xorg-libxfixes","value":"xorg-libxfixes"},{"label":"xorg-libxft","value":"xorg-libxft"},{"label":"xorg-libxi","value":"xorg-libxi"},{"label":"xorg-libxmu","value":"xorg-libxmu"},{"label":"xorg-libxp","value":"xorg-libxp"},{"label":"xorg-libxpm","value":"xorg-libxpm"},{"label":"xorg-libxrandr","value":"xorg-libxrandr"},{"label":"xorg-libxrender","value":"xorg-libxrender"},{"label":"xorg-libxt","value":"xorg-libxt"},{"label":"xorg-libxtst","value":"xorg-libxtst"},{"label":"xorg-makedepend","value":"xorg-makedepend"},{"label":"xorg-presentproto","value":"xorg-presentproto"},{"label":"xorg-printproto","value":"xorg-printproto"},{"label":"xorg-randrproto","value":"xorg-randrproto"},{"label":"xorg-recordproto","value":"xorg-recordproto"},{"label":"xorg-renderproto","value":"xorg-renderproto"},{"label":"xorg-resourceproto","value":"xorg-resourceproto"},{"label":"xorg-scrnsaverproto","value":"xorg-scrnsaverproto"},{"label":"xorg-trapproto","value":"xorg-trapproto"},{"label":"xorg-util-macros","value":"xorg-util-macros"},{"label":"xorg-videoproto","value":"xorg-videoproto"},{"label":"xorg-windowswmproto","value":"xorg-windowswmproto"},{"label":"xorg-xbitmaps","value":"xorg-xbitmaps"},{"label":"xorg-xcb-proto","value":"xorg-xcb-proto"},{"label":"xorg-xcmiscproto","value":"xorg-xcmiscproto"},{"label":"xorg-xextproto","value":"xorg-xextproto"},{"label":"xorg-xf86bigfontproto","value":"xorg-xf86bigfontproto"},{"label":"xorg-xf86dgaproto","value":"xorg-xf86dgaproto"},{"label":"xorg-xf86driproto","value":"xorg-xf86driproto"},{"label":"xorg-xf86miscproto","value":"xorg-xf86miscproto"},{"label":"xorg-xf86rushproto","value":"xorg-xf86rushproto"},{"label":"xorg-xf86vidmodeproto","value":"xorg-xf86vidmodeproto"},{"label":"xorg-xineramaproto","value":"xorg-xineramaproto"},{"label":"xorg-xproto","value":"xorg-xproto"},{"label":"xorg-xproxymanagementprotocol","value":"xorg-xproxymanagementprotocol"},{"label":"xorg-xtrans","value":"xorg-xtrans"},{"label":"xproperty","value":"xproperty"},{"label":"xray-vision","value":"xray-vision"},{"label":"xraylib","value":"xraylib"},{"label":"xrft","value":"xrft"},{"label":"xsgen","value":"xsgen"},{"label":"xsimd","value":"xsimd"},{"label":"xtensor","value":"xtensor"},{"label":"xtensor-blas","value":"xtensor-blas"},{"label":"xtensor-python","value":"xtensor-python"},{"label":"xtl","value":"xtl"},{"label":"xvfbwrapper","value":"xvfbwrapper"},{"label":"xz","value":"xz"},{"label":"y_serial","value":"y_serial"},{"label":"yaafe","value":"yaafe"},{"label":"yail","value":"yail"},{"label":"yajl","value":"yajl"},{"label":"yaml","value":"yaml"},{"label":"yaml2ncml","value":"yaml2ncml"},{"label":"yamllint","value":"yamllint"},{"label":"yapf","value":"yapf"},{"label":"yappi","value":"yappi"},{"label":"yarg","value":"yarg"},{"label":"yarl","value":"yarl"},{"label":"yarn","value":"yarn"},{"label":"yasm","value":"yasm"},{"label":"yeadon","value":"yeadon"},{"label":"yt","value":"yt"},{"label":"zarr","value":"zarr"},{"label":"zc.lockfile","value":"zc.lockfile"},{"label":"zconfig","value":"zconfig"},{"label":"zdaemon","value":"zdaemon"},{"label":"zeep","value":"zeep"},{"label":"zeo","value":"zeo"},{"label":"zeromq","value":"zeromq"},{"label":"zict","value":"zict"},{"label":"zip","value":"zip"},{"label":"zipfile36","value":"zipfile36"},{"label":"zlib","value":"zlib"},{"label":"zn_poly","value":"zn_poly"},{"label":"zodb","value":"zodb"},{"label":"zodbpickle","value":"zodbpickle"},{"label":"zodburi","value":"zodburi"},{"label":"zopfli","value":"zopfli"},{"label":"zstandard","value":"zstandard"},{"label":"zstd","value":"zstd"},{"label":"zwatershed","value":"zwatershed"}]}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = {"packages":[{"label":"r-abind","value":"r-abind"},{"label":"r-acepack","value":"r-acepack"},{"label":"r-ada","value":"r-ada"},{"label":"r-ade4","value":"r-ade4"},{"label":"r-adgoftest","value":"r-adgoftest"},{"label":"r-aer","value":"r-aer"},{"label":"r-afex","value":"r-afex"},{"label":"r-agricolae","value":"r-agricolae"},{"label":"r-ahocorasicktrie","value":"r-ahocorasicktrie"},{"label":"r-algdesign","value":"r-algdesign"},{"label":"r-amap","value":"r-amap"},{"label":"r-anomalydetection","value":"r-anomalydetection"},{"label":"r-aod","value":"r-aod"},{"label":"r-ape","value":"r-ape"},{"label":"r-argparse","value":"r-argparse"},{"label":"r-argparser","value":"r-argparser"},{"label":"r-arm","value":"r-arm"},{"label":"r-aroma.apd","value":"r-aroma.apd"},{"label":"r-ash","value":"r-ash"},{"label":"r-ashr","value":"r-ashr"},{"label":"r-assertthat","value":"r-assertthat"},{"label":"r-automap","value":"r-automap"},{"label":"r-backports","value":"r-backports"},{"label":"r-base","value":"r-base"},{"label":"r-base64","value":"r-base64"},{"label":"r-base64enc","value":"r-base64enc"},{"label":"r-batch","value":"r-batch"},{"label":"r-batchjobs","value":"r-batchjobs"},{"label":"r-bbmisc","value":"r-bbmisc"},{"label":"r-bbmle","value":"r-bbmle"},{"label":"r-bdsmatrix","value":"r-bdsmatrix"},{"label":"r-beanplot","value":"r-beanplot"},{"label":"r-beeswarm","value":"r-beeswarm"},{"label":"r-bestglm","value":"r-bestglm"},{"label":"r-betareg","value":"r-betareg"},{"label":"r-bh","value":"r-bh"},{"label":"r-biasedurn","value":"r-biasedurn"},{"label":"r-bibtex","value":"r-bibtex"},{"label":"r-biganalytics","value":"r-biganalytics"},{"label":"r-biglm","value":"r-biglm"},{"label":"r-bigmemory","value":"r-bigmemory"},{"label":"r-bigmemory.sri","value":"r-bigmemory.sri"},{"label":"r-bindr","value":"r-bindr"},{"label":"r-bindrcpp","value":"r-bindrcpp"},{"label":"r-bit","value":"r-bit"},{"label":"r-bit64","value":"r-bit64"},{"label":"r-bitops","value":"r-bitops"},{"label":"r-blockmodeling","value":"r-blockmodeling"},{"label":"r-bma","value":"r-bma"},{"label":"r-bmp","value":"r-bmp"},{"label":"r-bookdown","value":"r-bookdown"},{"label":"r-boot","value":"r-boot"},{"label":"r-bradleyterry2","value":"r-bradleyterry2"},{"label":"r-brew","value":"r-brew"},{"label":"r-brglm","value":"r-brglm"},{"label":"r-broom","value":"r-broom"},{"label":"r-cairo","value":"r-cairo"},{"label":"r-calibrate","value":"r-calibrate"},{"label":"r-callr","value":"r-callr"},{"label":"r-captioner","value":"r-captioner"},{"label":"r-car","value":"r-car"},{"label":"r-caret","value":"r-caret"},{"label":"r-caroline","value":"r-caroline"},{"label":"r-catools","value":"r-catools"},{"label":"r-cellranger","value":"r-cellranger"},{"label":"r-cghflasso","value":"r-cghflasso"},{"label":"r-changepoint","value":"r-changepoint"},{"label":"r-checkmate","value":"r-checkmate"},{"label":"r-checkpoint","value":"r-checkpoint"},{"label":"r-chron","value":"r-chron"},{"label":"r-circlize","value":"r-circlize"},{"label":"r-circstats","value":"r-circstats"},{"label":"r-class","value":"r-class"},{"label":"r-clue","value":"r-clue"},{"label":"r-cluster","value":"r-cluster"},{"label":"r-coda","value":"r-coda"},{"label":"r-codetools","value":"r-codetools"},{"label":"r-coin","value":"r-coin"},{"label":"r-colorramps","value":"r-colorramps"},{"label":"r-colorspace","value":"r-colorspace"},{"label":"r-combinat","value":"r-combinat"},{"label":"r-commonmark","value":"r-commonmark"},{"label":"r-compquadform","value":"r-compquadform"},{"label":"r-compute.es","value":"r-compute.es"},{"label":"r-config","value":"r-config"},{"label":"r-contrast","value":"r-contrast"},{"label":"r-copula","value":"r-copula"},{"label":"r-corpcor","value":"r-corpcor"},{"label":"r-corrplot","value":"r-corrplot"},{"label":"r-covr","value":"r-covr"},{"label":"r-cowplot","value":"r-cowplot"},{"label":"r-crayon","value":"r-crayon"},{"label":"r-crosstalk","value":"r-crosstalk"},{"label":"r-ctv","value":"r-ctv"},{"label":"r-curl","value":"r-curl"},{"label":"r-cvtools","value":"r-cvtools"},{"label":"r-d3heatmap","value":"r-d3heatmap"},{"label":"r-data.table","value":"r-data.table"},{"label":"r-dbi","value":"r-dbi"},{"label":"r-dbplyr","value":"r-dbplyr"},{"label":"r-ddrtree","value":"r-ddrtree"},{"label":"r-delaporte","value":"r-delaporte"},{"label":"r-deldir","value":"r-deldir"},{"label":"r-dendextend","value":"r-dendextend"},{"label":"r-densityclust","value":"r-densityclust"},{"label":"r-deoptimr","value":"r-deoptimr"},{"label":"r-desc","value":"r-desc"},{"label":"r-devtools","value":"r-devtools"},{"label":"r-diagram","value":"r-diagram"},{"label":"r-diagrammer","value":"r-diagrammer"},{"label":"r-dichromat","value":"r-dichromat"},{"label":"r-digest","value":"r-digest"},{"label":"r-diptest","value":"r-diptest"},{"label":"r-discriminer","value":"r-discriminer"},{"label":"r-distillery","value":"r-distillery"},{"label":"r-docopt","value":"r-docopt"},{"label":"r-domc","value":"r-domc"},{"label":"r-doparallel","value":"r-doparallel"},{"label":"r-dorng","value":"r-dorng"},{"label":"r-dosnow","value":"r-dosnow"},{"label":"r-dotcall64","value":"r-dotcall64"},{"label":"r-downloader","value":"r-downloader"},{"label":"r-dplyr","value":"r-dplyr"},{"label":"r-dt","value":"r-dt"},{"label":"r-dunn.test","value":"r-dunn.test"},{"label":"r-dygraphs","value":"r-dygraphs"},{"label":"r-e1071","value":"r-e1071"},{"label":"r-ecp","value":"r-ecp"},{"label":"r-ellipse","value":"r-ellipse"},{"label":"r-emdbook","value":"r-emdbook"},{"label":"r-envstats","value":"r-envstats"},{"label":"r-essentials","value":"r-essentials"},{"label":"r-estimability","value":"r-estimability"},{"label":"r-etrunct","value":"r-etrunct"},{"label":"r-evaluate","value":"r-evaluate"},{"label":"r-evd","value":"r-evd"},{"label":"r-exactranktests","value":"r-exactranktests"},{"label":"r-expm","value":"r-expm"},{"label":"r-extrafont","value":"r-extrafont"},{"label":"r-extrafontdb","value":"r-extrafontdb"},{"label":"r-factominer","value":"r-factominer"},{"label":"r-fail","value":"r-fail"},{"label":"r-fastcluster","value":"r-fastcluster"},{"label":"r-fastica","value":"r-fastica"},{"label":"r-fastmatch","value":"r-fastmatch"},{"label":"r-fda","value":"r-fda"},{"label":"r-fdrtool","value":"r-fdrtool"},{"label":"r-feather","value":"r-feather"},{"label":"r-feature","value":"r-feature"},{"label":"r-ff","value":"r-ff"},{"label":"r-fftwtools","value":"r-fftwtools"},{"label":"r-fields","value":"r-fields"},{"label":"r-findpython","value":"r-findpython"},{"label":"r-fitdistrplus","value":"r-fitdistrplus"},{"label":"r-flashclust","value":"r-flashclust"},{"label":"r-flexclust","value":"r-flexclust"},{"label":"r-flexmix","value":"r-flexmix"},{"label":"r-flowr","value":"r-flowr"},{"label":"r-flux","value":"r-flux"},{"label":"r-fnn","value":"r-fnn"},{"label":"r-forcats","value":"r-forcats"},{"label":"r-foreach","value":"r-foreach"},{"label":"r-forecast","value":"r-forecast"},{"label":"r-foreign","value":"r-foreign"},{"label":"r-formatr","value":"r-formatr"},{"label":"r-formattable","value":"r-formattable"},{"label":"r-formula","value":"r-formula"},{"label":"r-fpc","value":"r-fpc"},{"label":"r-fracdiff","value":"r-fracdiff"},{"label":"r-fst","value":"r-fst"},{"label":"r-functional","value":"r-functional"},{"label":"r-funr","value":"r-funr"},{"label":"r-futile.logger","value":"r-futile.logger"},{"label":"r-futile.options","value":"r-futile.options"},{"label":"r-future","value":"r-future"},{"label":"r-fwdselect","value":"r-fwdselect"},{"label":"r-gam","value":"r-gam"},{"label":"r-gamlss","value":"r-gamlss"},{"label":"r-gamlss.data","value":"r-gamlss.data"},{"label":"r-gamlss.dist","value":"r-gamlss.dist"},{"label":"r-gbm","value":"r-gbm"},{"label":"r-gdata","value":"r-gdata"},{"label":"r-gdtools","value":"r-gdtools"},{"label":"r-geepack","value":"r-geepack"},{"label":"r-genabel.data","value":"r-genabel.data"},{"label":"r-geomap","value":"r-geomap"},{"label":"r-geosphere","value":"r-geosphere"},{"label":"r-getopt","value":"r-getopt"},{"label":"r-getoptlong","value":"r-getoptlong"},{"label":"r-ggally","value":"r-ggally"},{"label":"r-ggalt","value":"r-ggalt"},{"label":"r-ggbeeswarm","value":"r-ggbeeswarm"},{"label":"r-ggdendro","value":"r-ggdendro"},{"label":"r-ggfortify","value":"r-ggfortify"},{"label":"r-ggmap","value":"r-ggmap"},{"label":"r-ggplot2","value":"r-ggplot2"},{"label":"r-ggrepel","value":"r-ggrepel"},{"label":"r-ggsci","value":"r-ggsci"},{"label":"r-ggthemes","value":"r-ggthemes"},{"label":"r-ggvis","value":"r-ggvis"},{"label":"r-giant","value":"r-giant"},{"label":"r-gistr","value":"r-gistr"},{"label":"r-git2r","value":"r-git2r"},{"label":"r-glmnet","value":"r-glmnet"},{"label":"r-globaloptions","value":"r-globaloptions"},{"label":"r-globals","value":"r-globals"},{"label":"r-glue","value":"r-glue"},{"label":"r-gmd","value":"r-gmd"},{"label":"r-gmodels","value":"r-gmodels"},{"label":"r-gmp","value":"r-gmp"},{"label":"r-goftest","value":"r-goftest"},{"label":"r-googlevis","value":"r-googlevis"},{"label":"r-gplots","value":"r-gplots"},{"label":"r-gprofiler","value":"r-gprofiler"},{"label":"r-gpseq","value":"r-gpseq"},{"label":"r-gridbase","value":"r-gridbase"},{"label":"r-gridextra","value":"r-gridextra"},{"label":"r-gridgraphics","value":"r-gridgraphics"},{"label":"r-grimport","value":"r-grimport"},{"label":"r-grpreg","value":"r-grpreg"},{"label":"r-gsalib","value":"r-gsalib"},{"label":"r-gsl","value":"r-gsl"},{"label":"r-gsmoothr","value":"r-gsmoothr"},{"label":"r-gstat","value":"r-gstat"},{"label":"r-gsubfn","value":"r-gsubfn"},{"label":"r-gsw","value":"r-gsw"},{"label":"r-gtable","value":"r-gtable"},{"label":"r-gtools","value":"r-gtools"},{"label":"r-hash","value":"r-hash"},{"label":"r-haven","value":"r-haven"},{"label":"r-hdrcde","value":"r-hdrcde"},{"label":"r-hexbin","value":"r-hexbin"},{"label":"r-hiddenmarkov","value":"r-hiddenmarkov"},{"label":"r-highcharter","value":"r-highcharter"},{"label":"r-highr","value":"r-highr"},{"label":"r-hive","value":"r-hive"},{"label":"r-hmisc","value":"r-hmisc"},{"label":"r-hms","value":"r-hms"},{"label":"r-hoardr","value":"r-hoardr"},{"label":"r-htmltable","value":"r-htmltable"},{"label":"r-htmltools","value":"r-htmltools"},{"label":"r-htmlwidgets","value":"r-htmlwidgets"},{"label":"r-httpuv","value":"r-httpuv"},{"label":"r-httr","value":"r-httr"},{"label":"r-hunspell","value":"r-hunspell"},{"label":"r-hwriter","value":"r-hwriter"},{"label":"r-idpmisc","value":"r-idpmisc"},{"label":"r-idr","value":"r-idr"},{"label":"r-igraph","value":"r-igraph"},{"label":"r-influencer","value":"r-influencer"},{"label":"r-inline","value":"r-inline"},{"label":"r-inlinedocs","value":"r-inlinedocs"},{"label":"r-intamap","value":"r-intamap"},{"label":"r-intervals","value":"r-intervals"},{"label":"r-irdisplay","value":"r-irdisplay"},{"label":"r-irkernel","value":"r-irkernel"},{"label":"r-irlba","value":"r-irlba"},{"label":"r-iterators","value":"r-iterators"},{"label":"r-itertools","value":"r-itertools"},{"label":"r-janeaustenr","value":"r-janeaustenr"},{"label":"r-jpeg","value":"r-jpeg"},{"label":"r-jsonlite","value":"r-jsonlite"},{"label":"r-kernlab","value":"r-kernlab"},{"label":"r-kernsmooth","value":"r-kernsmooth"},{"label":"r-klar","value":"r-klar"},{"label":"r-km.ci","value":"r-km.ci"},{"label":"r-kmsurv","value":"r-kmsurv"},{"label":"r-knitr","value":"r-knitr"},{"label":"r-knitrbootstrap","value":"r-knitrbootstrap"},{"label":"r-kohonen","value":"r-kohonen"},{"label":"r-kriging","value":"r-kriging"},{"label":"r-ks","value":"r-ks"},{"label":"r-labeling","value":"r-labeling"},{"label":"r-lahman","value":"r-lahman"},{"label":"r-lambda.r","value":"r-lambda.r"},{"label":"r-lars","value":"r-lars"},{"label":"r-lattice","value":"r-lattice"},{"label":"r-latticeextra","value":"r-latticeextra"},{"label":"r-lazyeval","value":"r-lazyeval"},{"label":"r-leaflet","value":"r-leaflet"},{"label":"r-leaps","value":"r-leaps"},{"label":"r-learnbayes","value":"r-learnbayes"},{"label":"r-lintr","value":"r-lintr"},{"label":"r-listenv","value":"r-listenv"},{"label":"r-lme4","value":"r-lme4"},{"label":"r-lmertest","value":"r-lmertest"},{"label":"r-lmtest","value":"r-lmtest"},{"label":"r-locfdr","value":"r-locfdr"},{"label":"r-locfit","value":"r-locfit"},{"label":"r-logging","value":"r-logging"},{"label":"r-lokern","value":"r-lokern"},{"label":"r-longitudinal","value":"r-longitudinal"},{"label":"r-lsd","value":"r-lsd"},{"label":"r-lsmeans","value":"r-lsmeans"},{"label":"r-lubridate","value":"r-lubridate"},{"label":"r-magrittr","value":"r-magrittr"},{"label":"r-manipulate","value":"r-manipulate"},{"label":"r-mapdata","value":"r-mapdata"},{"label":"r-mapproj","value":"r-mapproj"},{"label":"r-maps","value":"r-maps"},{"label":"r-maptools","value":"r-maptools"},{"label":"r-markdown","value":"r-markdown"},{"label":"r-mass","value":"r-mass"},{"label":"r-matlab","value":"r-matlab"},{"label":"r-matrix","value":"r-matrix"},{"label":"r-matrixmodels","value":"r-matrixmodels"},{"label":"r-matrixstats","value":"r-matrixstats"},{"label":"r-maxlik","value":"r-maxlik"},{"label":"r-mba","value":"r-mba"},{"label":"r-mclust","value":"r-mclust"},{"label":"r-mcmc","value":"r-mcmc"},{"label":"r-mcmcpack","value":"r-mcmcpack"},{"label":"r-memoise","value":"r-memoise"},{"label":"r-memuse","value":"r-memuse"},{"label":"r-mgcv","value":"r-mgcv"},{"label":"r-mhsmm","value":"r-mhsmm"},{"label":"r-microbenchmark","value":"r-microbenchmark"},{"label":"r-mime","value":"r-mime"},{"label":"r-miniui","value":"r-miniui"},{"label":"r-minpack.lm","value":"r-minpack.lm"},{"label":"r-minqa","value":"r-minqa"},{"label":"r-misc3d","value":"r-misc3d"},{"label":"r-misctools","value":"r-misctools"},{"label":"r-missforest","value":"r-missforest"},{"label":"r-mitools","value":"r-mitools"},{"label":"r-mixtools","value":"r-mixtools"},{"label":"r-mlmrev","value":"r-mlmrev"},{"label":"r-mnormt","value":"r-mnormt"},{"label":"r-modelmetrics","value":"r-modelmetrics"},{"label":"r-modelr","value":"r-modelr"},{"label":"r-modeltools","value":"r-modeltools"},{"label":"r-moments","value":"r-moments"},{"label":"r-multcomp","value":"r-multcomp"},{"label":"r-multicool","value":"r-multicool"},{"label":"r-multitaper","value":"r-multitaper"},{"label":"r-munsell","value":"r-munsell"},{"label":"r-mvtnorm","value":"r-mvtnorm"},{"label":"r-naturalsort","value":"r-naturalsort"},{"label":"r-ncdf4","value":"r-ncdf4"},{"label":"r-networkd3","value":"r-networkd3"},{"label":"r-nhmmfdr","value":"r-nhmmfdr"},{"label":"r-nleqslv","value":"r-nleqslv"},{"label":"r-nlme","value":"r-nlme"},{"label":"r-nloptr","value":"r-nloptr"},{"label":"r-nlp","value":"r-nlp"},{"label":"r-nmf","value":"r-nmf"},{"label":"r-nnet","value":"r-nnet"},{"label":"r-nor1mix","value":"r-nor1mix"},{"label":"r-nozzle.r1","value":"r-nozzle.r1"},{"label":"r-numderiv","value":"r-numderiv"},{"label":"r-nycflights13","value":"r-nycflights13"},{"label":"r-oce","value":"r-oce"},{"label":"r-openssl","value":"r-openssl"},{"label":"r-openxlsx","value":"r-openxlsx"},{"label":"r-optparse","value":"r-optparse"},{"label":"r-ore","value":"r-ore"},{"label":"r-outliers","value":"r-outliers"},{"label":"r-pack","value":"r-pack"},{"label":"r-packrat","value":"r-packrat"},{"label":"r-params","value":"r-params"},{"label":"r-pbdzmq","value":"r-pbdzmq"},{"label":"r-pbkrtest","value":"r-pbkrtest"},{"label":"r-pcapp","value":"r-pcapp"},{"label":"r-penalized","value":"r-penalized"},{"label":"r-perm","value":"r-perm"},{"label":"r-permute","value":"r-permute"},{"label":"r-pheatmap","value":"r-pheatmap"},{"label":"r-phonr","value":"r-phonr"},{"label":"r-pkgconfig","value":"r-pkgconfig"},{"label":"r-pkgmaker","value":"r-pkgmaker"},{"label":"r-pki","value":"r-pki"},{"label":"r-plm","value":"r-plm"},{"label":"r-plogr","value":"r-plogr"},{"label":"r-plotly","value":"r-plotly"},{"label":"r-plotrix","value":"r-plotrix"},{"label":"r-plumber","value":"r-plumber"},{"label":"r-plyr","value":"r-plyr"},{"label":"r-pmcmr","value":"r-pmcmr"},{"label":"r-png","value":"r-png"},{"label":"r-polspline","value":"r-polspline"},{"label":"r-polyclip","value":"r-polyclip"},{"label":"r-polynom","value":"r-polynom"},{"label":"r-powerlaw","value":"r-powerlaw"},{"label":"r-prabclus","value":"r-prabclus"},{"label":"r-pracma","value":"r-pracma"},{"label":"r-praise","value":"r-praise"},{"label":"r-preseqr","value":"r-preseqr"},{"label":"r-prettyunits","value":"r-prettyunits"},{"label":"r-proc","value":"r-proc"},{"label":"r-profilemodel","value":"r-profilemodel"},{"label":"r-progress","value":"r-progress"},{"label":"r-proj4","value":"r-proj4"},{"label":"r-proto","value":"r-proto"},{"label":"r-proxy","value":"r-proxy"},{"label":"r-prroc","value":"r-prroc"},{"label":"r-pryr","value":"r-pryr"},{"label":"r-pscl","value":"r-pscl"},{"label":"r-pspline","value":"r-pspline"},{"label":"r-psych","value":"r-psych"},{"label":"r-ptw","value":"r-ptw"},{"label":"r-purrr","value":"r-purrr"},{"label":"r-pvclust","value":"r-pvclust"},{"label":"r-qdaptools","value":"r-qdaptools"},{"label":"r-qlcmatrix","value":"r-qlcmatrix"},{"label":"r-quadprog","value":"r-quadprog"},{"label":"r-quantmod","value":"r-quantmod"},{"label":"r-quantreg","value":"r-quantreg"},{"label":"r-r.cache","value":"r-r.cache"},{"label":"r-r.devices","value":"r-r.devices"},{"label":"r-r.filesets","value":"r-r.filesets"},{"label":"r-r.huge","value":"r-r.huge"},{"label":"r-r.methodss3","value":"r-r.methodss3"},{"label":"r-r.oo","value":"r-r.oo"},{"label":"r-r.rsp","value":"r-r.rsp"},{"label":"r-r.utils","value":"r-r.utils"},{"label":"r-r2html","value":"r-r2html"},{"label":"r-r6","value":"r-r6"},{"label":"r-rainbow","value":"r-rainbow"},{"label":"r-randomforest","value":"r-randomforest"},{"label":"r-rann","value":"r-rann"},{"label":"r-rappdirs","value":"r-rappdirs"},{"label":"r-raster","value":"r-raster"},{"label":"r-rbokeh","value":"r-rbokeh"},{"label":"r-rcolorbrewer","value":"r-rcolorbrewer"},{"label":"r-rcpp","value":"r-rcpp"},{"label":"r-rcpparmadillo","value":"r-rcpparmadillo"},{"label":"r-rcppeigen","value":"r-rcppeigen"},{"label":"r-rcppgsl","value":"r-rcppgsl"},{"label":"r-rcppparallel","value":"r-rcppparallel"},{"label":"r-rcpptoml","value":"r-rcpptoml"},{"label":"r-rcurl","value":"r-rcurl"},{"label":"r-readbitmap","value":"r-readbitmap"},{"label":"r-readr","value":"r-readr"},{"label":"r-readxl","value":"r-readxl"},{"label":"r-recommended","value":"r-recommended"},{"label":"r-registry","value":"r-registry"},{"label":"r-relaimpo","value":"r-relaimpo"},{"label":"r-relations","value":"r-relations"},{"label":"r-rematch","value":"r-rematch"},{"label":"r-repr","value":"r-repr"},{"label":"r-rerddap","value":"r-rerddap"},{"label":"r-reshape","value":"r-reshape"},{"label":"r-reshape2","value":"r-reshape2"},{"label":"r-reticulate","value":"r-reticulate"},{"label":"r-rex","value":"r-rex"},{"label":"r-rfoc","value":"r-rfoc"},{"label":"r-rgdal","value":"r-rgdal"},{"label":"r-rgexf","value":"r-rgexf"},{"label":"r-rgl","value":"r-rgl"},{"label":"r-rgooglemaps","value":"r-rgooglemaps"},{"label":"r-rjava","value":"r-rjava"},{"label":"r-rjson","value":"r-rjson"},{"label":"r-rjsonio","value":"r-rjsonio"},{"label":"r-rlang","value":"r-rlang"},{"label":"r-rlist","value":"r-rlist"},{"label":"r-rmarkdown","value":"r-rmarkdown"},{"label":"r-rmr2","value":"r-rmr2"},{"label":"r-rms","value":"r-rms"},{"label":"r-rmysql","value":"r-rmysql"},{"label":"r-rngtools","value":"r-rngtools"},{"label":"r-rnifti","value":"r-rnifti"},{"label":"r-rniftyreg","value":"r-rniftyreg"},{"label":"r-robustbase","value":"r-robustbase"},{"label":"r-rocr","value":"r-rocr"},{"label":"r-rodbc","value":"r-rodbc"},{"label":"r-rook","value":"r-rook"},{"label":"r-roxygen2","value":"r-roxygen2"},{"label":"r-rpart","value":"r-rpart"},{"label":"r-rpmg","value":"r-rpmg"},{"label":"r-rprojroot","value":"r-rprojroot"},{"label":"r-rrcov","value":"r-rrcov"},{"label":"r-rsconnect","value":"r-rsconnect"},{"label":"r-rseis","value":"r-rseis"},{"label":"r-rserve","value":"r-rserve"},{"label":"r-rsm","value":"r-rsm"},{"label":"r-rsolnp","value":"r-rsolnp"},{"label":"r-rsqlite","value":"r-rsqlite"},{"label":"r-rstan","value":"r-rstan"},{"label":"r-rstudioapi","value":"r-rstudioapi"},{"label":"r-rtsne","value":"r-rtsne"},{"label":"r-rttf2pt1","value":"r-rttf2pt1"},{"label":"r-runit","value":"r-runit"},{"label":"r-rversions","value":"r-rversions"},{"label":"r-rvest","value":"r-rvest"},{"label":"r-rwave","value":"r-rwave"},{"label":"r-rzmq","value":"r-rzmq"},{"label":"r-sandwich","value":"r-sandwich"},{"label":"r-scales","value":"r-scales"},{"label":"r-scatterplot3d","value":"r-scatterplot3d"},{"label":"r-sciplot","value":"r-sciplot"},{"label":"r-seacarb","value":"r-seacarb"},{"label":"r-segmented","value":"r-segmented"},{"label":"r-selectr","value":"r-selectr"},{"label":"r-sendmailr","value":"r-sendmailr"},{"label":"r-sets","value":"r-sets"},{"label":"r-sf","value":"r-sf"},{"label":"r-sfsmisc","value":"r-sfsmisc"},{"label":"r-shape","value":"r-shape"},{"label":"r-shiny","value":"r-shiny"},{"label":"r-shinyace","value":"r-shinyace"},{"label":"r-shinybs","value":"r-shinybs"},{"label":"r-shinydashboard","value":"r-shinydashboard"},{"label":"r-shinyjs","value":"r-shinyjs"},{"label":"r-shinysky","value":"r-shinysky"},{"label":"r-shinythemes","value":"r-shinythemes"},{"label":"r-signal","value":"r-signal"},{"label":"r-skellam","value":"r-skellam"},{"label":"r-slam","value":"r-slam"},{"label":"r-snow","value":"r-snow"},{"label":"r-snowballc","value":"r-snowballc"},{"label":"r-snowfall","value":"r-snowfall"},{"label":"r-som","value":"r-som"},{"label":"r-sourcetools","value":"r-sourcetools"},{"label":"r-sp","value":"r-sp"},{"label":"r-spacetime","value":"r-spacetime"},{"label":"r-spam","value":"r-spam"},{"label":"r-sparklyr","value":"r-sparklyr"},{"label":"r-sparql","value":"r-sparql"},{"label":"r-sparsem","value":"r-sparsem"},{"label":"r-spatial","value":"r-spatial"},{"label":"r-spdep","value":"r-spdep"},{"label":"r-speedglm","value":"r-speedglm"},{"label":"r-splancs","value":"r-splancs"},{"label":"r-splitstackshape","value":"r-splitstackshape"},{"label":"r-sqldf","value":"r-sqldf"},{"label":"r-squarem","value":"r-squarem"},{"label":"r-stabledist","value":"r-stabledist"},{"label":"r-stanheaders","value":"r-stanheaders"},{"label":"r-statmod","value":"r-statmod"},{"label":"r-stringdist","value":"r-stringdist"},{"label":"r-stringi","value":"r-stringi"},{"label":"r-stringr","value":"r-stringr"},{"label":"r-strucchange","value":"r-strucchange"},{"label":"r-suppdists","value":"r-suppdists"},{"label":"r-survey","value":"r-survey"},{"label":"r-survival","value":"r-survival"},{"label":"r-svdialogs","value":"r-svdialogs"},{"label":"r-svgui","value":"r-svgui"},{"label":"r-tensor","value":"r-tensor"},{"label":"r-tensorflow","value":"r-tensorflow"},{"label":"r-testit","value":"r-testit"},{"label":"r-testthat","value":"r-testthat"},{"label":"r-th.data","value":"r-th.data"},{"label":"r-threejs","value":"r-threejs"},{"label":"r-tibble","value":"r-tibble"},{"label":"r-tidyr","value":"r-tidyr"},{"label":"r-tidytext","value":"r-tidytext"},{"label":"r-tidyverse","value":"r-tidyverse"},{"label":"r-tiff","value":"r-tiff"},{"label":"r-tilegramsr","value":"r-tilegramsr"},{"label":"r-timedate","value":"r-timedate"},{"label":"r-tm","value":"r-tm"},{"label":"r-tokenizers","value":"r-tokenizers"},{"label":"r-trimcluster","value":"r-trimcluster"},{"label":"r-truncnorm","value":"r-truncnorm"},{"label":"r-tseries","value":"r-tseries"},{"label":"r-tsne","value":"r-tsne"},{"label":"r-ttr","value":"r-ttr"},{"label":"r-udunits2","value":"r-udunits2"},{"label":"r-units","value":"r-units"},{"label":"r-upsetr","value":"r-upsetr"},{"label":"r-urca","value":"r-urca"},{"label":"r-uuid","value":"r-uuid"},{"label":"r-vars","value":"r-vars"},{"label":"r-vegan","value":"r-vegan"},{"label":"r-venn","value":"r-venn"},{"label":"r-venndiagram","value":"r-venndiagram"},{"label":"r-vgam","value":"r-vgam"},{"label":"r-vipor","value":"r-vipor"},{"label":"r-viridis","value":"r-viridis"},{"label":"r-viridislite","value":"r-viridislite"},{"label":"r-visnetwork","value":"r-visnetwork"},{"label":"r-waveslim","value":"r-waveslim"},{"label":"r-wavethresh","value":"r-wavethresh"},{"label":"r-weatherdata","value":"r-weatherdata"},{"label":"r-whisker","value":"r-whisker"},{"label":"r-withr","value":"r-withr"},{"label":"r-wrassp","value":"r-wrassp"},{"label":"r-writexls","value":"r-writexls"},{"label":"r-xlsx","value":"r-xlsx"},{"label":"r-xlsxjars","value":"r-xlsxjars"},{"label":"r-xml","value":"r-xml"},{"label":"r-xml2","value":"r-xml2"},{"label":"r-xtable","value":"r-xtable"},{"label":"r-xtractomatic","value":"r-xtractomatic"},{"label":"r-xts","value":"r-xts"},{"label":"r-yaml","value":"r-yaml"},{"label":"r-zoo","value":"r-zoo"}]}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = {"packages":[{"label":"Apache Toree","value":"Apache Toree"},{"label":"spylon-kernel","value":"spylon-kernel"}]}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/docker-stacker",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/docker-stacker"+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.2c39a435.js